export const espngames26 = [
    {
        "id": 401856766,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-08-29T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": true,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3504,
        "venue": "Aviva Stadium",
        "homeId": 2628,
        "homeTeam": "TCU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 10,
        "homeLineScores": [
            10,
            0,
            0,
            0
        ],
        "homePostgameWinProbability": 0.5609505772590637,
        "homePregameElo": 1613,
        "homePostgameElo": 1595,
        "awayId": 153,
        "awayTeam": "North Carolina",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 15,
        "awayLineScores": [
            10,
            2,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.4390494227409363,
        "awayPregameElo": 1380,
        "awayPostgameElo": 1398,
        "excitementIndex": 6.501938416580931,
        "highlights": "",
        "notes": "Aer Lingus College Football Classic",
        "playoff": null
    },
    {
        "id": 401864494,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-08-29T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 477,
        "venue": "Los Angeles Memorial Coliseum",
        "homeId": 30,
        "homeTeam": "USC",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 42,
        "homeLineScores": [
            7,
            21,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9964043498039246,
        "homePregameElo": 1747,
        "homePostgameElo": 1752,
        "awayId": 23,
        "awayTeam": "San José State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 26,
        "awayLineScores": [
            0,
            0,
            3,
            23
        ],
        "awayPostgameWinProbability": 0.0035956501960754395,
        "awayPregameElo": 1411,
        "awayPostgameElo": 1406,
        "excitementIndex": 2.1247838400218297,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858202,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-08-29T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3923,
        "venue": "Scott Stadium",
        "homeId": 258,
        "homeTeam": "Virginia",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 34,
        "homeLineScores": [
            10,
            7,
            7,
            10
        ],
        "homePostgameWinProbability": 0.9934231638908386,
        "homePregameElo": 1591,
        "homePostgameElo": 1655,
        "awayId": 152,
        "awayTeam": "NC State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 8,
        "awayLineScores": [
            0,
            0,
            8,
            0
        ],
        "awayPostgameWinProbability": 0.006576836109161377,
        "awayPregameElo": 1570,
        "awayPostgameElo": 1506,
        "excitementIndex": 2.3644462220310416,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864577,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-08-29T21:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3714,
        "venue": "Fargodome",
        "homeId": 2449,
        "homeTeam": "North Dakota State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 33,
        "homeLineScores": [
            7,
            10,
            10,
            6
        ],
        "homePostgameWinProbability": 0.9063087105751038,
        "homePregameElo": 1500,
        "homePostgameElo": 1566,
        "awayId": 55,
        "awayTeam": "Jacksonville State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.09369128942489624,
        "awayPregameElo": 1494,
        "awayPostgameElo": 1428,
        "excitementIndex": 3.0503311314063795,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866408,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-08-29T22:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3912,
        "venue": "Rynearson Stadium",
        "homeId": 2199,
        "homeTeam": "Eastern Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 28,
        "homeLineScores": [
            0,
            21,
            0,
            7
        ],
        "homePostgameWinProbability": 0.9009293913841248,
        "homePregameElo": 1326,
        "homePostgameElo": 1360,
        "awayId": 16,
        "awayTeam": "Sacramento State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 17,
        "awayLineScores": [
            0,
            10,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.09907060861587524,
        "awayPregameElo": 1500,
        "awayPostgameElo": 1466,
        "excitementIndex": 3.5970782042129867,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858201,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-08-29T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3940,
        "venue": "Stanford Stadium",
        "homeId": 24,
        "homeTeam": "Stanford",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 37,
        "homeLineScores": [
            7,
            7,
            9,
            14
        ],
        "homePostgameWinProbability": 0.9951261878013611,
        "homePregameElo": 1390,
        "homePostgameElo": 1413,
        "awayId": 62,
        "awayTeam": "Hawai'i",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 27,
        "awayLineScores": [
            0,
            7,
            0,
            20
        ],
        "awayPostgameWinProbability": 0.004873812198638916,
        "awayPregameElo": 1472,
        "awayPostgameElo": 1449,
        "excitementIndex": 5.770253187027743,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864570,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-08-29T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3697,
        "venue": "Doak Campbell Stadium",
        "homeId": 52,
        "homeTeam": "Florida State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 34,
        "homeLineScores": [
            3,
            14,
            7,
            10
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1537,
        "homePostgameElo": 1551,
        "awayId": 166,
        "awayTeam": "New Mexico State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 17,
        "awayLineScores": [
            0,
            7,
            3,
            7
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1281,
        "awayPostgameElo": 1267,
        "excitementIndex": 3.6506915398564455,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862693,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-08-30T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 6501,
        "venue": "Allegiant Stadium",
        "homeId": 2439,
        "homeTeam": "UNLV",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 21,
        "homeLineScores": [
            0,
            14,
            7,
            0
        ],
        "homePostgameWinProbability": 0.04621971398591995,
        "homePregameElo": 1581,
        "homePostgameElo": 1566,
        "awayId": 235,
        "awayTeam": "Memphis",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 27,
        "awayLineScores": [
            0,
            7,
            17,
            3
        ],
        "awayPostgameWinProbability": 0.95378028601408,
        "awayPregameElo": 1526,
        "awayPostgameElo": 1541,
        "excitementIndex": 6.40825618898589,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858423,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-03T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 6577,
        "venue": "SHI Stadium",
        "homeId": 164,
        "homeTeam": "Rutgers",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 21,
        "homeLineScores": [
            7,
            0,
            0,
            14
        ],
        "homePostgameWinProbability": 0.0026932330802083015,
        "homePregameElo": 1479,
        "homePostgameElo": 1381,
        "awayId": 113,
        "awayTeam": "Massachusetts",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 37,
        "awayLineScores": [
            7,
            17,
            3,
            10
        ],
        "awayPostgameWinProbability": 0.9973067669197917,
        "awayPregameElo": 978,
        "awayPostgameElo": 1076,
        "excitementIndex": 3.19174551401912,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864425,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4899,
        "venue": "Fifth Third Stadium",
        "homeId": 338,
        "homeTeam": "Kennesaw State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 47,
        "homeLineScores": [
            19,
            21,
            7,
            0
        ],
        "homePostgameWinProbability": 0.9909650087356567,
        "homePregameElo": 1373,
        "homePostgameElo": 1373,
        "awayId": 2698,
        "awayTeam": "West Georgia",
        "awayClassification": "fcs",
        "awayConference": "UAC",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.009034991264343262,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.229737075700872,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864424,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3695,
        "venue": "Delaware Stadium",
        "homeId": 48,
        "homeTeam": "Delaware",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 42,
        "homeLineScores": [
            7,
            14,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9847715497016907,
        "homePregameElo": 1404,
        "homePostgameElo": 1404,
        "awayId": 2771,
        "awayTeam": "Merrimack",
        "awayClassification": "fcs",
        "awayConference": "FCS Independents",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.015228450298309326,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.641449382089869,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856767,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3652,
        "venue": "FBC Mortgage Stadium",
        "homeId": 2116,
        "homeTeam": "UCF",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 73,
        "homeLineScores": [
            21,
            17,
            28,
            7
        ],
        "homePostgameWinProbability": 0.9843000769615173,
        "homePregameElo": 1465,
        "homePostgameElo": 1465,
        "awayId": 2065,
        "awayTeam": "Bethune-Cookman",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 6,
        "awayLineScores": [
            0,
            0,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.015699923038482666,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.897970373376696,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866409,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3965,
        "venue": "UB Stadium",
        "homeId": 2084,
        "homeTeam": "Buffalo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 21,
        "homeLineScores": [
            0,
            14,
            0,
            7
        ],
        "homePostgameWinProbability": 0.9391478896141052,
        "homePregameElo": 1365,
        "homePostgameElo": 1365,
        "awayId": 399,
        "awayTeam": "UAlbany",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 17,
        "awayLineScores": [
            7,
            3,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.060852110385894775,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 6.902093440356493,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858204,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3630,
        "venue": "Allegacy Federal Credit Union Stadium",
        "homeId": 154,
        "homeTeam": "Wake Forest",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 38,
        "homeLineScores": [
            10,
            18,
            3,
            7
        ],
        "homePostgameWinProbability": 0.9861863851547241,
        "homePregameElo": 1520,
        "homePostgameElo": 1516,
        "awayId": 2006,
        "awayTeam": "Akron",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 16,
        "awayLineScores": [
            0,
            3,
            0,
            13
        ],
        "awayPostgameWinProbability": 0.013813614845275879,
        "awayPregameElo": 925,
        "awayPostgameElo": 929,
        "excitementIndex": 2.6068707243929237,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856776,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-04T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 721,
        "venue": "Bobby Dodd Stadium",
        "homeId": 59,
        "homeTeam": "Georgia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 13,
        "homeLineScores": [
            0,
            10,
            0,
            3
        ],
        "homePostgameWinProbability": 0.46688950061798096,
        "homePregameElo": 1563,
        "homePostgameElo": 1553,
        "awayId": 38,
        "awayTeam": "Colorado",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.533110499382019,
        "awayPregameElo": 1396,
        "awayPostgameElo": 1406,
        "excitementIndex": 6.240260056598781,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858422,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-04T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3953,
        "venue": "Huntington Bank Stadium",
        "homeId": 135,
        "homeTeam": "Minnesota",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 59,
        "homeLineScores": [
            14,
            21,
            10,
            14
        ],
        "homePostgameWinProbability": 0.9948015213012695,
        "homePregameElo": 1510,
        "homePostgameElo": 1510,
        "awayId": 2197,
        "awayTeam": "Eastern Illinois",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.005198478698730469,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.14001327981458,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856663,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-04T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3838,
        "venue": "Memorial Stadium",
        "homeId": 142,
        "homeTeam": "Missouri",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 54,
        "homeLineScores": [
            14,
            26,
            0,
            14
        ],
        "homePostgameWinProbability": 0.9942298531532288,
        "homePregameElo": 1666,
        "homePostgameElo": 1666,
        "awayId": 2029,
        "awayTeam": "Arkansas-Pine Bluff",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            0,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.00577014684677124,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.395718076222952,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858424,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-04T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3832,
        "venue": "Memorial Stadium (Champaign, IL)",
        "homeId": 356,
        "homeTeam": "Illinois",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 42,
        "homeLineScores": [
            14,
            7,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9480764269828796,
        "homePregameElo": 1563,
        "homePostgameElo": 1595,
        "awayId": 5,
        "awayTeam": "UAB",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 23,
        "awayLineScores": [
            3,
            10,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.05192357301712036,
        "awayPregameElo": 1443,
        "awayPostgameElo": 1411,
        "excitementIndex": 3.799962230181375,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856768,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-04T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 587,
        "venue": "Rice-Eccles Stadium",
        "homeId": 254,
        "homeTeam": "Utah",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 66,
        "homeLineScores": [
            17,
            14,
            14,
            21
        ],
        "homePostgameWinProbability": 0.9970967173576355,
        "homePregameElo": 1817,
        "homePostgameElo": 1817,
        "awayId": 70,
        "awayTeam": "Idaho",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.002903282642364502,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.11235780713634,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864495,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-04T22:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3912,
        "venue": "Rynearson Stadium",
        "homeId": 2199,
        "homeTeam": "Eastern Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 21,
        "homeLineScores": [
            0,
            7,
            14,
            0
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1360,
        "homePostgameElo": 1353,
        "awayId": 23,
        "awayTeam": "San José State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 27,
        "awayLineScores": [
            0,
            10,
            7,
            10
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1406,
        "awayPostgameElo": 1413,
        "excitementIndex": 5.895337083138708,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858435,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-04T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3907,
        "venue": "Ross-Ade Stadium",
        "homeId": 2509,
        "homeTeam": "Purdue",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 44,
        "homeLineScores": [
            10,
            6,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9921911954879761,
        "homePregameElo": 1318,
        "homePostgameElo": 1318,
        "awayId": 282,
        "awayTeam": "Indiana State",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 19,
        "awayLineScores": [
            3,
            3,
            0,
            13
        ],
        "awayPostgameWinProbability": 0.007808804512023926,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.442458035830671,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866623,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-04T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4246,
        "venue": "Center Parc Stadium",
        "homeId": 2247,
        "homeTeam": "Georgia State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 59,
        "homeLineScores": [
            14,
            21,
            24,
            0
        ],
        "homePostgameWinProbability": 0.9921911954879761,
        "homePregameElo": 1241,
        "homePostgameElo": 1241,
        "awayId": 2448,
        "awayTeam": "North Carolina A&T",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            7,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.007808804512023926,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.2067711849236753,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858429,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3936,
        "venue": "Spartan Stadium",
        "homeId": 127,
        "homeTeam": "Michigan State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 30,
        "homeLineScores": [
            10,
            9,
            0,
            11
        ],
        "homePostgameWinProbability": 0.7865183353424072,
        "homePregameElo": 1439,
        "homePostgameElo": 1468,
        "awayId": 2649,
        "awayTeam": "Toledo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 20,
        "awayLineScores": [
            0,
            7,
            7,
            6
        ],
        "awayPostgameWinProbability": 0.21348166465759277,
        "awayPregameElo": 1597,
        "awayPostgameElo": 1568,
        "excitementIndex": 3.933766595911785,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856769,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3833,
        "venue": "Memorial Stadium",
        "homeId": 2305,
        "homeTeam": "Kansas",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 51,
        "homeLineScores": [
            6,
            24,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9919133186340332,
        "homePregameElo": 1510,
        "homePostgameElo": 1510,
        "awayId": 2341,
        "awayTeam": "Long Island University",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 6,
        "awayLineScores": [
            0,
            0,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.008086681365966797,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.712433637537601,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856664,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3835,
        "venue": "Memorial Stadium (Norman, OK)",
        "homeId": 201,
        "homeTeam": "Oklahoma",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 51,
        "homeLineScores": [
            21,
            6,
            17,
            7
        ],
        "homePostgameWinProbability": 0.9970476031303406,
        "homePregameElo": 1706,
        "homePostgameElo": 1799,
        "awayId": 2638,
        "awayTeam": "UTEP",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.002952396869659424,
        "awayPregameElo": 1256,
        "awayPostgameElo": 1163,
        "excitementIndex": 1.6622847209305427,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858436,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 477,
        "venue": "Los Angeles Memorial Coliseum",
        "homeId": 30,
        "homeTeam": "USC",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 39,
        "homeLineScores": [
            7,
            23,
            2,
            7
        ],
        "homePostgameWinProbability": 0.9353188276290894,
        "homePregameElo": 1752,
        "homePostgameElo": 1835,
        "awayId": 278,
        "awayTeam": "Fresno State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.06468117237091064,
        "awayPregameElo": 1532,
        "awayPostgameElo": 1449,
        "excitementIndex": 2.768518413523263,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858206,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3940,
        "venue": "Stanford Stadium",
        "homeId": 24,
        "homeTeam": "Stanford",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 6,
        "homeLineScores": [
            3,
            3,
            0,
            0
        ],
        "homePostgameWinProbability": 0.018528111279010773,
        "homePregameElo": 1413,
        "homePostgameElo": 1354,
        "awayId": 2390,
        "awayTeam": "Miami",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 45,
        "awayLineScores": [
            14,
            14,
            14,
            3
        ],
        "awayPostgameWinProbability": 0.9814718887209892,
        "awayPregameElo": 1842,
        "awayPostgameElo": 1901,
        "excitementIndex": 3.861456675658052,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856634,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3657,
        "venue": "Bryant-Denny Stadium",
        "homeId": 333,
        "homeTeam": "Alabama",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 48,
        "homeLineScores": [
            10,
            28,
            0,
            10
        ],
        "homePostgameWinProbability": 0.9966325163841248,
        "homePregameElo": 1738,
        "homePostgameElo": 1823,
        "awayId": 151,
        "awayTeam": "East Carolina",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            7,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.003367483615875244,
        "awayPregameElo": 1562,
        "awayPostgameElo": 1477,
        "excitementIndex": 2.413542657655659,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401861962,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3892,
        "venue": "Pratt & Whitney Stadium",
        "homeId": 41,
        "homeTeam": "UConn",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": 56,
        "homeLineScores": [
            21,
            14,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9930822253227234,
        "homePregameElo": 1484,
        "homePostgameElo": 1484,
        "awayId": 322,
        "awayTeam": "Lafayette",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.006917774677276611,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.1293066509575125,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856778,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4728,
        "venue": "TDECU Stadium",
        "homeId": 248,
        "homeTeam": "Houston",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 33,
        "homeLineScores": [
            9,
            10,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9747902750968933,
        "homePregameElo": 1508,
        "homePostgameElo": 1514,
        "awayId": 204,
        "awayTeam": "Oregon State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            0,
            6,
            7
        ],
        "awayPostgameWinProbability": 0.02520972490310669,
        "awayPregameElo": 1266,
        "awayPostgameElo": 1260,
        "excitementIndex": 4.451653122690978,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869960,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3651,
        "venue": "Bridgeforth Stadium",
        "homeId": 256,
        "homeTeam": "James Madison",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 20,
        "homeLineScores": [
            7,
            10,
            3,
            0
        ],
        "homePostgameWinProbability": 0.9636929631233215,
        "homePregameElo": 1770,
        "homePostgameElo": 1776,
        "awayId": 2335,
        "awayTeam": "Liberty",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            6,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.03630703687667847,
        "awayPregameElo": 1703,
        "awayPostgameElo": 1697,
        "excitementIndex": 2.938805175877657,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866410,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3700,
        "venue": "Doyt L. Perry Stadium",
        "homeId": 189,
        "homeTeam": "Bowling Green",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 13,
        "homeLineScores": [
            0,
            7,
            3,
            3
        ],
        "homePostgameWinProbability": 0.47325095534324646,
        "homePregameElo": 1340,
        "homePostgameElo": 1340,
        "awayId": 2627,
        "awayTeam": "Tarleton State",
        "awayClassification": "fcs",
        "awayConference": "UAC",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            10,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.5267490446567535,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 4.2530976755708005,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858425,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3830,
        "venue": "Memorial Stadium (Bloomington, IN)",
        "homeId": 84,
        "homeTeam": "Indiana",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 52,
        "homeLineScores": [
            14,
            10,
            7,
            21
        ],
        "homePostgameWinProbability": 0.9949389696121216,
        "homePregameElo": 2064,
        "homePostgameElo": 2113,
        "awayId": 249,
        "awayTeam": "North Texas",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 16,
        "awayLineScores": [
            0,
            6,
            10,
            0
        ],
        "awayPostgameWinProbability": 0.005061030387878418,
        "awayPregameElo": 1639,
        "awayPostgameElo": 1590,
        "excitementIndex": 2.2743649912659762,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858430,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3834,
        "venue": "Memorial Stadium (Lincoln, NE)",
        "homeId": 158,
        "homeTeam": "Nebraska",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 49,
        "homeLineScores": [
            7,
            7,
            14,
            21
        ],
        "homePostgameWinProbability": 0.993261456489563,
        "homePregameElo": 1538,
        "homePostgameElo": 1592,
        "awayId": 195,
        "awayTeam": "Ohio",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 21,
        "awayLineScores": [
            10,
            3,
            0,
            8
        ],
        "awayPostgameWinProbability": 0.006738543510437012,
        "awayPregameElo": 1372,
        "awayPostgameElo": 1318,
        "excitementIndex": 4.959056683394593,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862701,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3841,
        "venue": "Michie Stadium",
        "homeId": 349,
        "homeTeam": "Army",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 59,
        "homeLineScores": [
            21,
            10,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9969590902328491,
        "homePregameElo": 1527,
        "homePostgameElo": 1527,
        "awayId": 2803,
        "awayTeam": "Bryant",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.003040909767150879,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.9076028235625277,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856780,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3842,
        "venue": "Milan Puskar Stadium",
        "homeId": 277,
        "homeTeam": "West Virginia",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 31,
        "homeLineScores": [
            14,
            10,
            0,
            7
        ],
        "homePostgameWinProbability": 0.8937140703201294,
        "homePregameElo": 1360,
        "homePostgameElo": 1365,
        "awayId": 324,
        "awayTeam": "Coastal Carolina",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 24,
        "awayLineScores": [
            0,
            0,
            7,
            17
        ],
        "awayPostgameWinProbability": 0.1062859296798706,
        "awayPregameElo": 1275,
        "awayPostgameElo": 1270,
        "excitementIndex": 2.918222613424516,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858208,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 1964,
        "venue": "JMA Wireless Dome",
        "homeId": 183,
        "homeTeam": "Syracuse",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 66,
        "homeLineScores": [
            14,
            27,
            2,
            23
        ],
        "homePostgameWinProbability": 0.9922709465026855,
        "homePregameElo": 1288,
        "homePostgameElo": 1288,
        "awayId": 160,
        "awayTeam": "New Hampshire",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            0,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.007729053497314453,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.1397786797517004,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858432,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3861,
        "venue": "Ohio Stadium",
        "homeId": 194,
        "homeTeam": "Ohio State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 56,
        "homeLineScores": [
            14,
            14,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9805747270584106,
        "homePregameElo": 1925,
        "homePostgameElo": 1986,
        "awayId": 2050,
        "awayTeam": "Ball State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.019425272941589355,
        "awayPregameElo": 1173,
        "awayPostgameElo": 1112,
        "excitementIndex": 2.0816947559603913,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858207,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3752,
        "venue": "Acrisure Stadium",
        "homeId": 221,
        "homeTeam": "Pittsburgh",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 59,
        "homeLineScores": [
            21,
            10,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9727570414543152,
        "homePregameElo": 1576,
        "homePostgameElo": 1681,
        "awayId": 193,
        "awayTeam": "Miami (OH)",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            14,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.027242958545684814,
        "awayPregameElo": 1364,
        "awayPostgameElo": 1259,
        "excitementIndex": 2.4978793686470273,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856665,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T16:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3994,
        "venue": "Williams-Brice Stadium",
        "homeId": 2579,
        "homeTeam": "South Carolina",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 57,
        "homeLineScores": [
            7,
            22,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9963384866714478,
        "homePregameElo": 1631,
        "homePostgameElo": 1742,
        "awayId": 2309,
        "awayTeam": "Kent State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.003661513328552246,
        "awayPregameElo": 1167,
        "awayPostgameElo": 1056,
        "excitementIndex": 1.927710383165817,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856659,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3683,
        "venue": "Kroger Field",
        "homeId": 96,
        "homeTeam": "Kentucky",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 45,
        "homeLineScores": [
            14,
            14,
            7,
            10
        ],
        "homePostgameWinProbability": 0.9882584810256958,
        "homePregameElo": 1476,
        "homePostgameElo": 1476,
        "awayId": 2754,
        "awayTeam": "Youngstown State",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            7,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.0117415189743042,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.7714212792584294,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856779,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3772,
        "venue": "Jack Trice Stadium",
        "homeId": 66,
        "homeTeam": "Iowa State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 38,
        "homeLineScores": [
            14,
            14,
            3,
            7
        ],
        "homePostgameWinProbability": 0.9895552396774292,
        "homePregameElo": 1586,
        "homePostgameElo": 1586,
        "awayId": 2546,
        "awayTeam": "Southeast Missouri State",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            7,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.0104447603225708,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.775955154249339,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864496,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3713,
        "venue": "Falcon Stadium",
        "homeId": 2005,
        "homeTeam": "Air Force",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 34,
        "homeLineScores": [
            7,
            13,
            7,
            7
        ],
        "homePostgameWinProbability": 0.992472767829895,
        "homePregameElo": 1424,
        "homePostgameElo": 1424,
        "awayId": 2184,
        "awayTeam": "Duquesne",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0075272321701049805,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.8531627866369802,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862698,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3806,
        "venue": "Lincoln Financial Field",
        "homeId": 218,
        "homeTeam": "Temple",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 38,
        "homeLineScores": [
            10,
            14,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9994505643844604,
        "homePregameElo": 1312,
        "homePostgameElo": 1312,
        "awayId": 227,
        "awayTeam": "Rhode Island",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0005494356155395508,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.427826148039743,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856658,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3917,
        "venue": "Sanford Stadium",
        "homeId": 61,
        "homeTeam": "Georgia",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 63,
        "homeLineScores": [
            28,
            7,
            14,
            14
        ],
        "homePostgameWinProbability": 0.987844705581665,
        "homePregameElo": 1871,
        "homePostgameElo": 1871,
        "awayId": 2634,
        "awayTeam": "Tennessee State",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.012155294418334961,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.8624348875527263,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862696,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3852,
        "venue": "Navy-Marine Corps Memorial Stadium",
        "homeId": 2426,
        "homeTeam": "Navy",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 42,
        "homeLineScores": [
            14,
            14,
            7,
            7
        ],
        "homePostgameWinProbability": 0.976482093334198,
        "homePregameElo": 1550,
        "homePostgameElo": 1550,
        "awayId": 119,
        "awayTeam": "Towson",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 15,
        "awayLineScores": [
            0,
            12,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.023517906665802002,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.276233467141967,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862700,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3604,
        "venue": "Alamodome",
        "homeId": 2636,
        "homeTeam": "UTSA",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 45,
        "homeLineScores": [
            7,
            24,
            0,
            14
        ],
        "homePostgameWinProbability": 0.977594256401062,
        "homePregameElo": 1522,
        "homePostgameElo": 1522,
        "awayId": 292,
        "awayTeam": "UT Rio Grande Valley",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 16,
        "awayLineScores": [
            0,
            6,
            0,
            10
        ],
        "awayPostgameWinProbability": 0.02240574359893799,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.762885935131833,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858433,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3626,
        "venue": "Autzen Stadium",
        "homeId": 2483,
        "homeTeam": "Oregon",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 34,
        "homeLineScores": [
            0,
            14,
            10,
            10
        ],
        "homePostgameWinProbability": 0.936040997505188,
        "homePregameElo": 1880,
        "homePostgameElo": 1873,
        "awayId": 68,
        "awayTeam": "Boise State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 27,
        "awayLineScores": [
            7,
            10,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.06395900249481201,
        "awayPregameElo": 1562,
        "awayPostgameElo": 1569,
        "excitementIndex": 6.800212461567343,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862694,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4418,
        "venue": "Jerry Richardson Stadium",
        "homeId": 2429,
        "homeTeam": "Charlotte",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 41,
        "homeLineScores": [
            7,
            7,
            7,
            7,
            13
        ],
        "homePostgameWinProbability": 0.07293246686458588,
        "homePregameElo": 1182,
        "homePostgameElo": 1182,
        "awayId": 2643,
        "awayTeam": "The Citadel",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": 43,
        "awayLineScores": [
            7,
            0,
            14,
            7,
            15
        ],
        "awayPostgameWinProbability": 0.9270675331354141,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 9.442475061652209,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856777,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3854,
        "venue": "Nippert Stadium",
        "homeId": 2132,
        "homeTeam": "Cincinnati",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 34,
        "homeLineScores": [
            3,
            7,
            14,
            10
        ],
        "homePostgameWinProbability": 0.9926350712776184,
        "homePregameElo": 1480,
        "homePostgameElo": 1516,
        "awayId": 103,
        "awayTeam": "Boston College",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 15,
        "awayLineScores": [
            0,
            0,
            8,
            7
        ],
        "awayPostgameWinProbability": 0.007364928722381592,
        "awayPregameElo": 1406,
        "awayPostgameElo": 1370,
        "excitementIndex": 3.7856761933742193,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864499,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3714,
        "venue": "Fargodome",
        "homeId": 2449,
        "homeTeam": "North Dakota State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 38,
        "homeLineScores": [
            3,
            14,
            21,
            0
        ],
        "homePostgameWinProbability": 0.9916819930076599,
        "homePregameElo": 1562,
        "homePostgameElo": 1562,
        "awayId": 2230,
        "awayTeam": "Fordham",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.008318006992340088,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.332098818300068,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856667,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3910,
        "venue": "DKR-Texas Memorial Stadium",
        "homeId": 251,
        "homeTeam": "Texas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 59,
        "homeLineScores": [
            14,
            14,
            21,
            10
        ],
        "homePostgameWinProbability": 0.9363611340522766,
        "homePregameElo": 1784,
        "homePostgameElo": 1913,
        "awayId": 326,
        "awayTeam": "Texas State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.06363886594772339,
        "awayPregameElo": 1570,
        "awayPostgameElo": 1441,
        "excitementIndex": 2.4768900387323205,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866627,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3792,
        "venue": "Kidd Brewer Stadium",
        "homeId": 2026,
        "homeTeam": "App State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 55,
        "homeLineScores": [
            7,
            24,
            7,
            17
        ],
        "homePostgameWinProbability": 0.992509663105011,
        "homePregameElo": 1310,
        "homePostgameElo": 1310,
        "awayId": 311,
        "awayTeam": "Maine",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            0,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.007490336894989014,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.1860471472481593,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856636,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": true,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 5348,
        "venue": "Mercedes-Benz Stadium",
        "homeId": 2,
        "homeTeam": "Auburn",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 17,
        "homeLineScores": [
            3,
            7,
            0,
            7
        ],
        "homePostgameWinProbability": 0.3212757408618927,
        "homePregameElo": 1613,
        "homePostgameElo": 1613,
        "awayId": 239,
        "awayTeam": "Baylor",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 16,
        "awayLineScores": [
            0,
            7,
            0,
            9
        ],
        "awayPostgameWinProbability": 0.6787242591381073,
        "awayPregameElo": 1506,
        "awayPostgameElo": 1506,
        "excitementIndex": 7.276093790199145,
        "highlights": "",
        "notes": "Aflac Kickoff",
        "playoff": null
    },
    {
        "id": 401858209,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3982,
        "venue": "Wallace Wade Stadium",
        "homeId": 150,
        "homeTeam": "Duke",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 17,
        "homeLineScores": [
            7,
            3,
            0,
            7
        ],
        "homePostgameWinProbability": 0.9367347955703735,
        "homePregameElo": 1581,
        "homePostgameElo": 1607,
        "awayId": 2655,
        "awayTeam": "Tulane",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            0,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.06326520442962646,
        "awayPregameElo": 1555,
        "awayPostgameElo": 1529,
        "excitementIndex": 3.3994336317500204,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856666,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3853,
        "venue": "Neyland Stadium",
        "homeId": 2633,
        "homeTeam": "Tennessee",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 56,
        "homeLineScores": [
            7,
            21,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9925051331520081,
        "homePregameElo": 1691,
        "homePostgameElo": 1691,
        "awayId": 231,
        "awayTeam": "Furman",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": 9,
        "awayLineScores": [
            0,
            0,
            3,
            6
        ],
        "awayPostgameWinProbability": 0.007494866847991943,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.5481180554485405,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858434,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3632,
        "venue": "Beaver Stadium",
        "homeId": 213,
        "homeTeam": "Penn State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 45,
        "homeLineScores": [
            17,
            7,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9949479103088379,
        "homePregameElo": 1802,
        "homePostgameElo": 1891,
        "awayId": 276,
        "awayTeam": "Marshall",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.005052089691162109,
        "awayPregameElo": 1478,
        "awayPostgameElo": 1389,
        "excitementIndex": 2.069694438371381,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856772,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T19:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3674,
        "venue": "Chapman Stadium",
        "homeId": 202,
        "homeTeam": "Tulsa",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 24,
        "homeLineScores": [
            3,
            7,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9988501071929932,
        "homePregameElo": 1240,
        "homePostgameElo": 1268,
        "awayId": 197,
        "awayTeam": "Oklahoma State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            3,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.001149892807006836,
        "awayPregameElo": 1240,
        "awayPostgameElo": 1212,
        "excitementIndex": 3.4798394312225565,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856635,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3887,
        "venue": "Razorback Stadium",
        "homeId": 8,
        "homeTeam": "Arkansas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 31,
        "homeLineScores": [
            7,
            7,
            7,
            10
        ],
        "homePostgameWinProbability": 0.9978387951850891,
        "homePregameElo": 1547,
        "homePostgameElo": 1547,
        "awayId": 2453,
        "awayTeam": "North Alabama",
        "awayClassification": "fcs",
        "awayConference": "UAC",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            0,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.0021612048149108887,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.2596139293232698,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858426,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3793,
        "venue": "Kinnick Stadium",
        "homeId": 2294,
        "homeTeam": "Iowa",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 40,
        "homeLineScores": [
            20,
            13,
            7,
            0
        ],
        "homePostgameWinProbability": 0.9894656538963318,
        "homePregameElo": 1791,
        "homePostgameElo": 1847,
        "awayId": 2459,
        "awayTeam": "Northern Illinois",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.010534346103668213,
        "awayPregameElo": 1322,
        "awayPostgameElo": 1266,
        "excitementIndex": 2.056095441182341,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868356,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3815,
        "venue": "M. M. Roberts Stadium",
        "homeId": 2572,
        "homeTeam": "Southern Miss",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 49,
        "homeLineScores": [
            7,
            14,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9972705841064453,
        "homePregameElo": 1350,
        "homePostgameElo": 1350,
        "awayId": 2016,
        "awayTeam": "Alcorn State",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 3,
        "awayLineScores": [
            3,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0027294158935546875,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.906769279204327,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860878,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 5388,
        "venue": "Canvas Stadium",
        "homeId": 36,
        "homeTeam": "Colorado State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 35,
        "homeLineScores": [
            7,
            7,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9878835082054138,
        "homePregameElo": 1273,
        "homePostgameElo": 1336,
        "awayId": 2751,
        "awayTeam": "Wyoming",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 13,
        "awayLineScores": [
            3,
            3,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.012116491794586182,
        "awayPregameElo": 1363,
        "awayPostgameElo": 1300,
        "excitementIndex": 3.447543350267783,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401867973,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3918,
        "venue": "S.B. Ballard Stadium",
        "homeId": 295,
        "homeTeam": "Old Dominion",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 31,
        "homeLineScores": [
            7,
            10,
            14,
            0
        ],
        "homePostgameWinProbability": 0.8599848747253418,
        "homePregameElo": 1336,
        "homePostgameElo": 1336,
        "awayId": 2450,
        "awayTeam": "Norfolk State",
        "awayClassification": "fcs",
        "awayConference": "MEAC",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            7,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.1400151252746582,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.936906991354552,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870763,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3975,
        "venue": "Veterans Memorial Stadium (AL)",
        "homeId": 2653,
        "homeTeam": "Troy",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 24,
        "homeLineScores": [
            7,
            7,
            3,
            7
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1422,
        "homePostgameElo": 1420,
        "awayId": 2534,
        "awayTeam": "Sam Houston",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 21,
        "awayLineScores": [
            7,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1162,
        "awayPostgameElo": 1164,
        "excitementIndex": 5.8888493281709735,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856668,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3795,
        "venue": "Kyle Field",
        "homeId": 245,
        "homeTeam": "Texas A&M",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 50,
        "homeLineScores": [
            9,
            10,
            14,
            17
        ],
        "homePostgameWinProbability": 0.9935471415519714,
        "homePregameElo": 1748,
        "homePostgameElo": 1849,
        "awayId": 2623,
        "awayTeam": "Missouri State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0064528584480285645,
        "awayPregameElo": 1385,
        "awayPostgameElo": 1284,
        "excitementIndex": 1.97195805997534,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862695,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3805,
        "venue": "Simmons Bank Liberty Stadium",
        "homeId": 235,
        "homeTeam": "Memphis",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 42,
        "homeLineScores": [
            0,
            21,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9897596836090088,
        "homePregameElo": 1541,
        "homePostgameElo": 1566,
        "awayId": 2032,
        "awayTeam": "Arkansas State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 24,
        "awayLineScores": [
            3,
            14,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.010240316390991211,
        "awayPregameElo": 1378,
        "awayPostgameElo": 1353,
        "excitementIndex": 5.053423669218713,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401867866,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3725,
        "venue": "Johnny \"Red\" Floyd Stadium",
        "homeId": 2393,
        "homeTeam": "Middle Tennessee",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 38,
        "homeLineScores": [
            14,
            7,
            3,
            14
        ],
        "homePostgameWinProbability": 0.9877748489379883,
        "homePregameElo": 1276,
        "homePostgameElo": 1276,
        "awayId": 93,
        "awayTeam": "Murray State",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.012225151062011719,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.523397804082168,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862699,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3886,
        "venue": "Raymond James Stadium",
        "homeId": 58,
        "homeTeam": "South Florida",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 19,
        "homeLineScores": [
            3,
            3,
            0,
            13
        ],
        "homePostgameWinProbability": 0.9994904398918152,
        "homePregameElo": 1682,
        "homePostgameElo": 1679,
        "awayId": 2229,
        "awayTeam": "Florida International",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 9,
        "awayLineScores": [
            0,
            0,
            3,
            6
        ],
        "awayPostgameWinProbability": 0.0005095601081848145,
        "awayPregameElo": 1382,
        "awayPostgameElo": 1385,
        "excitementIndex": 4.8355795003531155,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862697,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3895,
        "venue": "Rice Stadium",
        "homeId": 242,
        "homeTeam": "Rice",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 31,
        "homeLineScores": [
            7,
            10,
            0,
            14
        ],
        "homePostgameWinProbability": 0.9941425919532776,
        "homePregameElo": 1196,
        "homePostgameElo": 1196,
        "awayId": 2277,
        "awayTeam": "Houston Christian",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 3,
        "awayLineScores": [
            3,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.005857408046722412,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.594905350092231,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868316,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 6526,
        "venue": "Hancock Whitney Stadium",
        "homeId": 6,
        "homeTeam": "South Alabama",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 39,
        "homeLineScores": [
            19,
            3,
            10,
            7
        ],
        "homePostgameWinProbability": 0.9733971357345581,
        "homePregameElo": 1390,
        "homePostgameElo": 1390,
        "awayId": 2545,
        "awayTeam": "SE Louisiana",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.026602864265441895,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.5044065669121878,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860880,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3905,
        "venue": "Maverik Stadium",
        "homeId": 328,
        "homeTeam": "Utah State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 17,
        "homeLineScores": [
            7,
            3,
            7,
            0
        ],
        "homePostgameWinProbability": 0.25037574768066406,
        "homePregameElo": 1376,
        "homePostgameElo": 1376,
        "awayId": 304,
        "awayTeam": "Idaho State",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 29,
        "awayLineScores": [
            6,
            10,
            3,
            10
        ],
        "awayPostgameWinProbability": 0.7496242523193359,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 6.264019457225063,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868140,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3662,
        "venue": "AmFirst Stadium",
        "homeId": 55,
        "homeTeam": "Jacksonville State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 49,
        "homeLineScores": [
            14,
            21,
            7,
            7
        ],
        "homePostgameWinProbability": 0.990320086479187,
        "homePregameElo": 1432,
        "homePostgameElo": 1432,
        "awayId": 2198,
        "awayTeam": "Eastern Kentucky",
        "awayClassification": "fcs",
        "awayConference": "UAC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.009679913520812988,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.415696723581675,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868170,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3608,
        "venue": "Allen E. Paulson Stadium",
        "homeId": 290,
        "homeTeam": "Georgia Southern",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 31,
        "homeLineScores": [
            21,
            3,
            7,
            0
        ],
        "homePostgameWinProbability": 0.9878964424133301,
        "homePregameElo": 1376,
        "homePostgameElo": 1376,
        "awayId": 2127,
        "awayTeam": "Charleston Southern",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.012103557586669922,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.8280426311254057,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856669,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3973,
        "venue": "FirstBank Stadium",
        "homeId": 238,
        "homeTeam": "Vanderbilt",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 28,
        "homeLineScores": [
            5,
            10,
            6,
            7
        ],
        "homePostgameWinProbability": 0.9735190868377686,
        "homePregameElo": 1753,
        "homePostgameElo": 1753,
        "awayId": 2046,
        "awayTeam": "Austin Peay",
        "awayClassification": "fcs",
        "awayConference": "UAC",
        "awayPoints": 9,
        "awayLineScores": [
            6,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.026480913162231445,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.1370849878505407,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856770,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3784,
        "venue": "Jones AT&T Stadium",
        "homeId": 2641,
        "homeTeam": "Texas Tech",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 33,
        "homeLineScores": [
            14,
            3,
            9,
            7
        ],
        "homePostgameWinProbability": 0.9908412098884583,
        "homePregameElo": 1870,
        "homePostgameElo": 1870,
        "awayId": 2000,
        "awayTeam": "Abilene Christian",
        "awayClassification": "fcs",
        "awayConference": "UAC",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            3,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.009158790111541748,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.270616940713421,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856771,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3636,
        "venue": "Bill Snyder Family Stadium",
        "homeId": 2306,
        "homeTeam": "Kansas State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 71,
        "homeLineScores": [
            22,
            14,
            21,
            14
        ],
        "homePostgameWinProbability": 0.99085533618927,
        "homePregameElo": 1616,
        "homePostgameElo": 1616,
        "awayId": 2447,
        "awayTeam": "Nicholls",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.00914466381072998,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.860002838700055,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858211,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3799,
        "venue": "Lane Stadium",
        "homeId": 259,
        "homeTeam": "Virginia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 73,
        "homeLineScores": [
            21,
            24,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9959549903869629,
        "homePregameElo": 1421,
        "homePostgameElo": 1421,
        "awayId": 2678,
        "awayTeam": "VMI",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            0,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.004045009613037109,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.6187263304956838,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856662,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3693,
        "venue": "Davis Wade Stadium",
        "homeId": 344,
        "homeTeam": "Mississippi State",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 62,
        "homeLineScores": [
            21,
            20,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9833825826644897,
        "homePregameElo": 1478,
        "homePostgameElo": 1584,
        "awayId": 2433,
        "awayTeam": "UL Monroe",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            3,
            10,
            0
        ],
        "awayPostgameWinProbability": 0.016617417335510254,
        "awayPregameElo": 1177,
        "awayPostgameElo": 1071,
        "excitementIndex": 2.163199868290036,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869129,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3776,
        "venue": "Joe Aillet Stadium",
        "homeId": 2348,
        "homeTeam": "Louisiana Tech",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 80,
        "homeLineScores": [
            21,
            42,
            14,
            3
        ],
        "homePostgameWinProbability": 0.9989631772041321,
        "homePregameElo": 1454,
        "homePostgameElo": 1454,
        "awayId": 2466,
        "awayTeam": "Northwestern State",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 6,
        "awayLineScores": [
            3,
            0,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.00103682279586792,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.285266420139923,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858428,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3558,
        "venue": "Michigan Stadium",
        "homeId": 130,
        "homeTeam": "Michigan",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 13,
        "homeLineScores": [
            7,
            0,
            0,
            6
        ],
        "homePostgameWinProbability": 0.5044036507606506,
        "homePregameElo": 1690,
        "homePostgameElo": 1686,
        "awayId": 2711,
        "awayTeam": "Western Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 12,
        "awayLineScores": [
            3,
            3,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.49559634923934937,
        "awayPregameElo": 1530,
        "awayPostgameElo": 1534,
        "excitementIndex": 5.085374646276987,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856660,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3958,
        "venue": "Tiger Stadium (LA)",
        "homeId": 99,
        "homeTeam": "LSU",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 51,
        "homeLineScores": [
            17,
            14,
            13,
            7
        ],
        "homePostgameWinProbability": 0.988840639591217,
        "homePregameElo": 1616,
        "homePostgameElo": 1745,
        "awayId": 228,
        "awayTeam": "Clemson",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.011159360408782959,
        "awayPregameElo": 1670,
        "awayPostgameElo": 1541,
        "excitementIndex": 2.4920462615485617,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856637,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-05T23:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3634,
        "venue": "Ben Hill Griffin Stadium",
        "homeId": 57,
        "homeTeam": "Florida",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 66,
        "homeLineScores": [
            17,
            21,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9905579090118408,
        "homePregameElo": 1562,
        "homePostgameElo": 1658,
        "awayId": 2226,
        "awayTeam": "Florida Atlantic",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            14,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.00944209098815918,
        "awayPregameElo": 1285,
        "awayPostgameElo": 1189,
        "excitementIndex": 2.9309560668065715,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858427,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3665,
        "venue": "SECU Stadium",
        "homeId": 120,
        "homeTeam": "Maryland",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 62,
        "homeLineScores": [
            17,
            17,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9812546968460083,
        "homePregameElo": 1424,
        "homePostgameElo": 1424,
        "awayId": 2261,
        "awayTeam": "Hampton",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0187453031539917,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.0262132883316366,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858431,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 5960,
        "venue": "Lanny and Sharon Martin Stadium",
        "homeId": 77,
        "homeTeam": "Northwestern",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 34,
        "homeLineScores": [
            7,
            3,
            7,
            17
        ],
        "homePostgameWinProbability": 0.9755688905715942,
        "homePregameElo": 1549,
        "homePostgameElo": 1549,
        "awayId": 2571,
        "awayTeam": "South Dakota State",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 18,
        "awayLineScores": [
            0,
            6,
            6,
            6
        ],
        "awayPostgameWinProbability": 0.02443110942840576,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 4.929680461851733,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869142,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3666,
        "venue": "Cajun Field",
        "homeId": 309,
        "homeTeam": "Louisiana",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 38,
        "homeLineScores": [
            7,
            21,
            7,
            3
        ],
        "homePostgameWinProbability": 0.9931040406227112,
        "homePregameElo": 1389,
        "homePostgameElo": 1389,
        "awayId": 2320,
        "awayTeam": "Lamar",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.006895959377288818,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.254952524080834,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856775,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3801,
        "venue": "LaVell Edwards Stadium",
        "homeId": 252,
        "homeTeam": "BYU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 63,
        "homeLineScores": [
            14,
            28,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9927279949188232,
        "homePregameElo": 1666,
        "homePostgameElo": 1666,
        "awayId": 3101,
        "awayTeam": "Utah Tech",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.007272005081176758,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.693029251257934,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870790,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3601,
        "venue": "Aggie Memorial Stadium",
        "homeId": 166,
        "homeTeam": "New Mexico State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 51,
        "homeLineScores": [
            13,
            10,
            7,
            21
        ],
        "homePostgameWinProbability": 0.9876314401626587,
        "homePregameElo": 1259,
        "homePostgameElo": 1259,
        "awayId": 2385,
        "awayTeam": "Mercyhurst",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.012368559837341309,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 5.633043387226727,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860879,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T01:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 7311,
        "venue": "Snapdragon Stadium",
        "homeId": 21,
        "homeTeam": "San Diego State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 53,
        "homeLineScores": [
            7,
            22,
            14,
            10
        ],
        "homePostgameWinProbability": 0.9686100482940674,
        "homePregameElo": 1518,
        "homePostgameElo": 1518,
        "awayId": 2502,
        "awayTeam": "Portland State",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 20,
        "awayLineScores": [
            6,
            0,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.03138995170593262,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.4302171098744187,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856773,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T01:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3619,
        "venue": "Arizona Stadium",
        "homeId": 12,
        "homeTeam": "Arizona",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 35,
        "homeLineScores": [
            7,
            14,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9888352155685425,
        "homePregameElo": 1625,
        "homePostgameElo": 1625,
        "awayId": 2464,
        "awayTeam": "Northern Arizona",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.01116478443145752,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.0200470826040386,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864498,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3971,
        "venue": "University Stadium (NM)",
        "homeId": 167,
        "homeTeam": "New Mexico",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 38,
        "homeLineScores": [
            7,
            13,
            15,
            3
        ],
        "homePostgameWinProbability": 0.9932624697685242,
        "homePregameElo": 1496,
        "homePostgameElo": 1558,
        "awayId": 2117,
        "awayTeam": "Central Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.00673753023147583,
        "awayPregameElo": 1321,
        "awayPostgameElo": 1259,
        "excitementIndex": 1.6516373272600842,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856774,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3947,
        "venue": "Mountain America Stadium",
        "homeId": 9,
        "homeTeam": "Arizona State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 70,
        "homeLineScores": [
            28,
            21,
            21,
            0
        ],
        "homePostgameWinProbability": 0.9897788166999817,
        "homePregameElo": 1572,
        "homePostgameElo": 1572,
        "awayId": 2415,
        "awayTeam": "Morgan State",
        "awayClassification": "fcs",
        "awayConference": "MEAC",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.01022118330001831,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.1291923925930254,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866411,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3757,
        "venue": "Hornet Stadium",
        "homeId": 16,
        "homeTeam": "Sacramento State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 52,
        "homeLineScores": [
            14,
            17,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9875482320785522,
        "homePregameElo": 1476,
        "homePostgameElo": 1476,
        "awayId": 2400,
        "awayTeam": "Mississippi Valley State",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.012451767921447754,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.039980215956526,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864497,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7220,
        "venue": "Clarence T.C. Ching Athletics Complex",
        "homeId": 62,
        "homeTeam": "Hawai'i",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 6,
        "homeLineScores": [
            0,
            3,
            3,
            0
        ],
        "homePostgameWinProbability": 0.03882439061999321,
        "homePregameElo": 1449,
        "homePostgameElo": 1426,
        "awayId": 2439,
        "awayTeam": "UNLV",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 21,
        "awayLineScores": [
            7,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.9611756093800068,
        "awayPregameElo": 1566,
        "awayPostgameElo": 1589,
        "excitementIndex": 4.135331155799781,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858210,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3831,
        "venue": "California Memorial Stadium",
        "homeId": 25,
        "homeTeam": "California",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 24,
        "homeLineScores": [
            7,
            10,
            7,
            0
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1406,
        "homePostgameElo": 1349,
        "awayId": 26,
        "awayTeam": "UCLA",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 45,
        "awayLineScores": [
            7,
            17,
            0,
            21
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1381,
        "awayPostgameElo": 1438,
        "excitementIndex": 7.116397431805615,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864432,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3816,
        "venue": "Mackay Stadium",
        "homeId": 2440,
        "homeTeam": "Nevada",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 49,
        "homeLineScores": [
            14,
            7,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9910643100738525,
        "homePregameElo": 1351,
        "homePostgameElo": 1462,
        "awayId": 98,
        "awayTeam": "Western Kentucky",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.008935689926147461,
        "awayPregameElo": 1438,
        "awayPostgameElo": 1327,
        "excitementIndex": 2.6540355849259845,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858437,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3765,
        "venue": "Husky Stadium",
        "homeId": 264,
        "homeTeam": "Washington",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 24,
        "homeLineScores": [
            3,
            7,
            0,
            14
        ],
        "homePostgameWinProbability": 0.9796331524848938,
        "homePregameElo": 1744,
        "homePostgameElo": 1762,
        "awayId": 265,
        "awayTeam": "Washington State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            0,
            0,
            10
        ],
        "awayPostgameWinProbability": 0.0203668475151062,
        "awayPregameElo": 1619,
        "awayPostgameElo": 1601,
        "excitementIndex": 3.4272122553332083,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856661,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": true,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3810,
        "venue": "Nissan Stadium",
        "homeId": 145,
        "homeTeam": "Ole Miss",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 41,
        "homeLineScores": [
            0,
            10,
            14,
            17
        ],
        "homePostgameWinProbability": 0.6583908200263977,
        "homePregameElo": 1839,
        "homePostgameElo": 1837,
        "awayId": 97,
        "awayTeam": "Louisville",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 38,
        "awayLineScores": [
            3,
            3,
            18,
            14
        ],
        "awayPostgameWinProbability": 0.3416091799736023,
        "awayPregameElo": 1666,
        "awayPostgameElo": 1668,
        "excitementIndex": 7.825231475951447,
        "highlights": "",
        "notes": "Liberty Mutual Music City Kickoff",
        "playoff": null
    },
    {
        "id": 401858438,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-06T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": true,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3798,
        "venue": "Lambeau Field",
        "homeId": 87,
        "homeTeam": "Notre Dame",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": 41,
        "homeLineScores": [
            10,
            3,
            14,
            14
        ],
        "homePostgameWinProbability": 0.911626398563385,
        "homePregameElo": 1995,
        "homePostgameElo": 2021,
        "awayId": 275,
        "awayTeam": "Wisconsin",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 13,
        "awayLineScores": [
            3,
            7,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.08837360143661499,
        "awayPregameElo": 1501,
        "awayPostgameElo": 1475,
        "excitementIndex": 4.713404453161819,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858212,
        "season": 2026,
        "week": 1,
        "seasonType": "regular",
        "startDate": "2026-09-07T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3697,
        "venue": "Doak Campbell Stadium",
        "homeId": 52,
        "homeTeam": "Florida State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 24,
        "homeLineScores": [
            7,
            3,
            7,
            7
        ],
        "homePostgameWinProbability": 0.03824145346879959,
        "homePregameElo": 1551,
        "homePostgameElo": 1557,
        "awayId": 2567,
        "awayTeam": "SMU",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 27,
        "awayLineScores": [
            7,
            10,
            0,
            10
        ],
        "awayPostgameWinProbability": 0.9617585465312004,
        "awayPregameElo": 1734,
        "awayPostgameElo": 1728,
        "excitementIndex": 6.434540721332048,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858213,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-11T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3948,
        "venue": "Hard Rock Stadium",
        "homeId": 2390,
        "homeTeam": "Miami",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 77,
        "homeLineScores": [
            21,
            28,
            28,
            0
        ],
        "homePostgameWinProbability": 0.9930822253227234,
        "homePregameElo": 1930,
        "homePostgameElo": 1930,
        "awayId": 50,
        "awayTeam": "Florida A&M",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.006917774677276611,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.8345705305786555,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858222,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-11T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3670,
        "venue": "Carter-Finley Stadium",
        "homeId": 152,
        "homeTeam": "NC State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 73,
        "homeLineScores": [
            21,
            28,
            14,
            10
        ],
        "homePostgameWinProbability": 0.9935848712921143,
        "homePregameElo": 1509,
        "homePostgameElo": 1509,
        "awayId": 257,
        "awayTeam": "Richmond",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.006415128707885742,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.9801876241116372,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858220,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-11T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3923,
        "venue": "Scott Stadium",
        "homeId": 258,
        "homeTeam": "Virginia",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 59,
        "homeLineScores": [
            21,
            7,
            14,
            17
        ],
        "homePostgameWinProbability": 0.9930822253227234,
        "homePregameElo": 1652,
        "homePostgameElo": 1652,
        "awayId": 2450,
        "awayTeam": "Norfolk State",
        "awayClassification": "fcs",
        "awayConference": "MEAC",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.006917774677276611,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.138828100677014,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858215,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-11T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3873,
        "venue": "L&N Federal Credit Union Stadium",
        "homeId": 97,
        "homeTeam": "Louisville",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 59,
        "homeLineScores": [
            17,
            14,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9942125678062439,
        "homePregameElo": 1668,
        "homePostgameElo": 1668,
        "awayId": 222,
        "awayTeam": "Villanova",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 13,
        "awayLineScores": [
            3,
            7,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.0057874321937561035,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.4404798318841623,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858214,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-11T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3615,
        "venue": "Alumni Stadium (Chestnut Hill, MA)",
        "homeId": 103,
        "homeTeam": "Boston College",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 28,
        "homeLineScores": [
            14,
            6,
            0,
            8
        ],
        "homePostgameWinProbability": 0.39106959104537964,
        "homePregameElo": 1370,
        "homePostgameElo": 1380,
        "awayId": 164,
        "awayTeam": "Rutgers",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            7,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.6089304089546204,
        "awayPregameElo": 1381,
        "awayPostgameElo": 1371,
        "excitementIndex": 3.8629434228559565,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856678,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3833,
        "venue": "Memorial Stadium",
        "homeId": 2305,
        "homeTeam": "Kansas",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 21,
        "homeLineScores": [
            0,
            14,
            7,
            0
        ],
        "homePostgameWinProbability": 0.00580001762136817,
        "homePregameElo": 1510,
        "homePostgameElo": 1485,
        "awayId": 142,
        "awayTeam": "Missouri",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 38,
        "awayLineScores": [
            0,
            14,
            14,
            10
        ],
        "awayPostgameWinProbability": 0.9941999823786318,
        "awayPregameElo": 1666,
        "awayPostgameElo": 1691,
        "excitementIndex": 6.683010293890897,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862702,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3841,
        "venue": "Michie Stadium",
        "homeId": 349,
        "homeTeam": "Army",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 24,
        "homeLineScores": [
            0,
            14,
            0,
            10
        ],
        "homePostgameWinProbability": 0.3616083562374115,
        "homePregameElo": 1527,
        "homePostgameElo": 1530,
        "awayId": 58,
        "awayTeam": "South Florida",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 28,
        "awayLineScores": [
            7,
            0,
            7,
            14
        ],
        "awayPostgameWinProbability": 0.6383916437625885,
        "awayPregameElo": 1679,
        "awayPostgameElo": 1676,
        "excitementIndex": 5.644033764124048,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856683,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3795,
        "venue": "Kyle Field",
        "homeId": 245,
        "homeTeam": "Texas A&M",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 48,
        "homeLineScores": [
            7,
            10,
            7,
            24
        ],
        "homePostgameWinProbability": 0.9799808263778687,
        "homePregameElo": 1849,
        "homePostgameElo": 1890,
        "awayId": 9,
        "awayTeam": "Arizona State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            3,
            10,
            0
        ],
        "awayPostgameWinProbability": 0.020019173622131348,
        "awayPregameElo": 1572,
        "awayPostgameElo": 1531,
        "excitementIndex": 4.058681717255771,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401867929,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3651,
        "venue": "Bridgeforth Stadium",
        "homeId": 256,
        "homeTeam": "James Madison",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 87,
        "homeLineScores": [
            21,
            21,
            24,
            21
        ],
        "homePostgameWinProbability": 0.9958890080451965,
        "homePregameElo": 1776,
        "homePostgameElo": 1776,
        "awayId": 2681,
        "awayTeam": "Wagner",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 3,
        "awayLineScores": [
            3,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.004110991954803467,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.521116012299708,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858218,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3787,
        "venue": "Kenan Stadium",
        "homeId": 153,
        "homeTeam": "North Carolina",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 35,
        "homeLineScores": [
            7,
            14,
            14,
            0
        ],
        "homePostgameWinProbability": 0.9849953055381775,
        "homePregameElo": 1395,
        "homePostgameElo": 1395,
        "awayId": 2193,
        "awayTeam": "East Tennessee State",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            0,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.01500469446182251,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.8097981493180526,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856781,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3636,
        "venue": "Bill Snyder Family Stadium",
        "homeId": 2306,
        "homeTeam": "Kansas State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 34,
        "homeLineScores": [
            3,
            14,
            10,
            7
        ],
        "homePostgameWinProbability": 0.9975051283836365,
        "homePregameElo": 1616,
        "homePostgameElo": 1684,
        "awayId": 265,
        "awayTeam": "Washington State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0024948716163635254,
        "awayPregameElo": 1601,
        "awayPostgameElo": 1533,
        "excitementIndex": 2.7120452347612307,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856782,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3646,
        "venue": "Boone Pickens Stadium",
        "homeId": 197,
        "homeTeam": "Oklahoma State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 39,
        "homeLineScores": [
            3,
            21,
            6,
            9
        ],
        "homePostgameWinProbability": 0.6795249581336975,
        "homePregameElo": 1212,
        "homePostgameElo": 1274,
        "awayId": 2483,
        "awayTeam": "Oregon",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 31,
        "awayLineScores": [
            7,
            10,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.3204750418663025,
        "awayPregameElo": 1873,
        "awayPostgameElo": 1811,
        "excitementIndex": 5.848195968458265,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858224,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3907,
        "venue": "Ross-Ade Stadium",
        "homeId": 2509,
        "homeTeam": "Purdue",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 36,
        "homeLineScores": [
            7,
            3,
            3,
            10,
            13
        ],
        "homePostgameWinProbability": 0.5124849081039429,
        "homePregameElo": 1318,
        "homePostgameElo": 1326,
        "awayId": 154,
        "awayTeam": "Wake Forest",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            10,
            3,
            3,
            15
        ],
        "awayPostgameWinProbability": 0.48751509189605713,
        "awayPregameElo": 1516,
        "awayPostgameElo": 1508,
        "excitementIndex": 10.15891091707647,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858442,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3806,
        "venue": "Lincoln Financial Field",
        "homeId": 218,
        "homeTeam": "Temple",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 9,
        "homeLineScores": [
            0,
            3,
            0,
            6
        ],
        "homePostgameWinProbability": 0.027871139347553253,
        "homePregameElo": 1312,
        "homePostgameElo": 1323,
        "awayId": 213,
        "awayTeam": "Penn State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 27,
        "awayLineScores": [
            0,
            10,
            10,
            7
        ],
        "awayPostgameWinProbability": 0.9721288606524467,
        "awayPregameElo": 1891,
        "awayPostgameElo": 1880,
        "excitementIndex": 3.5985873235133377,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866416,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3696,
        "venue": "Dix Stadium",
        "homeId": 2309,
        "homeTeam": "Kent State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 36,
        "homeLineScores": [
            7,
            7,
            0,
            22
        ],
        "homePostgameWinProbability": 0.9619717597961426,
        "homePregameElo": 1035,
        "homePostgameElo": 1035,
        "awayId": 2747,
        "awayTeam": "Wofford",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": 15,
        "awayLineScores": [
            3,
            12,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.03802824020385742,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 4.618649026122627,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856679,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3558,
        "venue": "Michigan Stadium",
        "homeId": 130,
        "homeTeam": "Michigan",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 17,
        "homeLineScores": [
            7,
            3,
            0,
            7
        ],
        "homePostgameWinProbability": 0.886965274810791,
        "homePregameElo": 1686,
        "homePostgameElo": 1702,
        "awayId": 201,
        "awayTeam": "Oklahoma",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            0,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.11303472518920898,
        "awayPregameElo": 1799,
        "awayPostgameElo": 1783,
        "excitementIndex": 4.412815749915213,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858439,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3830,
        "venue": "Memorial Stadium (Bloomington, IN)",
        "homeId": 84,
        "homeTeam": "Indiana",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 55,
        "homeLineScores": [
            20,
            21,
            14,
            0
        ],
        "homePostgameWinProbability": 0.9941574335098267,
        "homePregameElo": 2132,
        "homePostgameElo": 2132,
        "awayId": 47,
        "awayTeam": "Howard",
        "awayClassification": "fcs",
        "awayConference": "MEAC",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.00584256649017334,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.6708804528668852,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864571,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3699,
        "venue": "Dowdy-Ficklen Stadium",
        "homeId": 151,
        "homeTeam": "East Carolina",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 24,
        "homeLineScores": [
            7,
            3,
            7,
            7
        ],
        "homePostgameWinProbability": 0.28081414103507996,
        "homePregameElo": 1477,
        "homePostgameElo": 1462,
        "awayId": 2026,
        "awayTeam": "App State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 27,
        "awayLineScores": [
            3,
            14,
            10,
            0
        ],
        "awayPostgameWinProbability": 0.71918585896492,
        "awayPregameElo": 1310,
        "awayPostgameElo": 1325,
        "excitementIndex": 5.840694871750819,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868187,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3992,
        "venue": "Williams Stadium (VA)",
        "homeId": 2335,
        "homeTeam": "Liberty",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 24,
        "homeLineScores": [
            14,
            3,
            0,
            7
        ],
        "homePostgameWinProbability": 0.8924932479858398,
        "homePregameElo": 1697,
        "homePostgameElo": 1697,
        "awayId": 2241,
        "awayTeam": "Gardner-Webb",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 23,
        "awayLineScores": [
            6,
            14,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.10750675201416016,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 5.981791198506766,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858221,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3799,
        "venue": "Lane Stadium",
        "homeId": 259,
        "homeTeam": "Virginia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 44,
        "homeLineScores": [
            17,
            17,
            3,
            7
        ],
        "homePostgameWinProbability": 0.9789135456085205,
        "homePregameElo": 1421,
        "homePostgameElo": 1468,
        "awayId": 295,
        "awayTeam": "Old Dominion",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 21,
        "awayLineScores": [
            3,
            3,
            7,
            8
        ],
        "awayPostgameWinProbability": 0.021086454391479492,
        "awayPregameElo": 1336,
        "awayPostgameElo": 1289,
        "excitementIndex": 2.5798047775213986,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856673,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T16:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3917,
        "venue": "Sanford Stadium",
        "homeId": 61,
        "homeTeam": "Georgia",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 70,
        "homeLineScores": [
            21,
            28,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9499468803405762,
        "homePregameElo": 1871,
        "homePostgameElo": 1948,
        "awayId": 98,
        "awayTeam": "Western Kentucky",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 20,
        "awayLineScores": [
            0,
            6,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.05005311965942383,
        "awayPregameElo": 1327,
        "awayPostgameElo": 1250,
        "excitementIndex": 2.0673143380751107,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866417,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3996,
        "venue": "Yager Stadium",
        "homeId": 193,
        "homeTeam": "Miami (OH)",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 45,
        "homeLineScores": [
            14,
            28,
            3,
            0
        ],
        "homePostgameWinProbability": 0.9932807683944702,
        "homePregameElo": 1252,
        "homePostgameElo": 1252,
        "awayId": 107,
        "awayTeam": "Holy Cross",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.006719231605529785,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.6097025491435413,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866415,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3786,
        "venue": "Kelly/Shorts Stadium",
        "homeId": 2117,
        "homeTeam": "Central Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 13,
        "homeLineScores": [
            0,
            0,
            6,
            7
        ],
        "homePostgameWinProbability": 0.9310958981513977,
        "homePregameElo": 1253,
        "homePostgameElo": 1253,
        "awayId": 2142,
        "awayTeam": "Colgate",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            10,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0689041018486023,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 4.595530284820957,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856791,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3842,
        "venue": "Milan Puskar Stadium",
        "homeId": 277,
        "homeTeam": "West Virginia",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 52,
        "homeLineScores": [
            21,
            7,
            17,
            7
        ],
        "homePostgameWinProbability": 0.9900001287460327,
        "homePregameElo": 1365,
        "homePostgameElo": 1365,
        "awayId": 2630,
        "awayTeam": "UT Martin",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.009999871253967285,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.208256557952954,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866413,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3919,
        "venue": "Scheumann Stadium",
        "homeId": 2050,
        "homeTeam": "Ball State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 41,
        "homeLineScores": [
            7,
            14,
            0,
            20
        ],
        "homePostgameWinProbability": 0.9929779171943665,
        "homePregameElo": 1076,
        "homePostgameElo": 1076,
        "awayId": 2619,
        "awayTeam": "Stony Brook",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 17,
        "awayLineScores": [
            0,
            3,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.007022082805633545,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.9274254084526574,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866419,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3739,
        "venue": "Glass Bowl",
        "homeId": 2649,
        "homeTeam": "Toledo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 63,
        "homeLineScores": [
            14,
            21,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9916463494300842,
        "homePregameElo": 1576,
        "homePostgameElo": 1576,
        "awayId": 2115,
        "awayTeam": "Central Connecticut",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.008353650569915771,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.2197421570118423,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856810,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3801,
        "venue": "LaVell Edwards Stadium",
        "homeId": 252,
        "homeTeam": "BYU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 28,
        "homeLineScores": [
            7,
            7,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9806126356124878,
        "homePregameElo": 1666,
        "homePostgameElo": 1683,
        "awayId": 12,
        "awayTeam": "Arizona",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 17,
        "awayLineScores": [
            10,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.019387364387512207,
        "awayPregameElo": 1625,
        "awayPostgameElo": 1608,
        "excitementIndex": 5.22890503880269,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858440,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3936,
        "venue": "Spartan Stadium",
        "homeId": 127,
        "homeTeam": "Michigan State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 35,
        "homeLineScores": [
            7,
            7,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9901273250579834,
        "homePregameElo": 1468,
        "homePostgameElo": 1528,
        "awayId": 2199,
        "awayTeam": "Eastern Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.009872674942016602,
        "awayPregameElo": 1353,
        "awayPostgameElo": 1293,
        "excitementIndex": 2.694647689046348,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858446,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3765,
        "venue": "Husky Stadium",
        "homeId": 264,
        "homeTeam": "Washington",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 16,
        "homeLineScores": [
            0,
            10,
            0,
            6
        ],
        "homePostgameWinProbability": 0.857559323310852,
        "homePregameElo": 1762,
        "homePostgameElo": 1757,
        "awayId": 328,
        "awayTeam": "Utah State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.14244067668914795,
        "awayPregameElo": 1376,
        "awayPostgameElo": 1381,
        "excitementIndex": 7.0473552315932055,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866412,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3768,
        "venue": "InfoCision Stadium",
        "homeId": 2006,
        "homeTeam": "Akron",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 45,
        "homeLineScores": [
            7,
            14,
            10,
            14
        ],
        "homePostgameWinProbability": 0.9734373688697815,
        "homePregameElo": 905,
        "homePostgameElo": 905,
        "awayId": 2523,
        "awayTeam": "Robert Morris",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            10,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.026562631130218506,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.9058535163628694,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858217,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3832,
        "venue": "Memorial Stadium (Champaign, IL)",
        "homeId": 356,
        "homeTeam": "Illinois",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 27,
        "homeLineScores": [
            10,
            14,
            3,
            0
        ],
        "homePostgameWinProbability": 0.017757385969161987,
        "homePregameElo": 1595,
        "homePostgameElo": 1589,
        "awayId": 150,
        "awayTeam": "Duke",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 31,
        "awayLineScores": [
            7,
            14,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.982242614030838,
        "awayPregameElo": 1607,
        "awayPostgameElo": 1613,
        "excitementIndex": 5.659197811170286,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860884,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3644,
        "venue": "Bobcat Stadium (TX)",
        "homeId": 326,
        "homeTeam": "Texas State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 26,
        "homeLineScores": [
            0,
            17,
            6,
            3
        ],
        "homePostgameWinProbability": 0.4162304699420929,
        "homePregameElo": 1441,
        "homePostgameElo": 1438,
        "awayId": 2636,
        "awayTeam": "UTSA",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 31,
        "awayLineScores": [
            7,
            0,
            10,
            14
        ],
        "awayPostgameWinProbability": 0.5837695300579071,
        "awayPregameElo": 1522,
        "awayPostgameElo": 1525,
        "excitementIndex": 6.508105036584822,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858216,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1964,
        "venue": "JMA Wireless Dome",
        "homeId": 183,
        "homeTeam": "Syracuse",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 18,
        "homeLineScores": [
            3,
            9,
            6,
            0
        ],
        "homePostgameWinProbability": 0.45804399251937866,
        "homePregameElo": 1288,
        "homePostgameElo": 1287,
        "awayId": 25,
        "awayTeam": "California",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            7,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.5419560074806213,
        "awayPregameElo": 1349,
        "awayPostgameElo": 1350,
        "excitementIndex": 6.3187843827573635,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862708,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 7221,
        "venue": "Protective Stadium",
        "homeId": 5,
        "homeTeam": "UAB",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 26,
        "homeLineScores": [
            0,
            10,
            3,
            13
        ],
        "homePostgameWinProbability": 0.9372057318687439,
        "homePregameElo": 1411,
        "homePostgameElo": 1403,
        "awayId": 2433,
        "awayTeam": "UL Monroe",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            10,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.0627942681312561,
        "awayPregameElo": 1071,
        "awayPostgameElo": 1079,
        "excitementIndex": 5.855949041456546,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856785,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3726,
        "venue": "Folsom Field",
        "homeId": 38,
        "homeTeam": "Colorado",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 52,
        "homeLineScores": [
            21,
            21,
            3,
            7
        ],
        "homePostgameWinProbability": 0.9908815622329712,
        "homePregameElo": 1404,
        "homePostgameElo": 1404,
        "awayId": 2692,
        "awayTeam": "Weber State",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 21,
        "awayLineScores": [
            7,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.009118437767028809,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.107023447998443,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856674,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3683,
        "venue": "Kroger Field",
        "homeId": 96,
        "homeTeam": "Kentucky",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 17,
        "homeLineScores": [
            7,
            10,
            0,
            0
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1476,
        "homePostgameElo": 1440,
        "awayId": 333,
        "awayTeam": "Alabama",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 45,
        "awayLineScores": [
            7,
            6,
            18,
            14
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1823,
        "awayPostgameElo": 1859,
        "excitementIndex": 4.735355751393114,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858444,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3892,
        "venue": "Pratt & Whitney Stadium",
        "homeId": 41,
        "homeTeam": "UConn",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": 14,
        "homeLineScores": [
            7,
            0,
            7,
            0
        ],
        "homePostgameWinProbability": 0.027325501665472984,
        "homePregameElo": 1484,
        "homePostgameElo": 1413,
        "awayId": 120,
        "awayTeam": "Maryland",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            10,
            14,
            7
        ],
        "awayPostgameWinProbability": 0.972674498334527,
        "awayPregameElo": 1424,
        "awayPostgameElo": 1495,
        "excitementIndex": 4.122592171700131,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401859184,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3855,
        "venue": "Notre Dame Stadium",
        "homeId": 87,
        "homeTeam": "Notre Dame",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": 52,
        "homeLineScores": [
            21,
            21,
            10,
            0
        ],
        "homePostgameWinProbability": 0.9896548390388489,
        "homePregameElo": 2021,
        "homePostgameElo": 2070,
        "awayId": 242,
        "awayTeam": "Rice",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.010345160961151123,
        "awayPregameElo": 1196,
        "awayPostgameElo": 1147,
        "excitementIndex": 1.9717400884243172,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856790,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3752,
        "venue": "Acrisure Stadium",
        "homeId": 221,
        "homeTeam": "Pittsburgh",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 12,
        "homeLineScores": [
            3,
            9,
            0,
            0
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1681,
        "homePostgameElo": 1678,
        "awayId": 2116,
        "awayTeam": "UCF",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1465,
        "awayPostgameElo": 1468,
        "excitementIndex": 5.379665826795133,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866420,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3985,
        "venue": "Warren McGuirk Alumni Stadium",
        "homeId": 113,
        "homeTeam": "Massachusetts",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 37,
        "homeLineScores": [
            17,
            6,
            14,
            0
        ],
        "homePostgameWinProbability": 0.9915581941604614,
        "homePregameElo": 1049,
        "homePostgameElo": 1049,
        "awayId": 2529,
        "awayTeam": "Sacred Heart",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            0,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.008441805839538574,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.0110112525244674,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856677,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3953,
        "venue": "Huntington Bank Stadium",
        "homeId": 135,
        "homeTeam": "Minnesota",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 13,
        "homeLineScores": [
            3,
            3,
            7,
            0
        ],
        "homePostgameWinProbability": 0.02202126942574978,
        "homePregameElo": 1510,
        "homePostgameElo": 1452,
        "awayId": 344,
        "awayTeam": "Mississippi State",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 38,
        "awayLineScores": [
            14,
            14,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.9779787305742502,
        "awayPregameElo": 1584,
        "awayPostgameElo": 1642,
        "excitementIndex": 3.6851358285722577,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862705,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T19:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3825,
        "venue": "DATCU Stadium",
        "homeId": 249,
        "homeTeam": "North Texas",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 44,
        "homeLineScores": [
            13,
            7,
            14,
            10
        ],
        "homePostgameWinProbability": 0.9951195120811462,
        "homePregameElo": 1590,
        "homePostgameElo": 1699,
        "awayId": 2439,
        "awayTeam": "UNLV",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 6,
        "awayLineScores": [
            0,
            3,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.00488048791885376,
        "awayPregameElo": 1589,
        "awayPostgameElo": 1480,
        "excitementIndex": 2.4064488437525,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864506,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3984,
        "venue": "War Memorial Stadium",
        "homeId": 2751,
        "homeTeam": "Wyoming",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 21,
        "homeLineScores": [
            0,
            7,
            0,
            14
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1309,
        "homePostgameElo": 1309,
        "awayId": 2458,
        "awayTeam": "Northern Colorado",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            10,
            3,
            0
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 5.613684794038708,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868326,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3975,
        "venue": "Veterans Memorial Stadium (AL)",
        "homeId": 2653,
        "homeTeam": "Troy",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 34,
        "homeLineScores": [
            14,
            17,
            3,
            0
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1416,
        "homePostgameElo": 1416,
        "awayId": 2011,
        "awayTeam": "Alabama State",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 17,
        "awayLineScores": [
            7,
            0,
            10,
            0
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.5127105558260845,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401865252,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3971,
        "venue": "University Stadium (NM)",
        "homeId": 167,
        "homeTeam": "New Mexico",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 70,
        "homeLineScores": [
            7,
            42,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9994450211524963,
        "homePregameElo": 1564,
        "homePostgameElo": 1564,
        "awayId": 2385,
        "awayTeam": "Mercyhurst",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0005549788475036621,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.5097709978250333,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858223,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3735,
        "venue": "Gerald J. Ford Stadium",
        "homeId": 2567,
        "homeTeam": "SMU",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 56,
        "homeLineScores": [
            14,
            28,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9876115322113037,
        "homePregameElo": 1734,
        "homePostgameElo": 1734,
        "awayId": 302,
        "awayTeam": "UC Davis",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            0,
            0,
            10
        ],
        "awayPostgameWinProbability": 0.012388467788696289,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.917390208205421,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856684,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3973,
        "venue": "FirstBank Stadium",
        "homeId": 238,
        "homeTeam": "Vanderbilt",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 35,
        "homeLineScores": [
            14,
            0,
            21,
            0
        ],
        "homePostgameWinProbability": 0.9546753168106079,
        "homePregameElo": 1753,
        "homePostgameElo": 1746,
        "awayId": 48,
        "awayTeam": "Delaware",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 26,
        "awayLineScores": [
            0,
            17,
            0,
            9
        ],
        "awayPostgameWinProbability": 0.04532468318939209,
        "awayPregameElo": 1404,
        "awayPostgameElo": 1411,
        "excitementIndex": 4.163405310327982,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856672,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T21:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3634,
        "venue": "Ben Hill Griffin Stadium",
        "homeId": 57,
        "homeTeam": "Florida",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 52,
        "homeLineScores": [
            10,
            35,
            7,
            0
        ],
        "homePostgameWinProbability": 0.9858131408691406,
        "homePregameElo": 1669,
        "homePostgameElo": 1669,
        "awayId": 2097,
        "awayTeam": "Campbell",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 3,
        "awayLineScores": [
            3,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.014186859130859375,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.480300376623857,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866414,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 2031,
        "venue": "Pitbull Stadium",
        "homeId": 2229,
        "homeTeam": "Florida International",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 33,
        "homeLineScores": [
            14,
            7,
            9,
            3
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1385,
        "homePostgameElo": 1409,
        "awayId": 2084,
        "awayTeam": "Buffalo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 20,
        "awayLineScores": [
            3,
            3,
            8,
            6
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1365,
        "awayPostgameElo": 1341,
        "excitementIndex": 3.115485379206615,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866418,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3876,
        "venue": "Peden Stadium",
        "homeId": 195,
        "homeTeam": "Ohio",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 29,
        "homeLineScores": [
            0,
            14,
            0,
            10,
            5
        ],
        "homePostgameWinProbability": 0.3134487271308899,
        "homePregameElo": 1318,
        "homePostgameElo": 1320,
        "awayId": 55,
        "awayTeam": "Jacksonville State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 27,
        "awayLineScores": [
            7,
            10,
            7,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.6865512728691101,
        "awayPregameElo": 1428,
        "awayPostgameElo": 1426,
        "excitementIndex": 7.380048779354027,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860881,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3653,
        "venue": "Albertsons Stadium",
        "homeId": 68,
        "homeTeam": "Boise State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 38,
        "homeLineScores": [
            3,
            14,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9536568522453308,
        "homePregameElo": 1569,
        "homePostgameElo": 1609,
        "awayId": 235,
        "awayTeam": "Memphis",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            13,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.04634314775466919,
        "awayPregameElo": 1566,
        "awayPostgameElo": 1526,
        "excitementIndex": 5.390900336820925,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866421,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T22:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3980,
        "venue": "Waldo Stadium",
        "homeId": 2711,
        "homeTeam": "Western Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 49,
        "homeLineScores": [
            7,
            14,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9900599718093872,
        "homePregameElo": 1534,
        "homePostgameElo": 1534,
        "awayId": 2405,
        "awayTeam": "Monmouth",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            0,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.009940028190612793,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.799589385494212,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864503,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3764,
        "venue": "Huskie Stadium",
        "homeId": 2459,
        "homeTeam": "Northern Illinois",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 24,
        "homeLineScores": [
            0,
            17,
            0,
            7
        ],
        "homePostgameWinProbability": 0.32738885283470154,
        "homePregameElo": 1245,
        "homePostgameElo": 1245,
        "awayId": 2287,
        "awayTeam": "Illinois State",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 28,
        "awayLineScores": [
            14,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.6726111471652985,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 6.71050730738745,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864575,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4729,
        "venue": "Yulman Stadium",
        "homeId": 2655,
        "homeTeam": "Tulane",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 28,
        "homeLineScores": [
            0,
            14,
            7,
            7
        ],
        "homePostgameWinProbability": 0.6363710761070251,
        "homePregameElo": 1529,
        "homePostgameElo": 1528,
        "awayId": 6,
        "awayTeam": "South Alabama",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 24,
        "awayLineScores": [
            10,
            0,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.36362892389297485,
        "awayPregameElo": 1390,
        "awayPostgameElo": 1391,
        "excitementIndex": 6.324042801260324,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860882,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 5388,
        "venue": "Canvas Stadium",
        "homeId": 36,
        "homeTeam": "Colorado State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 58,
        "homeLineScores": [
            17,
            31,
            3,
            7
        ],
        "homePostgameWinProbability": 0.9919970035552979,
        "homePregameElo": 1327,
        "homePostgameElo": 1327,
        "awayId": 253,
        "awayTeam": "Southern Utah",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 24,
        "awayLineScores": [
            7,
            14,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.008002996444702148,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.3659690485874445,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871046,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3878,
        "venue": "Plaster Sports Complex",
        "homeId": 2623,
        "homeTeam": "Missouri State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 48,
        "homeLineScores": [
            14,
            20,
            14,
            0
        ],
        "homePostgameWinProbability": 0.9952582120895386,
        "homePregameElo": 1268,
        "homePostgameElo": 1268,
        "awayId": 2815,
        "awayTeam": "Lindenwood",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            0,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.004741787910461426,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.3846776173413207,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871045,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3775,
        "venue": "Joan C. Edwards Stadium",
        "homeId": 276,
        "homeTeam": "Marshall",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 28,
        "homeLineScores": [
            7,
            7,
            0,
            14
        ],
        "homePostgameWinProbability": 0.7449626922607422,
        "homePregameElo": 1389,
        "homePostgameElo": 1388,
        "awayId": 2393,
        "awayTeam": "Middle Tennessee",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 26,
        "awayLineScores": [
            7,
            6,
            7,
            6
        ],
        "awayPostgameWinProbability": 0.2550373077392578,
        "awayPregameElo": 1276,
        "awayPostgameElo": 1277,
        "excitementIndex": 6.5898616001456,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856787,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4728,
        "venue": "TDECU Stadium",
        "homeId": 248,
        "homeTeam": "Houston",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 77,
        "homeLineScores": [
            28,
            21,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9922709465026855,
        "homePregameElo": 1521,
        "homePostgameElo": 1521,
        "awayId": 2582,
        "awayTeam": "Southern",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 6,
        "awayLineScores": [
            0,
            0,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.007729053497314453,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.4433547098894488,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856681,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 721,
        "venue": "Bobby Dodd Stadium",
        "homeId": 59,
        "homeTeam": "Georgia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 24,
        "homeLineScores": [
            10,
            0,
            7,
            7
        ],
        "homePostgameWinProbability": 0.0073597487062215805,
        "homePregameElo": 1553,
        "homePostgameElo": 1515,
        "awayId": 2633,
        "awayTeam": "Tennessee",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 45,
        "awayLineScores": [
            7,
            17,
            7,
            14
        ],
        "awayPostgameWinProbability": 0.9926402512937784,
        "awayPregameElo": 1691,
        "awayPostgameElo": 1729,
        "excitementIndex": 4.585174285774379,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856680,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3994,
        "venue": "Williams-Brice Stadium",
        "homeId": 2579,
        "homeTeam": "South Carolina",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 45,
        "homeLineScores": [
            7,
            10,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9886041879653931,
        "homePregameElo": 1763,
        "homePostgameElo": 1763,
        "awayId": 119,
        "awayTeam": "Towson",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 9,
        "awayLineScores": [
            0,
            3,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.011395812034606934,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.081217784380853,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862707,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3647,
        "venue": "Elliott T. Bowers Stadium",
        "homeId": 2534,
        "homeTeam": "Sam Houston",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 17,
        "homeLineScores": [
            7,
            7,
            3,
            0
        ],
        "homePostgameWinProbability": 0.6375409960746765,
        "homePregameElo": 1164,
        "homePostgameElo": 1161,
        "awayId": 202,
        "awayTeam": "Tulsa",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 23,
        "awayLineScores": [
            0,
            10,
            13,
            0
        ],
        "awayPostgameWinProbability": 0.3624590039253235,
        "awayPregameElo": 1268,
        "awayPostgameElo": 1271,
        "excitementIndex": 5.6417792526782655,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868241,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3625,
        "venue": "Centennial Bank Stadium",
        "homeId": 2032,
        "homeTeam": "Arkansas State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 52,
        "homeLineScores": [
            0,
            21,
            17,
            14
        ],
        "homePostgameWinProbability": 0.9971566200256348,
        "homePregameElo": 1349,
        "homePostgameElo": 1349,
        "awayId": 2698,
        "awayTeam": "West Georgia",
        "awayClassification": "fcs",
        "awayConference": "UAC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0028433799743652344,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.538354222285957,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858441,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3834,
        "venue": "Memorial Stadium (Lincoln, NE)",
        "homeId": 158,
        "homeTeam": "Nebraska",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 56,
        "homeLineScores": [
            14,
            21,
            0,
            21
        ],
        "homePostgameWinProbability": 0.9927433133125305,
        "homePregameElo": 1592,
        "homePostgameElo": 1705,
        "awayId": 189,
        "awayTeam": "Bowling Green",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.007256686687469482,
        "awayPregameElo": 1340,
        "awayPostgameElo": 1227,
        "excitementIndex": 1.8334434786997853,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869955,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4899,
        "venue": "Fifth Third Stadium",
        "homeId": 338,
        "homeTeam": "Kennesaw State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 17,
        "homeLineScores": [
            3,
            0,
            8,
            6
        ],
        "homePostgameWinProbability": 0.004584266804158688,
        "homePregameElo": 1373,
        "homePostgameElo": 1327,
        "awayId": 2247,
        "awayTeam": "Georgia State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 31,
        "awayLineScores": [
            6,
            15,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.9954157331958413,
        "awayPregameElo": 1241,
        "awayPostgameElo": 1287,
        "excitementIndex": 3.164195020313668,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856786,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3854,
        "venue": "Nippert Stadium",
        "homeId": 2132,
        "homeTeam": "Cincinnati",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 62,
        "homeLineScores": [
            7,
            21,
            21,
            13
        ],
        "homePostgameWinProbability": 0.9993381500244141,
        "homePregameElo": 1516,
        "homePostgameElo": 1516,
        "awayId": 2717,
        "awayTeam": "Western Carolina",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0006618499755859375,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.811860573881546,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858447,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 347,
        "venue": "Camp Randall Stadium",
        "homeId": 275,
        "homeTeam": "Wisconsin",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 36,
        "homeLineScores": [
            17,
            6,
            7,
            6
        ],
        "homePostgameWinProbability": 0.9956700801849365,
        "homePregameElo": 1455,
        "homePostgameElo": 1455,
        "awayId": 2710,
        "awayTeam": "Western Illinois",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 9,
        "awayLineScores": [
            3,
            3,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.0043299198150634766,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.9789155142132075,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858443,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 1056,
        "venue": "Rose Bowl",
        "homeId": 26,
        "homeTeam": "UCLA",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 28,
        "homeLineScores": [
            0,
            0,
            7,
            21
        ],
        "homePostgameWinProbability": 0.9974139332771301,
        "homePregameElo": 1438,
        "homePostgameElo": 1487,
        "awayId": 21,
        "awayTeam": "San Diego State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            0,
            0,
            10
        ],
        "awayPostgameWinProbability": 0.002586066722869873,
        "awayPregameElo": 1518,
        "awayPostgameElo": 1469,
        "excitementIndex": 3.469360436775447,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856788,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3793,
        "venue": "Kinnick Stadium",
        "homeId": 2294,
        "homeTeam": "Iowa",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 16,
        "homeLineScores": [
            0,
            10,
            0,
            6
        ],
        "homePostgameWinProbability": 0.40168020129203796,
        "homePregameElo": 1847,
        "homePostgameElo": 1845,
        "awayId": 66,
        "awayTeam": "Iowa State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            10,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.598319798707962,
        "awayPregameElo": 1586,
        "awayPostgameElo": 1588,
        "excitementIndex": 4.958241936566457,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868008,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3654,
        "venue": "Brooks Stadium (SC)",
        "homeId": 324,
        "homeTeam": "Coastal Carolina",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 45,
        "homeLineScores": [
            7,
            21,
            10,
            7
        ],
        "homePostgameWinProbability": 0.9924191832542419,
        "homePregameElo": 1270,
        "homePostgameElo": 1270,
        "awayId": 2230,
        "awayTeam": "Fordham",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.007580816745758057,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.0899856745210967,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401867796,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3958,
        "venue": "Tiger Stadium (LA)",
        "homeId": 99,
        "homeTeam": "LSU",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 45,
        "homeLineScores": [
            10,
            0,
            14,
            21
        ],
        "homePostgameWinProbability": 0.9529680609703064,
        "homePregameElo": 1745,
        "homePostgameElo": 1794,
        "awayId": 2348,
        "awayTeam": "Louisiana Tech",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.047031939029693604,
        "awayPregameElo": 1454,
        "awayPostgameElo": 1405,
        "excitementIndex": 3.7694043568740536,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856783,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3893,
        "venue": "Reser Stadium",
        "homeId": 204,
        "homeTeam": "Oregon State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 24,
        "homeLineScores": [
            0,
            7,
            14,
            3
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1260,
        "homePostgameElo": 1285,
        "awayId": 2641,
        "awayTeam": "Texas Tech",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 35,
        "awayLineScores": [
            0,
            14,
            7,
            14
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1870,
        "awayPostgameElo": 1845,
        "excitementIndex": 8.803792527027108,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862703,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3715,
        "venue": "FAU Stadium",
        "homeId": 2226,
        "homeTeam": "Florida Atlantic",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 38,
        "homeLineScores": [
            14,
            17,
            7,
            0
        ],
        "homePostgameWinProbability": 0.9901638031005859,
        "homePregameElo": 1189,
        "homePostgameElo": 1226,
        "awayId": 2426,
        "awayTeam": "Navy",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 30,
        "awayLineScores": [
            7,
            0,
            7,
            16
        ],
        "awayPostgameWinProbability": 0.009836196899414062,
        "awayPregameElo": 1550,
        "awayPostgameElo": 1513,
        "excitementIndex": 3.34078476829419,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858219,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3836,
        "venue": "Memorial Stadium (Clemson, SC)",
        "homeId": 228,
        "homeTeam": "Clemson",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 22,
        "homeLineScores": [
            7,
            9,
            0,
            6
        ],
        "homePostgameWinProbability": 0.9427822828292847,
        "homePregameElo": 1541,
        "homePostgameElo": 1558,
        "awayId": 290,
        "awayTeam": "Georgia Southern",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.05721771717071533,
        "awayPregameElo": 1376,
        "awayPostgameElo": 1359,
        "excitementIndex": 3.8034063954453603,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856682,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3910,
        "venue": "DKR-Texas Memorial Stadium",
        "homeId": 251,
        "homeTeam": "Texas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 24,
        "homeLineScores": [
            0,
            3,
            0,
            21
        ],
        "homePostgameWinProbability": 0.14218954741954803,
        "homePregameElo": 1913,
        "homePostgameElo": 1916,
        "awayId": 194,
        "awayTeam": "Ohio State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 23,
        "awayLineScores": [
            10,
            10,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.857810452580452,
        "awayPregameElo": 1986,
        "awayPostgameElo": 1983,
        "excitementIndex": 5.114837003774396,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856676,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3974,
        "venue": "Vaught-Hemingway Stadium",
        "homeId": 145,
        "homeTeam": "Ole Miss",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 41,
        "homeLineScores": [
            7,
            20,
            0,
            14
        ],
        "homePostgameWinProbability": 0.9847775101661682,
        "homePregameElo": 1837,
        "homePostgameElo": 1851,
        "awayId": 2429,
        "awayTeam": "Charlotte",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 9,
        "awayLineScores": [
            0,
            0,
            6,
            3
        ],
        "awayPostgameWinProbability": 0.015222489833831787,
        "awayPregameElo": 1182,
        "awayPostgameElo": 1168,
        "excitementIndex": 2.0606104158869574,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856671,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-12T23:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3785,
        "venue": "Jordan-Hare Stadium",
        "homeId": 2,
        "homeTeam": "Auburn",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 43,
        "homeLineScores": [
            17,
            10,
            16,
            0
        ],
        "homePostgameWinProbability": 0.9917724132537842,
        "homePregameElo": 1613,
        "homePostgameElo": 1678,
        "awayId": 2572,
        "awayTeam": "Southern Miss",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 8,
        "awayLineScores": [
            0,
            8,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.00822758674621582,
        "awayPregameElo": 1350,
        "awayPostgameElo": 1285,
        "excitementIndex": 2.0289423578577437,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856789,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3616,
        "venue": "Amon G. Carter Stadium",
        "homeId": 2628,
        "homeTeam": "TCU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 63,
        "homeLineScores": [
            7,
            21,
            14,
            21
        ],
        "homePostgameWinProbability": 0.9990647435188293,
        "homePregameElo": 1598,
        "homePostgameElo": 1598,
        "awayId": 2755,
        "awayTeam": "Grambling",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0009352564811706543,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.1245978996663135,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856784,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T00:08:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4727,
        "venue": "McLane Stadium",
        "homeId": 239,
        "homeTeam": "Baylor",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 44,
        "homeLineScores": [
            17,
            17,
            7,
            3
        ],
        "homePostgameWinProbability": 0.9628165364265442,
        "homePregameElo": 1509,
        "homePostgameElo": 1509,
        "awayId": 2504,
        "awayTeam": "Prairie View A&M",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 3,
        "awayLineScores": [
            3,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.03718346357345581,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.4287794730585697,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864504,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3935,
        "venue": "CEFCU Stadium",
        "homeId": 23,
        "homeTeam": "San José State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 30,
        "homeLineScores": [
            0,
            13,
            7,
            10
        ],
        "homePostgameWinProbability": 0.971356213092804,
        "homePregameElo": 1407,
        "homePostgameElo": 1407,
        "awayId": 13,
        "awayTeam": "Cal Poly",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 20,
        "awayLineScores": [
            0,
            6,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.028643786907196045,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 5.605784129851264,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864505,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3946,
        "venue": "Sun Bowl",
        "homeId": 2638,
        "homeTeam": "UTEP",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 51,
        "homeLineScores": [
            7,
            14,
            21,
            9
        ],
        "homePostgameWinProbability": 0.9886823892593384,
        "homePregameElo": 1143,
        "homePostgameElo": 1143,
        "awayId": 2640,
        "awayTeam": "Texas Southern",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 10,
        "awayLineScores": [
            7,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.011317610740661621,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.6816616555625794,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864502,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3713,
        "venue": "Falcon Stadium",
        "homeId": 2005,
        "homeTeam": "Air Force",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 32,
        "homeLineScores": [
            0,
            13,
            0,
            19
        ],
        "homePostgameWinProbability": 0.7506696581840515,
        "homePregameElo": 1424,
        "homePostgameElo": 1423,
        "awayId": 2449,
        "awayTeam": "North Dakota State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            21,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.2493303418159485,
        "awayPregameElo": 1566,
        "awayPostgameElo": 1567,
        "excitementIndex": 4.633518427306371,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856670,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T02:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 587,
        "venue": "Rice-Eccles Stadium",
        "homeId": 254,
        "homeTeam": "Utah",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 43,
        "homeLineScores": [
            7,
            22,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9934656023979187,
        "homePregameElo": 1817,
        "homePostgameElo": 1874,
        "awayId": 8,
        "awayTeam": "Arkansas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.006534397602081299,
        "awayPregameElo": 1547,
        "awayPostgameElo": 1490,
        "excitementIndex": 3.092347466132634,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864500,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3816,
        "venue": "Mackay Stadium",
        "homeId": 2440,
        "homeTeam": "Nevada",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 7,
        "homeLineScores": [
            0,
            0,
            0,
            7
        ],
        "homePostgameWinProbability": 0.00619275588542223,
        "homePregameElo": 1451,
        "homePostgameElo": 1451,
        "awayId": 147,
        "awayTeam": "Montana State",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 20,
        "awayLineScores": [
            10,
            7,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.9938072441145778,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.456983827518999,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860883,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3660,
        "venue": "Valley Children's Stadium",
        "homeId": 278,
        "homeTeam": "Fresno State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 49,
        "homeLineScores": [
            0,
            32,
            14,
            3
        ],
        "homePostgameWinProbability": 0.9862982630729675,
        "homePregameElo": 1449,
        "homePostgameElo": 1591,
        "awayId": 16,
        "awayTeam": "Sacramento State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            0,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.01370173692703247,
        "awayPregameElo": 1466,
        "awayPostgameElo": 1324,
        "excitementIndex": 2.6248456325091527,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858445,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T03:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 477,
        "venue": "Los Angeles Memorial Coliseum",
        "homeId": 30,
        "homeTeam": "USC",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 49,
        "homeLineScores": [
            7,
            21,
            7,
            14
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1835,
        "homePostgameElo": 1837,
        "awayId": 309,
        "awayTeam": "Louisiana",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 30,
        "awayLineScores": [
            3,
            7,
            7,
            13
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1389,
        "awayPostgameElo": 1387,
        "excitementIndex": 3.9120114593741944,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864578,
        "season": 2026,
        "week": 2,
        "seasonType": "regular",
        "startDate": "2026-09-13T03:59:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 7220,
        "venue": "Clarence T.C. Ching Athletics Complex",
        "homeId": 62,
        "homeTeam": "Hawai'i",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 29,
        "homeLineScores": [
            9,
            10,
            3,
            7
        ],
        "homePostgameWinProbability": 0.941411018371582,
        "homePregameElo": 1426,
        "homePostgameElo": 1432,
        "awayId": 166,
        "awayTeam": "New Mexico State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 19,
        "awayLineScores": [
            0,
            13,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.05858898162841797,
        "awayPregameElo": 1267,
        "awayPostgameElo": 1261,
        "excitementIndex": 4.774929477424329,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858225,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-17T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3752,
        "venue": "Acrisure Stadium",
        "homeId": 221,
        "homeTeam": "Pittsburgh",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 27,
        "homeLineScores": [
            7,
            10,
            7,
            3
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1678,
        "homePostgameElo": 1675,
        "awayId": 183,
        "awayTeam": "Syracuse",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            10,
            0,
            3
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1287,
        "awayPostgameElo": 1290,
        "excitementIndex": 2.681393052123561,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858226,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-18T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3630,
        "venue": "Allegacy Federal Credit Union Stadium",
        "homeId": 154,
        "homeTeam": "Wake Forest",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 20,
        "homeLineScores": [
            7,
            0,
            6,
            7
        ],
        "homePostgameWinProbability": 0.06744542717933655,
        "homePregameElo": 1508,
        "homePostgameElo": 1514,
        "awayId": 2390,
        "awayTeam": "Miami",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 33,
        "awayLineScores": [
            7,
            17,
            7,
            2
        ],
        "awayPostgameWinProbability": 0.9325545728206635,
        "awayPregameElo": 1901,
        "awayPostgameElo": 1895,
        "excitementIndex": 4.531463816387299,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856811,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3784,
        "venue": "Jones AT&T Stadium",
        "homeId": 2641,
        "homeTeam": "Texas Tech",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 28,
        "homeLineScores": [
            0,
            14,
            7,
            7
        ],
        "homePostgameWinProbability": 0.5553051233291626,
        "homePregameElo": 1845,
        "homePostgameElo": 1841,
        "awayId": 248,
        "awayTeam": "Houston",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 26,
        "awayLineScores": [
            10,
            7,
            3,
            6
        ],
        "awayPostgameWinProbability": 0.4446948766708374,
        "awayPregameElo": 1514,
        "awayPostgameElo": 1518,
        "excitementIndex": 6.805447451480736,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858455,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3626,
        "venue": "Autzen Stadium",
        "homeId": 2483,
        "homeTeam": "Oregon",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 84,
        "homeLineScores": [
            28,
            21,
            14,
            21
        ],
        "homePostgameWinProbability": 0.9894304871559143,
        "homePregameElo": 1838,
        "homePostgameElo": 1838,
        "awayId": 2502,
        "awayTeam": "Portland State",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.010569512844085693,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.89479407163626,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869940,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T15:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3695,
        "venue": "Delaware Stadium",
        "homeId": 48,
        "homeTeam": "Delaware",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 22,
        "homeLineScores": [
            0,
            15,
            0,
            7
        ],
        "homePostgameWinProbability": 0.16937653720378876,
        "homePregameElo": 1411,
        "homePostgameElo": 1414,
        "awayId": 324,
        "awayTeam": "Coastal Carolina",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.8306234627962112,
        "awayPregameElo": 1270,
        "awayPostgameElo": 1267,
        "excitementIndex": 4.877524784363484,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856812,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": true,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 2455,
        "venue": "Wembley Stadium",
        "homeId": 2305,
        "homeTeam": "Kansas",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 17,
        "homeLineScores": [
            0,
            7,
            0,
            10
        ],
        "homePostgameWinProbability": 0.7476793527603149,
        "homePregameElo": 1485,
        "homePostgameElo": 1481,
        "awayId": 9,
        "awayTeam": "Arizona State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 24,
        "awayLineScores": [
            3,
            7,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.25232064723968506,
        "awayPregameElo": 1531,
        "awayPostgameElo": 1535,
        "excitementIndex": 4.606880390879709,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858229,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3836,
        "venue": "Memorial Stadium (Clemson, SC)",
        "homeId": 228,
        "homeTeam": "Clemson",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 28,
        "homeLineScores": [
            3,
            3,
            9,
            13
        ],
        "homePostgameWinProbability": 0.9200934171676636,
        "homePregameElo": 1558,
        "homePostgameElo": 1560,
        "awayId": 153,
        "awayTeam": "North Carolina",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 20,
        "awayLineScores": [
            14,
            3,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.07990658283233643,
        "awayPregameElo": 1398,
        "awayPostgameElo": 1396,
        "excitementIndex": 4.845464774691703,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856686,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3887,
        "venue": "Razorback Stadium",
        "homeId": 8,
        "homeTeam": "Arkansas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 17,
        "homeLineScores": [
            0,
            3,
            0,
            14
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1490,
        "homePostgameElo": 1466,
        "awayId": 61,
        "awayTeam": "Georgia",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 45,
        "awayLineScores": [
            7,
            14,
            10,
            14
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1948,
        "awayPostgameElo": 1972,
        "excitementIndex": 2.951363194479673,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860889,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3644,
        "venue": "Bobcat Stadium (TX)",
        "homeId": 326,
        "homeTeam": "Texas State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 49,
        "homeLineScores": [
            21,
            7,
            7,
            14
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1438,
        "homePostgameElo": 1491,
        "awayId": 249,
        "awayTeam": "North Texas",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 35,
        "awayLineScores": [
            7,
            21,
            0,
            7
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1699,
        "awayPostgameElo": 1646,
        "excitementIndex": 5.544088586426384,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858451,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3953,
        "venue": "Huntington Bank Stadium",
        "homeId": 135,
        "homeTeam": "Minnesota",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 41,
        "homeLineScores": [
            10,
            10,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9865986704826355,
        "homePregameElo": 1452,
        "homePostgameElo": 1484,
        "awayId": 2006,
        "awayTeam": "Akron",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.013401329517364502,
        "awayPregameElo": 929,
        "awayPostgameElo": 897,
        "excitementIndex": 2.252949199441229,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858228,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 721,
        "venue": "Bobby Dodd Stadium",
        "homeId": 59,
        "homeTeam": "Georgia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 44,
        "homeLineScores": [
            7,
            17,
            13,
            7
        ],
        "homePostgameWinProbability": 0.9872198700904846,
        "homePregameElo": 1503,
        "homePostgameElo": 1503,
        "awayId": 2382,
        "awayTeam": "Mercer",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": 11,
        "awayLineScores": [
            0,
            3,
            8,
            0
        ],
        "awayPostgameWinProbability": 0.01278012990951538,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.9715837092751365,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856798,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3772,
        "venue": "Jack Trice Stadium",
        "homeId": 66,
        "homeTeam": "Iowa State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 55,
        "homeLineScores": [
            21,
            14,
            10,
            10
        ],
        "homePostgameWinProbability": 0.9847278594970703,
        "homePregameElo": 1588,
        "homePostgameElo": 1683,
        "awayId": 189,
        "awayTeam": "Bowling Green",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.015272140502929688,
        "awayPregameElo": 1227,
        "awayPostgameElo": 1132,
        "excitementIndex": 2.90255500259395,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858456,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3632,
        "venue": "Beaver Stadium",
        "homeId": 213,
        "homeTeam": "Penn State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 55,
        "homeLineScores": [
            17,
            17,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9946691989898682,
        "homePregameElo": 1880,
        "homePostgameElo": 1933,
        "awayId": 2084,
        "awayTeam": "Buffalo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 13,
        "awayLineScores": [
            3,
            3,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.005330801010131836,
        "awayPregameElo": 1341,
        "awayPostgameElo": 1288,
        "excitementIndex": 2.03969834859093,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856792,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3636,
        "venue": "Bill Snyder Family Stadium",
        "homeId": 2306,
        "homeTeam": "Kansas State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 31,
        "homeLineScores": [
            0,
            17,
            7,
            7
        ],
        "homePostgameWinProbability": 0.993634819984436,
        "homePregameElo": 1684,
        "homePostgameElo": 1692,
        "awayId": 2655,
        "awayTeam": "Tulane",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            3,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.006365180015563965,
        "awayPregameElo": 1528,
        "awayPostgameElo": 1520,
        "excitementIndex": 3.379333217409422,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858454,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3861,
        "venue": "Ohio Stadium",
        "homeId": 194,
        "homeTeam": "Ohio State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 59,
        "homeLineScores": [
            21,
            14,
            7,
            17
        ],
        "homePostgameWinProbability": 0.9889574646949768,
        "homePregameElo": 1983,
        "homePostgameElo": 2032,
        "awayId": 2309,
        "awayTeam": "Kent State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            0,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.011042535305023193,
        "awayPregameElo": 1056,
        "awayPostgameElo": 1007,
        "excitementIndex": 1.5658069191125186,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858460,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 347,
        "venue": "Camp Randall Stadium",
        "homeId": 275,
        "homeTeam": "Wisconsin",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 54,
        "homeLineScores": [
            3,
            28,
            10,
            13
        ],
        "homePostgameWinProbability": 0.9905959367752075,
        "homePregameElo": 1475,
        "homePostgameElo": 1580,
        "awayId": 2199,
        "awayTeam": "Eastern Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 10,
        "awayLineScores": [
            7,
            0,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.00940406322479248,
        "awayPregameElo": 1293,
        "awayPostgameElo": 1188,
        "excitementIndex": 2.899037008885028,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856695,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T16:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3973,
        "venue": "FirstBank Stadium",
        "homeId": 238,
        "homeTeam": "Vanderbilt",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 35,
        "homeLineScores": [
            0,
            7,
            7,
            21
        ],
        "homePostgameWinProbability": 0.9763383865356445,
        "homePregameElo": 1746,
        "homePostgameElo": 1742,
        "awayId": 152,
        "awayTeam": "NC State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 31,
        "awayLineScores": [
            14,
            3,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.02366161346435547,
        "awayPregameElo": 1506,
        "awayPostgameElo": 1510,
        "excitementIndex": 8.990119449610065,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864508,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3786,
        "venue": "Kelly/Shorts Stadium",
        "homeId": 2117,
        "homeTeam": "Central Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 24,
        "homeLineScores": [
            3,
            14,
            7,
            0
        ],
        "homePostgameWinProbability": 0.9417828321456909,
        "homePregameElo": 1259,
        "homePostgameElo": 1291,
        "awayId": 2751,
        "awayTeam": "Wyoming",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            0,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.05821716785430908,
        "awayPregameElo": 1300,
        "awayPostgameElo": 1268,
        "excitementIndex": 2.5193044641179796,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858227,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3615,
        "venue": "Alumni Stadium (Chestnut Hill, MA)",
        "homeId": 103,
        "homeTeam": "Boston College",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 22,
        "homeLineScores": [
            16,
            3,
            3,
            0
        ],
        "homePostgameWinProbability": 0.6811010241508484,
        "homePregameElo": 1379,
        "homePostgameElo": 1379,
        "awayId": 311,
        "awayTeam": "Maine",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": 16,
        "awayLineScores": [
            0,
            10,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.3188989758491516,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.131625533947348,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858448,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3832,
        "venue": "Memorial Stadium (Champaign, IL)",
        "homeId": 356,
        "homeTeam": "Illinois",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 48,
        "homeLineScores": [
            14,
            17,
            0,
            17
        ],
        "homePostgameWinProbability": 0.9906846880912781,
        "homePregameElo": 1587,
        "homePostgameElo": 1587,
        "awayId": 79,
        "awayTeam": "Southern Illinois",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 10,
        "awayLineScores": [
            7,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.009315311908721924,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.609181816487975,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862774,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3739,
        "venue": "Glass Bowl",
        "homeId": 2649,
        "homeTeam": "Toledo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 49,
        "homeLineScores": [
            7,
            7,
            7,
            21,
            7
        ],
        "homePostgameWinProbability": 0.5539595484733582,
        "homePregameElo": 1568,
        "homePostgameElo": 1561,
        "awayId": 218,
        "awayTeam": "Temple",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 48,
        "awayLineScores": [
            10,
            14,
            3,
            15,
            6
        ],
        "awayPostgameWinProbability": 0.44604045152664185,
        "awayPregameElo": 1323,
        "awayPostgameElo": 1330,
        "excitementIndex": 7.729420903421505,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866424,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3985,
        "venue": "Warren McGuirk Alumni Stadium",
        "homeId": 113,
        "homeTeam": "Massachusetts",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 36,
        "homeLineScores": [
            13,
            0,
            9,
            14
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1049,
        "homePostgameElo": 1049,
        "awayId": 284,
        "awayTeam": "Stonehill",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.7463259433589973,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858450,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3558,
        "venue": "Michigan Stadium",
        "homeId": 130,
        "homeTeam": "Michigan",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 52,
        "homeLineScores": [
            0,
            17,
            28,
            7
        ],
        "homePostgameWinProbability": 0.9927566647529602,
        "homePregameElo": 1702,
        "homePostgameElo": 1735,
        "awayId": 2638,
        "awayTeam": "UTEP",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 17,
        "awayLineScores": [
            7,
            7,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.007243335247039795,
        "awayPregameElo": 1163,
        "awayPostgameElo": 1130,
        "excitementIndex": 4.7078150789167,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856801,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 587,
        "venue": "Rice-Eccles Stadium",
        "homeId": 254,
        "homeTeam": "Utah",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 33,
        "homeLineScores": [
            16,
            10,
            7,
            0
        ],
        "homePostgameWinProbability": 0.9871453642845154,
        "homePregameElo": 1874,
        "homePostgameElo": 1907,
        "awayId": 328,
        "awayTeam": "Utah State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.01285463571548462,
        "awayPregameElo": 1381,
        "awayPostgameElo": 1348,
        "excitementIndex": 1.855585364021608,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856797,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 7173,
        "venue": "TQL Stadium",
        "homeId": 2132,
        "homeTeam": "Cincinnati",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 35,
        "homeLineScores": [
            7,
            0,
            14,
            14
        ],
        "homePostgameWinProbability": 0.6021653413772583,
        "homePregameElo": 1516,
        "homePostgameElo": 1512,
        "awayId": 193,
        "awayTeam": "Miami (OH)",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 31,
        "awayLineScores": [
            14,
            14,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.3978346586227417,
        "awayPregameElo": 1259,
        "awayPostgameElo": 1263,
        "excitementIndex": 6.38672450903238,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858230,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3873,
        "venue": "L&N Federal Credit Union Stadium",
        "homeId": 97,
        "homeTeam": "Louisville",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 41,
        "homeLineScores": [
            14,
            0,
            14,
            13
        ],
        "homePostgameWinProbability": 0.9996628165245056,
        "homePregameElo": 1668,
        "homePostgameElo": 1690,
        "awayId": 2567,
        "awayTeam": "SMU",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 31,
        "awayLineScores": [
            7,
            10,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.00033718347549438477,
        "awayPregameElo": 1728,
        "awayPostgameElo": 1706,
        "excitementIndex": 7.0761696534289475,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856694,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3795,
        "venue": "Kyle Field",
        "homeId": 245,
        "homeTeam": "Texas A&M",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 21,
        "homeLineScores": [
            0,
            7,
            0,
            14
        ],
        "homePostgameWinProbability": 0.003098544664680958,
        "homePregameElo": 1890,
        "homePostgameElo": 1824,
        "awayId": 96,
        "awayTeam": "Kentucky",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 31,
        "awayLineScores": [
            0,
            7,
            21,
            3
        ],
        "awayPostgameWinProbability": 0.996901455335319,
        "awayPregameElo": 1440,
        "awayPostgameElo": 1506,
        "excitementIndex": 4.227566138069254,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856685,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3657,
        "venue": "Bryant-Denny Stadium",
        "homeId": 333,
        "homeTeam": "Alabama",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 50,
        "homeLineScores": [
            3,
            23,
            14,
            10
        ],
        "homePostgameWinProbability": 0.9943773746490479,
        "homePregameElo": 1859,
        "homePostgameElo": 1863,
        "awayId": 52,
        "awayTeam": "Florida State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 36,
        "awayLineScores": [
            14,
            7,
            7,
            8
        ],
        "awayPostgameWinProbability": 0.0056226253509521484,
        "awayPregameElo": 1557,
        "awayPostgameElo": 1553,
        "excitementIndex": 5.513821541043104,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858457,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6577,
        "venue": "SHI Stadium",
        "homeId": 164,
        "homeTeam": "Rutgers",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 35,
        "homeLineScores": [
            7,
            7,
            14,
            7
        ],
        "homePostgameWinProbability": 0.0719924047589302,
        "homePregameElo": 1371,
        "homePostgameElo": 1391,
        "awayId": 30,
        "awayTeam": "USC",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 42,
        "awayLineScores": [
            10,
            10,
            15,
            7
        ],
        "awayPostgameWinProbability": 0.9280075952410698,
        "awayPregameElo": 1837,
        "awayPostgameElo": 1817,
        "excitementIndex": 6.144945172564879,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858233,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3831,
        "venue": "California Memorial Stadium",
        "homeId": 25,
        "homeTeam": "California",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 49,
        "homeLineScores": [
            29,
            10,
            7,
            3
        ],
        "homePostgameWinProbability": 0.960480809211731,
        "homePregameElo": 1353,
        "homePostgameElo": 1353,
        "awayId": 2681,
        "awayTeam": "Wagner",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.03951919078826904,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.013852397878264,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860890,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3820,
        "venue": "Gesa Field",
        "homeId": 265,
        "homeTeam": "Washington State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 48,
        "homeLineScores": [
            7,
            7,
            21,
            13
        ],
        "homePostgameWinProbability": 0.992756724357605,
        "homePregameElo": 1536,
        "homePostgameElo": 1536,
        "awayId": 2184,
        "awayTeam": "Duquesne",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0072432756423950195,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.736257066861516,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858471,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3793,
        "venue": "Kinnick Stadium",
        "homeId": 2294,
        "homeTeam": "Iowa",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 55,
        "homeLineScores": [
            21,
            21,
            7,
            6
        ],
        "homePostgameWinProbability": 0.9930168986320496,
        "homePregameElo": 1841,
        "homePostgameElo": 1841,
        "awayId": 2460,
        "awayTeam": "Northern Iowa",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0069831013679504395,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.087183122203247,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858449,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3830,
        "venue": "Memorial Stadium (Bloomington, IN)",
        "homeId": 84,
        "homeTeam": "Indiana",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 38,
        "homeLineScores": [
            0,
            14,
            17,
            7
        ],
        "homePostgameWinProbability": 0.9926459193229675,
        "homePregameElo": 2113,
        "homePostgameElo": 2121,
        "awayId": 98,
        "awayTeam": "Western Kentucky",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.007354080677032471,
        "awayPregameElo": 1250,
        "awayPostgameElo": 1242,
        "excitementIndex": 2.876401622365555,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858231,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3982,
        "venue": "Wallace Wade Stadium",
        "homeId": 150,
        "homeTeam": "Duke",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 35,
        "homeLineScores": [
            0,
            14,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9935848712921143,
        "homePregameElo": 1613,
        "homePostgameElo": 1656,
        "awayId": 24,
        "awayTeam": "Stanford",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.006415128707885742,
        "awayPregameElo": 1354,
        "awayPostgameElo": 1311,
        "excitementIndex": 3.237433821701348,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866422,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3992,
        "venue": "Williams Stadium (VA)",
        "homeId": 2335,
        "homeTeam": "Liberty",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 51,
        "homeLineScores": [
            13,
            10,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9943554401397705,
        "homePregameElo": 1697,
        "homePostgameElo": 1728,
        "awayId": 2050,
        "awayTeam": "Ball State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 15,
        "awayLineScores": [
            7,
            0,
            8,
            0
        ],
        "awayPostgameWinProbability": 0.005644559860229492,
        "awayPregameElo": 1112,
        "awayPostgameElo": 1081,
        "excitementIndex": 2.9032035567150762,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401867804,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4727,
        "venue": "McLane Stadium",
        "homeId": 239,
        "homeTeam": "Baylor",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 36,
        "homeLineScores": [
            7,
            13,
            9,
            7
        ],
        "homePostgameWinProbability": 0.9502611756324768,
        "homePregameElo": 1506,
        "homePostgameElo": 1534,
        "awayId": 2348,
        "awayTeam": "Louisiana Tech",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 19,
        "awayLineScores": [
            7,
            0,
            0,
            12
        ],
        "awayPostgameWinProbability": 0.04973882436752319,
        "awayPregameElo": 1405,
        "awayPostgameElo": 1377,
        "excitementIndex": 3.360110119380664,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856691,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3994,
        "venue": "Williams-Brice Stadium",
        "homeId": 2579,
        "homeTeam": "South Carolina",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 34,
        "homeLineScores": [
            13,
            10,
            0,
            11
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1742,
        "homePostgameElo": 1721,
        "awayId": 344,
        "awayTeam": "Mississippi State",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 41,
        "awayLineScores": [
            0,
            14,
            17,
            10
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1642,
        "awayPostgameElo": 1663,
        "excitementIndex": 5.6081138909839074,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868317,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3817,
        "venue": "Malone Stadium",
        "homeId": 2433,
        "homeTeam": "UL Monroe",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 35,
        "homeLineScores": [
            0,
            13,
            7,
            15
        ],
        "homePostgameWinProbability": 0.025431832298636436,
        "homePregameElo": 1076,
        "homePostgameElo": 1076,
        "awayId": 2545,
        "awayTeam": "SE Louisiana",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            17,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.9745681677013636,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 5.870224837157036,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864574,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3792,
        "venue": "Kidd Brewer Stadium",
        "homeId": 2026,
        "homeTeam": "App State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 26,
        "homeLineScores": [
            3,
            10,
            6,
            7
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1325,
        "homePostgameElo": 1324,
        "awayId": 2429,
        "awayTeam": "Charlotte",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            7,
            0,
            14
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1168,
        "awayPostgameElo": 1169,
        "excitementIndex": 3.7335858381066593,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862710,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3918,
        "venue": "S.B. Ballard Stadium",
        "homeId": 295,
        "homeTeam": "Old Dominion",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 17,
        "homeLineScores": [
            0,
            17,
            0,
            0
        ],
        "homePostgameWinProbability": 0.7674409747123718,
        "homePregameElo": 1289,
        "homePostgameElo": 1295,
        "awayId": 151,
        "awayTeam": "East Carolina",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            3,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.23255902528762817,
        "awayPregameElo": 1462,
        "awayPostgameElo": 1456,
        "excitementIndex": 6.3264494952988874,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862771,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3715,
        "venue": "FAU Stadium",
        "homeId": 2226,
        "homeTeam": "Florida Atlantic",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 16,
        "homeLineScores": [
            10,
            0,
            6,
            0
        ],
        "homePostgameWinProbability": 0.9298617243766785,
        "homePregameElo": 1226,
        "homePostgameElo": 1243,
        "awayId": 2229,
        "awayTeam": "Florida International",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            7,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.07013827562332153,
        "awayPregameElo": 1409,
        "awayPostgameElo": 1392,
        "excitementIndex": 5.53028244613773,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871047,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T22:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3878,
        "venue": "Plaster Sports Complex",
        "homeId": 2623,
        "homeTeam": "Missouri State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 24,
        "homeLineScores": [
            10,
            0,
            14,
            0
        ],
        "homePostgameWinProbability": 0.5527694821357727,
        "homePregameElo": 1284,
        "homePostgameElo": 1281,
        "awayId": 276,
        "awayTeam": "Marshall",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 30,
        "awayLineScores": [
            14,
            3,
            10,
            3
        ],
        "awayPostgameWinProbability": 0.4472305178642273,
        "awayPregameElo": 1388,
        "awayPostgameElo": 1391,
        "excitementIndex": 6.715983248413741,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862773,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3895,
        "venue": "Rice Stadium",
        "homeId": 242,
        "homeTeam": "Rice",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 21,
        "homeLineScores": [
            0,
            7,
            7,
            7
        ],
        "homePostgameWinProbability": 0.3939010798931122,
        "homePregameElo": 1147,
        "homePostgameElo": 1162,
        "awayId": 2711,
        "awayTeam": "Western Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 28,
        "awayLineScores": [
            7,
            7,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.6060989201068878,
        "awayPregameElo": 1534,
        "awayPostgameElo": 1519,
        "excitementIndex": 4.697684070810628,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870764,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3647,
        "venue": "Elliott T. Bowers Stadium",
        "homeId": 2534,
        "homeTeam": "Sam Houston",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 59,
        "homeLineScores": [
            10,
            21,
            21,
            7
        ],
        "homePostgameWinProbability": 0.989645779132843,
        "homePregameElo": 1155,
        "homePostgameElo": 1155,
        "awayId": 2447,
        "awayTeam": "Nicholls",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.010354220867156982,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.8754360356013395,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862777,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3886,
        "venue": "Raymond James Stadium",
        "homeId": 58,
        "homeTeam": "South Florida",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 59,
        "homeLineScores": [
            14,
            14,
            14,
            17
        ],
        "homePostgameWinProbability": 0.9322245717048645,
        "homePregameElo": 1682,
        "homePostgameElo": 1682,
        "awayId": 2169,
        "awayTeam": "Delaware State",
        "awayClassification": "fcs",
        "awayConference": "MEAC",
        "awayPoints": 17,
        "awayLineScores": [
            7,
            10,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0677754282951355,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.6874871503721045,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866423,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 6526,
        "venue": "Hancock Whitney Stadium",
        "homeId": 6,
        "homeTeam": "South Alabama",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 41,
        "homeLineScores": [
            14,
            10,
            7,
            10
        ],
        "homePostgameWinProbability": 0.6848459243774414,
        "homePregameElo": 1391,
        "homePostgameElo": 1393,
        "awayId": 195,
        "awayTeam": "Ohio",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 36,
        "awayLineScores": [
            7,
            0,
            14,
            15
        ],
        "awayPostgameWinProbability": 0.3151540756225586,
        "awayPregameElo": 1320,
        "awayPostgameElo": 1318,
        "excitementIndex": 3.9245862967611207,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864443,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3725,
        "venue": "Johnny \"Red\" Floyd Stadium",
        "homeId": 2393,
        "homeTeam": "Middle Tennessee",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 27,
        "homeLineScores": [
            7,
            3,
            7,
            10
        ],
        "homePostgameWinProbability": 0.9568924903869629,
        "homePregameElo": 1277,
        "homePostgameElo": 1298,
        "awayId": 2440,
        "awayTeam": "Nevada",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            3,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.04310750961303711,
        "awayPregameElo": 1462,
        "awayPostgameElo": 1441,
        "excitementIndex": 5.943196413737067,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856803,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3646,
        "venue": "Boone Pickens Stadium",
        "homeId": 197,
        "homeTeam": "Oklahoma State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 59,
        "homeLineScores": [
            14,
            17,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9924694895744324,
        "homePregameElo": 1247,
        "homePostgameElo": 1247,
        "awayId": 93,
        "awayTeam": "Murray State",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.007530510425567627,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.8571430379362441,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856687,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3785,
        "venue": "Jordan-Hare Stadium",
        "homeId": 2,
        "homeTeam": "Auburn",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 39,
        "homeLineScores": [
            3,
            14,
            7,
            15
        ],
        "homePostgameWinProbability": 0.02467680722475052,
        "homePregameElo": 1678,
        "homePostgameElo": 1668,
        "awayId": 57,
        "awayTeam": "Florida",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 44,
        "awayLineScores": [
            7,
            13,
            14,
            10
        ],
        "awayPostgameWinProbability": 0.9753231927752495,
        "awayPregameElo": 1658,
        "awayPostgameElo": 1668,
        "excitementIndex": 4.915838118486049,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401861963,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3815,
        "venue": "M. M. Roberts Stadium",
        "homeId": 2572,
        "homeTeam": "Southern Miss",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 20,
        "homeLineScores": [
            3,
            3,
            7,
            7
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1285,
        "homePostgameElo": 1224,
        "awayId": 41,
        "awayTeam": "UConn",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": 48,
        "awayLineScores": [
            14,
            13,
            14,
            7
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1413,
        "awayPostgameElo": 1474,
        "excitementIndex": 4.811639806925726,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856689,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3838,
        "venue": "Memorial Stadium",
        "homeId": 142,
        "homeTeam": "Missouri",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 27,
        "homeLineScores": [
            0,
            24,
            0,
            3
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1691,
        "homePostgameElo": 1690,
        "awayId": 2653,
        "awayTeam": "Troy",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 17,
        "awayLineScores": [
            10,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1420,
        "awayPostgameElo": 1421,
        "excitementIndex": 4.3885685456675425,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869948,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3662,
        "venue": "AmFirst Stadium",
        "homeId": 55,
        "homeTeam": "Jacksonville State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 31,
        "homeLineScores": [
            0,
            10,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9172762632369995,
        "homePregameElo": 1426,
        "homePostgameElo": 1427,
        "awayId": 290,
        "awayTeam": "Georgia Southern",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 27,
        "awayLineScores": [
            3,
            21,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.08272373676300049,
        "awayPregameElo": 1359,
        "awayPostgameElo": 1358,
        "excitementIndex": 5.231225171281374,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862772,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3805,
        "venue": "Simmons Bank Liberty Stadium",
        "homeId": 235,
        "homeTeam": "Memphis",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 45,
        "homeLineScores": [
            10,
            14,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9892739653587341,
        "homePregameElo": 1529,
        "homePostgameElo": 1529,
        "awayId": 2630,
        "awayTeam": "UT Martin",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            7,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.01072603464126587,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.4351672171204406,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856800,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3652,
        "venue": "FBC Mortgage Stadium",
        "homeId": 2116,
        "homeTeam": "UCF",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 44,
        "homeLineScores": [
            17,
            3,
            14,
            10
        ],
        "homePostgameWinProbability": 0.9837412238121033,
        "homePregameElo": 1468,
        "homePostgameElo": 1481,
        "awayId": 2247,
        "awayTeam": "Georgia State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 30,
        "awayLineScores": [
            7,
            17,
            3,
            3
        ],
        "awayPostgameWinProbability": 0.01625877618789673,
        "awayPregameElo": 1287,
        "awayPostgameElo": 1274,
        "excitementIndex": 5.735549721200934,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858452,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3834,
        "venue": "Memorial Stadium (Lincoln, NE)",
        "homeId": 158,
        "homeTeam": "Nebraska",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 34,
        "homeLineScores": [
            14,
            3,
            7,
            10
        ],
        "homePostgameWinProbability": 0.9894856214523315,
        "homePregameElo": 1715,
        "homePostgameElo": 1715,
        "awayId": 155,
        "awayTeam": "North Dakota",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.010514378547668457,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.859135207140717,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858459,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3765,
        "venue": "Husky Stadium",
        "homeId": 264,
        "homeTeam": "Washington",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 48,
        "homeLineScores": [
            14,
            17,
            7,
            10
        ],
        "homePostgameWinProbability": 0.9898290038108826,
        "homePregameElo": 1752,
        "homePostgameElo": 1752,
        "awayId": 331,
        "awayTeam": "Eastern Washington",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 16,
        "awayLineScores": [
            3,
            7,
            3,
            3
        ],
        "awayPostgameWinProbability": 0.010170996189117432,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.1874741790894,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856796,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 5960,
        "venue": "Lanny and Sharon Martin Stadium",
        "homeId": 77,
        "homeTeam": "Northwestern",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 41,
        "homeLineScores": [
            7,
            14,
            14,
            6
        ],
        "homePostgameWinProbability": 0.9932442307472229,
        "homePregameElo": 1549,
        "homePostgameElo": 1625,
        "awayId": 38,
        "awayTeam": "Colorado",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.0067557692527771,
        "awayPregameElo": 1406,
        "awayPostgameElo": 1330,
        "excitementIndex": 2.6936814550593233,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856795,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 5388,
        "venue": "Canvas Stadium",
        "homeId": 36,
        "homeTeam": "Colorado State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 23,
        "homeLineScores": [
            7,
            0,
            0,
            16
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1336,
        "homePostgameElo": 1327,
        "awayId": 252,
        "awayTeam": "BYU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 41,
        "awayLineScores": [
            21,
            10,
            7,
            3
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1683,
        "awayPostgameElo": 1692,
        "excitementIndex": 3.8666532735004533,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858232,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3665,
        "venue": "SECU Stadium",
        "homeId": 120,
        "homeTeam": "Maryland",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 26,
        "homeLineScores": [
            0,
            14,
            0,
            12
        ],
        "homePostgameWinProbability": 0.03750906139612198,
        "homePregameElo": 1495,
        "homePostgameElo": 1474,
        "awayId": 259,
        "awayTeam": "Virginia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 35,
        "awayLineScores": [
            7,
            20,
            8,
            0
        ],
        "awayPostgameWinProbability": 0.962490938603878,
        "awayPregameElo": 1468,
        "awayPostgameElo": 1489,
        "excitementIndex": 4.1187773296057335,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856802,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": true,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3628,
        "venue": "Bank of America Stadium",
        "homeId": 258,
        "homeTeam": "Virginia",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 27,
        "homeLineScores": [
            14,
            0,
            7,
            6
        ],
        "homePostgameWinProbability": 0.031228691339492798,
        "homePregameElo": 1655,
        "homePostgameElo": 1612,
        "awayId": 277,
        "awayTeam": "West Virginia",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            14,
            7,
            10
        ],
        "awayPostgameWinProbability": 0.9687713086605072,
        "awayPregameElo": 1365,
        "awayPostgameElo": 1408,
        "excitementIndex": 6.0148190025336605,
        "highlights": "",
        "notes": "Duke’s Mayo Classic",
        "playoff": null
    },
    {
        "id": 401856690,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3835,
        "venue": "Memorial Stadium (Norman, OK)",
        "homeId": 201,
        "homeTeam": "Oklahoma",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 14,
        "homeLineScores": [
            0,
            7,
            7,
            0
        ],
        "homePostgameWinProbability": 0.660073459148407,
        "homePregameElo": 1783,
        "homePostgameElo": 1782,
        "awayId": 167,
        "awayTeam": "New Mexico",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 6,
        "awayLineScores": [
            0,
            6,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.339926540851593,
        "awayPregameElo": 1558,
        "awayPostgameElo": 1559,
        "excitementIndex": 3.888959815772902,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858453,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3855,
        "venue": "Notre Dame Stadium",
        "homeId": 87,
        "homeTeam": "Notre Dame",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": 27,
        "homeLineScores": [
            10,
            7,
            3,
            7
        ],
        "homePostgameWinProbability": 0.9938645958900452,
        "homePregameElo": 2070,
        "homePostgameElo": 2061,
        "awayId": 127,
        "awayTeam": "Michigan State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            10,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.006135404109954834,
        "awayPregameElo": 1528,
        "awayPostgameElo": 1537,
        "excitementIndex": 2.726436174502571,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856688,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3974,
        "venue": "Vaught-Hemingway Stadium",
        "homeId": 145,
        "homeTeam": "Ole Miss",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 32,
        "homeLineScores": [
            10,
            14,
            0,
            8
        ],
        "homePostgameWinProbability": 0.1468684822320938,
        "homePregameElo": 1851,
        "homePostgameElo": 1859,
        "awayId": 99,
        "awayTeam": "LSU",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 24,
        "awayLineScores": [
            0,
            7,
            14,
            3
        ],
        "awayPostgameWinProbability": 0.8531315177679062,
        "awayPregameElo": 1794,
        "awayPostgameElo": 1786,
        "excitementIndex": 4.662154542037517,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856692,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-19T23:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3853,
        "venue": "Neyland Stadium",
        "homeId": 2633,
        "homeTeam": "Tennessee",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 42,
        "homeLineScores": [
            15,
            6,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9932624697685242,
        "homePregameElo": 1729,
        "homePostgameElo": 1771,
        "awayId": 338,
        "awayTeam": "Kennesaw State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 9,
        "awayLineScores": [
            3,
            0,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.00673753023147583,
        "awayPregameElo": 1327,
        "awayPostgameElo": 1285,
        "excitementIndex": 1.9992992525092796,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862775,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3674,
        "venue": "Chapman Stadium",
        "homeId": 202,
        "homeTeam": "Tulsa",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 42,
        "homeLineScores": [
            7,
            7,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9883432984352112,
        "homePregameElo": 1277,
        "homePostgameElo": 1277,
        "awayId": 2837,
        "awayTeam": "East Texas A&M",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.011656701564788818,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.2230052365386244,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856799,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3616,
        "venue": "Amon G. Carter Stadium",
        "homeId": 2628,
        "homeTeam": "TCU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 31,
        "homeLineScores": [
            7,
            7,
            7,
            10
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1595,
        "homePostgameElo": 1629,
        "awayId": 2032,
        "awayTeam": "Arkansas State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1353,
        "awayPostgameElo": 1319,
        "excitementIndex": 3.1451508269075092,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862776,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3666,
        "venue": "Cajun Field",
        "homeId": 309,
        "homeTeam": "Louisiana",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 21,
        "homeLineScores": [
            7,
            14,
            0,
            0
        ],
        "homePostgameWinProbability": 0.9404008984565735,
        "homePregameElo": 1387,
        "homePostgameElo": 1397,
        "awayId": 5,
        "awayTeam": "UAB",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.059599101543426514,
        "awayPregameElo": 1403,
        "awayPostgameElo": 1393,
        "excitementIndex": 3.4527354029997275,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856693,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3910,
        "venue": "DKR-Texas Memorial Stadium",
        "homeId": 251,
        "homeTeam": "Texas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 30,
        "homeLineScores": [
            10,
            10,
            3,
            7
        ],
        "homePostgameWinProbability": 0.9641265273094177,
        "homePregameElo": 1916,
        "homePostgameElo": 1935,
        "awayId": 2636,
        "awayTeam": "UTSA",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 6,
        "awayLineScores": [
            3,
            0,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.035873472690582275,
        "awayPregameElo": 1525,
        "awayPostgameElo": 1506,
        "excitementIndex": 2.120834864199118,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860885,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3653,
        "venue": "Albertsons Stadium",
        "homeId": 68,
        "homeTeam": "Boise State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 38,
        "homeLineScores": [
            7,
            14,
            3,
            14
        ],
        "homePostgameWinProbability": 0.9551956653594971,
        "homePregameElo": 1606,
        "homePostgameElo": 1606,
        "awayId": 233,
        "awayTeam": "South Dakota",
        "awayClassification": "fcs",
        "awayConference": "MVFC",
        "awayPoints": 24,
        "awayLineScores": [
            7,
            7,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.04480433464050293,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 5.709640287937467,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860887,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 7311,
        "venue": "Snapdragon Stadium",
        "homeId": 21,
        "homeTeam": "San Diego State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 13,
        "homeLineScores": [
            0,
            0,
            7,
            6
        ],
        "homePostgameWinProbability": 0.009089328348636627,
        "homePregameElo": 1469,
        "homePostgameElo": 1468,
        "awayId": 256,
        "awayTeam": "James Madison",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 26,
        "awayLineScores": [
            10,
            9,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.9909106716513634,
        "awayPregameElo": 1776,
        "awayPostgameElo": 1777,
        "excitementIndex": 4.566228542357562,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856793,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3619,
        "venue": "Arizona Stadium",
        "homeId": 12,
        "homeTeam": "Arizona",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 42,
        "homeLineScores": [
            7,
            21,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9791824221611023,
        "homePregameElo": 1608,
        "homePostgameElo": 1634,
        "awayId": 2459,
        "awayTeam": "Northern Illinois",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 17,
        "awayLineScores": [
            10,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.020817577838897705,
        "awayPregameElo": 1266,
        "awayPostgameElo": 1240,
        "excitementIndex": 3.8379336626917135,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864507,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3757,
        "venue": "Hornet Stadium",
        "homeId": 16,
        "homeTeam": "Sacramento State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 10,
        "homeLineScores": [
            0,
            3,
            0,
            7
        ],
        "homePostgameWinProbability": 0.11865776777267456,
        "homePregameElo": 1324,
        "homePostgameElo": 1297,
        "awayId": 2449,
        "awayTeam": "North Dakota State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 31,
        "awayLineScores": [
            21,
            7,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.8813422322273254,
        "awayPregameElo": 1567,
        "awayPostgameElo": 1594,
        "excitementIndex": 4.201292419504139,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860886,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T03:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3893,
        "venue": "Reser Stadium",
        "homeId": 204,
        "homeTeam": "Oregon State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 52,
        "homeLineScores": [
            14,
            21,
            7,
            10
        ],
        "homePostgameWinProbability": 0.9868937730789185,
        "homePregameElo": 1259,
        "homePostgameElo": 1259,
        "awayId": 149,
        "awayTeam": "Montana",
        "awayClassification": "fcs",
        "awayConference": "Big Sky",
        "awayPoints": 17,
        "awayLineScores": [
            0,
            3,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.013106226921081543,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.5196248513888295,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860888,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T03:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3935,
        "venue": "CEFCU Stadium",
        "homeId": 23,
        "homeTeam": "San José State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 10,
        "homeLineScores": [
            3,
            0,
            0,
            7
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1413,
        "homePostgameElo": 1393,
        "awayId": 278,
        "awayTeam": "Fresno State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 26,
        "awayLineScores": [
            0,
            6,
            7,
            13
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1591,
        "awayPostgameElo": 1611,
        "excitementIndex": 5.372592252759031,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858458,
        "season": 2026,
        "week": 3,
        "seasonType": "regular",
        "startDate": "2026-09-20T03:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1056,
        "venue": "Rose Bowl",
        "homeId": 26,
        "homeTeam": "UCLA",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 52,
        "homeLineScores": [
            21,
            3,
            14,
            14
        ],
        "homePostgameWinProbability": 0.8728534579277039,
        "homePregameElo": 1487,
        "homePostgameElo": 1502,
        "awayId": 2509,
        "awayTeam": "Purdue",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            14,
            10,
            7
        ],
        "awayPostgameWinProbability": 0.12714654207229614,
        "awayPregameElo": 1326,
        "awayPostgameElo": 1311,
        "excitementIndex": 5.646131474311363,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869941,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-24T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3654,
        "venue": "Brooks Stadium (SC)",
        "homeId": 324,
        "homeTeam": "Coastal Carolina",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 17,
        "homeLineScores": [
            3,
            14,
            0,
            0
        ],
        "homePostgameWinProbability": 0.1106228455901146,
        "homePregameElo": 1267,
        "homePostgameElo": 1270,
        "awayId": 2335,
        "awayTeam": "Liberty",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 34,
        "awayLineScores": [
            10,
            0,
            10,
            14
        ],
        "awayPostgameWinProbability": 0.8893771544098854,
        "awayPregameElo": 1728,
        "awayPostgameElo": 1725,
        "excitementIndex": 5.786679905016679,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862779,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-25T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3806,
        "venue": "Lincoln Financial Field",
        "homeId": 218,
        "homeTeam": "Temple",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 17,
        "homeLineScores": [
            7,
            0,
            7,
            3
        ],
        "homePostgameWinProbability": 0.5170736312866211,
        "homePregameElo": 1330,
        "homePostgameElo": 1336,
        "awayId": 349,
        "awayTeam": "Army",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 21,
        "awayLineScores": [
            7,
            0,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.4829263687133789,
        "awayPregameElo": 1530,
        "awayPostgameElo": 1524,
        "excitementIndex": 5.4124245271611855,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858468,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-25T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 6577,
        "venue": "SHI Stadium",
        "homeId": 164,
        "homeTeam": "Rutgers",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 58,
        "homeLineScores": [
            21,
            20,
            10,
            7
        ],
        "homePostgameWinProbability": 0.9923157691955566,
        "homePregameElo": 1373,
        "homePostgameElo": 1373,
        "awayId": 47,
        "awayTeam": "Howard",
        "awayClassification": "fcs",
        "awayConference": "MEAC",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.007684230804443359,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.8288786763993832,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862778,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-25T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7221,
        "venue": "Protective Stadium",
        "homeId": 5,
        "homeTeam": "UAB",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 24,
        "homeLineScores": [
            0,
            17,
            0,
            7
        ],
        "homePostgameWinProbability": 0.9578489661216736,
        "homePregameElo": 1393,
        "homePostgameElo": 1400,
        "awayId": 2426,
        "awayTeam": "Navy",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 20,
        "awayLineScores": [
            0,
            13,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.042151033878326416,
        "awayPregameElo": 1513,
        "awayPostgameElo": 1506,
        "excitementIndex": 5.7253890950266975,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858461,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3830,
        "venue": "Memorial Stadium (Bloomington, IN)",
        "homeId": 84,
        "homeTeam": "Indiana",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 29,
        "homeLineScores": [
            2,
            10,
            3,
            14
        ],
        "homePostgameWinProbability": 0.734318733215332,
        "homePregameElo": 2121,
        "homePostgameElo": 2106,
        "awayId": 77,
        "awayTeam": "Northwestern",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 23,
        "awayLineScores": [
            0,
            0,
            7,
            16
        ],
        "awayPostgameWinProbability": 0.26568126678466797,
        "awayPregameElo": 1625,
        "awayPostgameElo": 1640,
        "excitementIndex": 5.065616254853787,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858234,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3831,
        "venue": "California Memorial Stadium",
        "homeId": 25,
        "homeTeam": "California",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 10,
        "homeLineScores": [
            7,
            0,
            3,
            0
        ],
        "homePostgameWinProbability": 0.05829513818025589,
        "homePregameElo": 1350,
        "homePostgameElo": 1338,
        "awayId": 228,
        "awayTeam": "Clemson",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 24,
        "awayLineScores": [
            0,
            10,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.9417048618197441,
        "awayPregameElo": 1560,
        "awayPostgameElo": 1572,
        "excitementIndex": 4.8369947923936385,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860896,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3604,
        "venue": "Alamodome",
        "homeId": 2636,
        "homeTeam": "UTSA",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 59,
        "homeLineScores": [
            21,
            14,
            7,
            17
        ],
        "homePostgameWinProbability": 0.9023878574371338,
        "homePregameElo": 1506,
        "homePostgameElo": 1519,
        "awayId": 36,
        "awayTeam": "Colorado State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 45,
        "awayLineScores": [
            14,
            7,
            14,
            10
        ],
        "awayPostgameWinProbability": 0.09761214256286621,
        "awayPregameElo": 1327,
        "awayPostgameElo": 1314,
        "excitementIndex": 4.666174845628281,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858236,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3752,
        "venue": "Acrisure Stadium",
        "homeId": 221,
        "homeTeam": "Pittsburgh",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 59,
        "homeLineScores": [
            14,
            21,
            7,
            17
        ],
        "homePostgameWinProbability": 0.971844494342804,
        "homePregameElo": 1687,
        "homePostgameElo": 1687,
        "awayId": 2083,
        "awayTeam": "Bucknell",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.028155505657196045,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.360540901995125,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864512,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3768,
        "venue": "InfoCision Stadium",
        "homeId": 2006,
        "homeTeam": "Akron",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 10,
        "homeLineScores": [
            7,
            3,
            0,
            0
        ],
        "homePostgameWinProbability": 0.017381563782691956,
        "homePregameElo": 897,
        "homePostgameElo": 886,
        "awayId": 2439,
        "awayTeam": "UNLV",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            7,
            17,
            7
        ],
        "awayPostgameWinProbability": 0.982618436217308,
        "awayPregameElo": 1480,
        "awayPostgameElo": 1491,
        "excitementIndex": 4.010147939482967,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860893,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3739,
        "venue": "Glass Bowl",
        "homeId": 2649,
        "homeTeam": "Toledo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 41,
        "homeLineScores": [
            7,
            10,
            17,
            7
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1561,
        "homePostgameElo": 1614,
        "awayId": 21,
        "awayTeam": "San Diego State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 16,
        "awayLineScores": [
            3,
            0,
            6,
            7
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1468,
        "awayPostgameElo": 1415,
        "excitementIndex": 2.9814664252481533,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856805,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3784,
        "venue": "Jones AT&T Stadium",
        "homeId": 2641,
        "homeTeam": "Texas Tech",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 49,
        "homeLineScores": [
            7,
            14,
            14,
            14
        ],
        "homePostgameWinProbability": 0.997654914855957,
        "homePregameElo": 1841,
        "homePostgameElo": 1860,
        "awayId": 2534,
        "awayTeam": "Sam Houston",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            14,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0023450851440429688,
        "awayPregameElo": 1161,
        "awayPostgameElo": 1142,
        "excitementIndex": 3.041494746391094,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858243,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3873,
        "venue": "L&N Federal Credit Union Stadium",
        "homeId": 97,
        "homeTeam": "Louisville",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 27,
        "homeLineScores": [
            7,
            14,
            6,
            0
        ],
        "homePostgameWinProbability": 0.06864926964044571,
        "homePregameElo": 1690,
        "homePostgameElo": 1674,
        "awayId": 154,
        "awayTeam": "Wake Forest",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 30,
        "awayLineScores": [
            3,
            21,
            3,
            3
        ],
        "awayPostgameWinProbability": 0.9313507303595543,
        "awayPregameElo": 1514,
        "awayPostgameElo": 1530,
        "excitementIndex": 7.702457424504924,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856704,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3853,
        "venue": "Neyland Stadium",
        "homeId": 2633,
        "homeTeam": "Tennessee",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 17,
        "homeLineScores": [
            3,
            0,
            7,
            7
        ],
        "homePostgameWinProbability": 0.212660551071167,
        "homePregameElo": 1771,
        "homePostgameElo": 1776,
        "awayId": 251,
        "awayTeam": "Texas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            3,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.787339448928833,
        "awayPregameElo": 1935,
        "awayPostgameElo": 1930,
        "excitementIndex": 5.781441553031744,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858465,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3861,
        "venue": "Ohio Stadium",
        "homeId": 194,
        "homeTeam": "Ohio State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 42,
        "homeLineScores": [
            14,
            14,
            0,
            14
        ],
        "homePostgameWinProbability": 0.9550241231918335,
        "homePregameElo": 2032,
        "homePostgameElo": 2044,
        "awayId": 356,
        "awayTeam": "Illinois",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 19,
        "awayLineScores": [
            7,
            3,
            3,
            6
        ],
        "awayPostgameWinProbability": 0.044975876808166504,
        "awayPregameElo": 1589,
        "awayPostgameElo": 1577,
        "excitementIndex": 2.865914670983624,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866425,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3696,
        "venue": "Dix Stadium",
        "homeId": 2309,
        "homeTeam": "Kent State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 26,
        "homeLineScores": [
            7,
            10,
            0,
            9
        ],
        "homePostgameWinProbability": 0.9914798140525818,
        "homePregameElo": 1007,
        "homePostgameElo": 1039,
        "awayId": 2050,
        "awayTeam": "Ball State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            0,
            7,
            6
        ],
        "awayPostgameWinProbability": 0.008520185947418213,
        "awayPregameElo": 1081,
        "awayPostgameElo": 1049,
        "excitementIndex": 2.8336813489711803,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858242,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3615,
        "venue": "Alumni Stadium (Chestnut Hill, MA)",
        "homeId": 103,
        "homeTeam": "Boston College",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 14,
        "homeLineScores": [
            0,
            0,
            7,
            7
        ],
        "homePostgameWinProbability": 0.5770919919013977,
        "homePregameElo": 1380,
        "homePostgameElo": 1375,
        "awayId": 259,
        "awayTeam": "Virginia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            3,
            3,
            15
        ],
        "awayPostgameWinProbability": 0.4229080080986023,
        "awayPregameElo": 1489,
        "awayPostgameElo": 1494,
        "excitementIndex": 6.247434536126439,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856813,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4727,
        "venue": "McLane Stadium",
        "homeId": 239,
        "homeTeam": "Baylor",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 23,
        "homeLineScores": [
            0,
            10,
            3,
            10
        ],
        "homePostgameWinProbability": 0.7850828766822815,
        "homePregameElo": 1534,
        "homePostgameElo": 1537,
        "awayId": 38,
        "awayTeam": "Colorado",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 13,
        "awayLineScores": [
            3,
            0,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.2149171233177185,
        "awayPregameElo": 1330,
        "awayPostgameElo": 1327,
        "excitementIndex": 5.849607178858012,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864576,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T16:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3683,
        "venue": "Kroger Field",
        "homeId": 96,
        "homeTeam": "Kentucky",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 45,
        "homeLineScores": [
            7,
            17,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9962456822395325,
        "homePregameElo": 1506,
        "homePostgameElo": 1553,
        "awayId": 6,
        "awayTeam": "South Alabama",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            21,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0037543177604675293,
        "awayPregameElo": 1393,
        "awayPostgameElo": 1346,
        "excitementIndex": 5.369965684224936,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866427,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3912,
        "venue": "Rynearson Stadium",
        "homeId": 2199,
        "homeTeam": "Eastern Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 29,
        "homeLineScores": [
            13,
            6,
            3,
            7
        ],
        "homePostgameWinProbability": 0.9807041883468628,
        "homePregameElo": 1182,
        "homePostgameElo": 1182,
        "awayId": 2815,
        "awayTeam": "Lindenwood",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            0,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.019295811653137207,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.0376238297147706,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858462,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T17:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3665,
        "venue": "SECU Stadium",
        "homeId": 120,
        "homeTeam": "Maryland",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 3,
        "homeLineScores": [
            0,
            3,
            0,
            0
        ],
        "homePostgameWinProbability": 0.12636494636535645,
        "homePregameElo": 1474,
        "homePostgameElo": 1316,
        "awayId": 26,
        "awayTeam": "UCLA",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 54,
        "awayLineScores": [
            0,
            20,
            14,
            20
        ],
        "awayPostgameWinProbability": 0.8736350536346436,
        "awayPregameElo": 1502,
        "awayPostgameElo": 1660,
        "excitementIndex": 4.133270982449607,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864511,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4246,
        "venue": "Center Parc Stadium",
        "homeId": 2247,
        "homeTeam": "Georgia State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 35,
        "homeLineScores": [
            7,
            14,
            14,
            0
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1274,
        "homePostgameElo": 1320,
        "awayId": 2459,
        "awayTeam": "Northern Illinois",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1240,
        "awayPostgameElo": 1194,
        "excitementIndex": 3.7497333138339326,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858467,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3907,
        "venue": "Ross-Ade Stadium",
        "homeId": 2509,
        "homeTeam": "Purdue",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 10,
        "homeLineScores": [
            0,
            0,
            3,
            7
        ],
        "homePostgameWinProbability": 0.009583858773112297,
        "homePregameElo": 1311,
        "homePostgameElo": 1288,
        "awayId": 87,
        "awayTeam": "Notre Dame",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": 49,
        "awayLineScores": [
            7,
            28,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.9904161412268877,
        "awayPregameElo": 2061,
        "awayPostgameElo": 2084,
        "excitementIndex": 2.530448204201181,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858237,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3697,
        "venue": "Doak Campbell Stadium",
        "homeId": 52,
        "homeTeam": "Florida State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 34,
        "homeLineScores": [
            14,
            10,
            10,
            0
        ],
        "homePostgameWinProbability": 0.9934864044189453,
        "homePregameElo": 1544,
        "homePostgameElo": 1544,
        "awayId": 2110,
        "awayTeam": "Central Arkansas",
        "awayClassification": "fcs",
        "awayConference": "UAC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0065135955810546875,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.235036167991172,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864510,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3984,
        "venue": "War Memorial Stadium",
        "homeId": 2751,
        "homeTeam": "Wyoming",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 27,
        "homeLineScores": [
            3,
            10,
            0,
            14
        ],
        "homePostgameWinProbability": 0.9874715209007263,
        "homePregameElo": 1268,
        "homePostgameElo": 1322,
        "awayId": 62,
        "awayTeam": "Hawai'i",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.012528479099273682,
        "awayPregameElo": 1432,
        "awayPostgameElo": 1378,
        "excitementIndex": 3.3967724136281614,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860897,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3980,
        "venue": "Waldo Stadium",
        "homeId": 2711,
        "homeTeam": "Western Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 7,
        "homeLineScores": [
            0,
            0,
            0,
            7
        ],
        "homePostgameWinProbability": 0.01104755513370037,
        "homePregameElo": 1519,
        "homePostgameElo": 1463,
        "awayId": 68,
        "awayTeam": "Boise State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 32,
        "awayLineScores": [
            8,
            7,
            10,
            7
        ],
        "awayPostgameWinProbability": 0.9889524448662996,
        "awayPregameElo": 1609,
        "awayPostgameElo": 1665,
        "excitementIndex": 2.965807001384967,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856700,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3917,
        "venue": "Sanford Stadium",
        "homeId": 61,
        "homeTeam": "Georgia",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 41,
        "homeLineScores": [
            7,
            21,
            3,
            10
        ],
        "homePostgameWinProbability": 0.7367156744003296,
        "homePregameElo": 1972,
        "homePostgameElo": 2023,
        "awayId": 201,
        "awayTeam": "Oklahoma",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            0,
            6,
            7
        ],
        "awayPostgameWinProbability": 0.2632843255996704,
        "awayPregameElo": 1782,
        "awayPostgameElo": 1731,
        "excitementIndex": 2.4945346930463996,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401868188,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3775,
        "venue": "Joan C. Edwards Stadium",
        "homeId": 276,
        "homeTeam": "Marshall",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 36,
        "homeLineScores": [
            10,
            17,
            0,
            9
        ],
        "homePostgameWinProbability": 0.25881633162498474,
        "homePregameElo": 1397,
        "homePostgameElo": 1397,
        "awayId": 2241,
        "awayTeam": "Gardner-Webb",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": 35,
        "awayLineScores": [
            14,
            7,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.7411836683750153,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 9.182577063726184,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858244,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3982,
        "venue": "Wallace Wade Stadium",
        "homeId": 150,
        "homeTeam": "Duke",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 62,
        "homeLineScores": [
            14,
            24,
            10,
            14
        ],
        "homePostgameWinProbability": 0.9980794191360474,
        "homePregameElo": 1667,
        "homePostgameElo": 1667,
        "awayId": 2729,
        "awayTeam": "William & Mary",
        "awayClassification": "fcs",
        "awayConference": "Patriot",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0019205808639526367,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.45995909424972,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866426,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3965,
        "venue": "UB Stadium",
        "homeId": 2084,
        "homeTeam": "Buffalo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 31,
        "homeLineScores": [
            0,
            14,
            7,
            10
        ],
        "homePostgameWinProbability": 0.8974424004554749,
        "homePregameElo": 1262,
        "homePostgameElo": 1262,
        "awayId": 2523,
        "awayTeam": "Robert Morris",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 28,
        "awayLineScores": [
            7,
            7,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.10255759954452515,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 5.169809429434956,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864579,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3601,
        "venue": "Aggie Memorial Stadium",
        "homeId": 166,
        "homeTeam": "New Mexico State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 18,
        "homeLineScores": [
            0,
            3,
            0,
            15
        ],
        "homePostgameWinProbability": 0.004678218625485897,
        "homePregameElo": 1261,
        "homePostgameElo": 1231,
        "awayId": 167,
        "awayTeam": "New Mexico",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 42,
        "awayLineScores": [
            14,
            0,
            21,
            7
        ],
        "awayPostgameWinProbability": 0.9953217813745141,
        "awayPregameElo": 1559,
        "awayPostgameElo": 1589,
        "excitementIndex": 3.729731630773163,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858463,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3558,
        "venue": "Michigan Stadium",
        "homeId": 130,
        "homeTeam": "Michigan",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 19,
        "homeLineScores": [
            7,
            3,
            3,
            6
        ],
        "homePostgameWinProbability": 0.827899694442749,
        "homePregameElo": 1735,
        "homePostgameElo": 1739,
        "awayId": 2294,
        "awayTeam": "Iowa",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            0,
            0,
            13
        ],
        "awayPostgameWinProbability": 0.17210030555725098,
        "awayPregameElo": 1845,
        "awayPostgameElo": 1841,
        "excitementIndex": 5.308759697276732,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401861970,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3996,
        "venue": "Yager Stadium",
        "homeId": 193,
        "homeTeam": "Miami (OH)",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 24,
        "homeLineScores": [
            0,
            14,
            7,
            3
        ],
        "homePostgameWinProbability": 0.933273434638977,
        "homePregameElo": 1263,
        "homePostgameElo": 1267,
        "awayId": 41,
        "awayTeam": "UConn",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": 21,
        "awayLineScores": [
            14,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.06672656536102295,
        "awayPregameElo": 1474,
        "awayPostgameElo": 1470,
        "excitementIndex": 6.891866126932857,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856699,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3634,
        "venue": "Ben Hill Griffin Stadium",
        "homeId": 57,
        "homeTeam": "Florida",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 52,
        "homeLineScores": [
            10,
            7,
            14,
            21
        ],
        "homePostgameWinProbability": 0.9972167015075684,
        "homePregameElo": 1668,
        "homePostgameElo": 1751,
        "awayId": 145,
        "awayTeam": "Ole Miss",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 28,
        "awayLineScores": [
            0,
            6,
            15,
            7
        ],
        "awayPostgameWinProbability": 0.0027832984924316406,
        "awayPregameElo": 1859,
        "awayPostgameElo": 1776,
        "excitementIndex": 3.5871283412431705,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856815,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3652,
        "venue": "FBC Mortgage Stadium",
        "homeId": 2116,
        "homeTeam": "UCF",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 21,
        "homeLineScores": [
            7,
            7,
            0,
            7
        ],
        "homePostgameWinProbability": 0.8546160459518433,
        "homePregameElo": 1481,
        "homePostgameElo": 1503,
        "awayId": 2628,
        "awayTeam": "TCU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 13,
        "awayLineScores": [
            7,
            3,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.14538395404815674,
        "awayPregameElo": 1629,
        "awayPostgameElo": 1607,
        "excitementIndex": 4.223712729931165,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856816,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3772,
        "venue": "Jack Trice Stadium",
        "homeId": 66,
        "homeTeam": "Iowa State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 17,
        "homeLineScores": [
            0,
            3,
            7,
            7
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1683,
        "homePostgameElo": 1672,
        "awayId": 254,
        "awayTeam": "Utah",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 31,
        "awayLineScores": [
            14,
            10,
            0,
            7
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1907,
        "awayPostgameElo": 1918,
        "excitementIndex": 4.9792189606780575,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866428,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3876,
        "venue": "Peden Stadium",
        "homeId": 195,
        "homeTeam": "Ohio",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 35,
        "homeLineScores": [
            7,
            7,
            14,
            7
        ],
        "homePostgameWinProbability": 0.987979531288147,
        "homePregameElo": 1318,
        "homePostgameElo": 1318,
        "awayId": 284,
        "awayTeam": "Stonehill",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.012020468711853027,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.54451251273959,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862781,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3699,
        "venue": "Dowdy-Ficklen Stadium",
        "homeId": 151,
        "homeTeam": "East Carolina",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 42,
        "homeLineScores": [
            7,
            35,
            0,
            0
        ],
        "homePostgameWinProbability": 0.9756007194519043,
        "homePregameElo": 1462,
        "homePostgameElo": 1462,
        "awayId": 2428,
        "awayTeam": "North Carolina Central",
        "awayClassification": "fcs",
        "awayConference": "MEAC",
        "awayPoints": 9,
        "awayLineScores": [
            3,
            0,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.024399280548095703,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.17240210366826,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856806,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3608,
        "venue": "Allen E. Paulson Stadium",
        "homeId": 290,
        "homeTeam": "Georgia Southern",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 28,
        "homeLineScores": [
            0,
            14,
            7,
            7
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1358,
        "homePostgameElo": 1341,
        "awayId": 248,
        "awayTeam": "Houston",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 42,
        "awayLineScores": [
            14,
            14,
            7,
            7
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1518,
        "awayPostgameElo": 1535,
        "excitementIndex": 4.30696389182298,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856698,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3785,
        "venue": "Jordan-Hare Stadium",
        "homeId": 2,
        "homeTeam": "Auburn",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 21,
        "homeLineScores": [
            7,
            7,
            7,
            0
        ],
        "homePostgameWinProbability": 0.6595492362976074,
        "homePregameElo": 1668,
        "homePostgameElo": 1679,
        "awayId": 238,
        "awayTeam": "Vanderbilt",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 15,
        "awayLineScores": [
            3,
            0,
            6,
            6
        ],
        "awayPostgameWinProbability": 0.3404507637023926,
        "awayPregameElo": 1742,
        "awayPostgameElo": 1731,
        "excitementIndex": 4.354474712785336,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858464,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3936,
        "venue": "Spartan Stadium",
        "homeId": 127,
        "homeTeam": "Michigan State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 13,
        "homeLineScores": [
            3,
            7,
            3,
            0
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1537,
        "homePostgameElo": 1510,
        "awayId": 158,
        "awayTeam": "Nebraska",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 31,
        "awayLineScores": [
            7,
            17,
            0,
            7
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1705,
        "awayPostgameElo": 1732,
        "excitementIndex": 4.359703729038841,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862785,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3700,
        "venue": "Doyt L. Perry Stadium",
        "homeId": 189,
        "homeTeam": "Bowling Green",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 6,
        "homeLineScores": [
            3,
            3,
            0,
            0
        ],
        "homePostgameWinProbability": 0.5262295603752136,
        "homePregameElo": 1132,
        "homePostgameElo": 1156,
        "awayId": 58,
        "awayTeam": "South Florida",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            0,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.4737704396247864,
        "awayPregameElo": 1676,
        "awayPostgameElo": 1652,
        "excitementIndex": 4.812591852940088,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858466,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3632,
        "venue": "Beaver Stadium",
        "homeId": 213,
        "homeTeam": "Penn State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 20,
        "homeLineScores": [
            3,
            14,
            3,
            0
        ],
        "homePostgameWinProbability": 0.5245678424835205,
        "homePregameElo": 1933,
        "homePostgameElo": 1901,
        "awayId": 275,
        "awayTeam": "Wisconsin",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 24,
        "awayLineScores": [
            0,
            7,
            3,
            14
        ],
        "awayPostgameWinProbability": 0.4754321575164795,
        "awayPregameElo": 1580,
        "awayPostgameElo": 1612,
        "excitementIndex": 5.318259320033969,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869961,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3918,
        "venue": "S.B. Ballard Stadium",
        "homeId": 295,
        "homeTeam": "Old Dominion",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 20,
        "homeLineScores": [
            7,
            10,
            0,
            3
        ],
        "homePostgameWinProbability": 0.03528686612844467,
        "homePregameElo": 1295,
        "homePostgameElo": 1279,
        "awayId": 256,
        "awayTeam": "James Madison",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 46,
        "awayLineScores": [
            17,
            13,
            6,
            10
        ],
        "awayPostgameWinProbability": 0.9647131338715553,
        "awayPregameElo": 1777,
        "awayPostgameElo": 1793,
        "excitementIndex": 4.817054761388346,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860892,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3644,
        "venue": "Bobcat Stadium (TX)",
        "homeId": 326,
        "homeTeam": "Texas State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 63,
        "homeLineScores": [
            28,
            14,
            0,
            21
        ],
        "homePostgameWinProbability": 0.9922709465026855,
        "homePregameElo": 1475,
        "homePostgameElo": 1475,
        "awayId": 2916,
        "awayTeam": "Incarnate Word",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 10,
        "awayLineScores": [
            7,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.007729053497314453,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 3.1663214256551377,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858239,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3923,
        "venue": "Scott Stadium",
        "homeId": 258,
        "homeTeam": "Virginia",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 42,
        "homeLineScores": [
            7,
            21,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9814552068710327,
        "homePregameElo": 1612,
        "homePostgameElo": 1698,
        "awayId": 48,
        "awayTeam": "Delaware",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.018544793128967285,
        "awayPregameElo": 1414,
        "awayPostgameElo": 1328,
        "excitementIndex": 2.4772565551776125,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401867909,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 2031,
        "venue": "Pitbull Stadium",
        "homeId": 2229,
        "homeTeam": "Florida International",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 20,
        "homeLineScores": [
            7,
            7,
            3,
            3
        ],
        "homePostgameWinProbability": 0.9179713726043701,
        "homePregameElo": 1397,
        "homePostgameElo": 1397,
        "awayId": 2341,
        "awayTeam": "Long Island University",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.08202862739562988,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.65221845606213,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858238,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T22:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3948,
        "venue": "Hard Rock Stadium",
        "homeId": 2390,
        "homeTeam": "Miami",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 52,
        "homeLineScores": [
            7,
            28,
            7,
            10
        ],
        "homePostgameWinProbability": 0.986876368522644,
        "homePregameElo": 1895,
        "homePostgameElo": 1962,
        "awayId": 2117,
        "awayTeam": "Central Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 3,
        "awayLineScores": [
            3,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.013123631477355957,
        "awayPregameElo": 1291,
        "awayPostgameElo": 1224,
        "excitementIndex": 2.2898621738017813,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862780,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T22:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4418,
        "venue": "Jerry Richardson Stadium",
        "homeId": 2429,
        "homeTeam": "Charlotte",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 7,
        "homeLineScores": [
            0,
            7,
            0,
            0
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1169,
        "homePostgameElo": 1123,
        "awayId": 309,
        "awayTeam": "Louisiana",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 34,
        "awayLineScores": [
            3,
            7,
            7,
            17
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1397,
        "awayPostgameElo": 1443,
        "excitementIndex": 4.014103078124902,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856881,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3842,
        "venue": "Milan Puskar Stadium",
        "homeId": 277,
        "homeTeam": "West Virginia",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 24,
        "homeLineScores": [
            7,
            7,
            10,
            0
        ],
        "homePostgameWinProbability": 0.12267377972602844,
        "homePregameElo": 1408,
        "homePostgameElo": 1352,
        "awayId": 197,
        "awayTeam": "Oklahoma State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 41,
        "awayLineScores": [
            3,
            10,
            15,
            13
        ],
        "awayPostgameWinProbability": 0.8773262202739716,
        "awayPregameElo": 1274,
        "awayPostgameElo": 1330,
        "excitementIndex": 6.713631407029059,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870745,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3796,
        "venue": "Houchens Industries-L.T. Smith Stadium",
        "homeId": 98,
        "homeTeam": "Western Kentucky",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 52,
        "homeLineScores": [
            10,
            21,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9924694895744324,
        "homePregameElo": 1202,
        "homePostgameElo": 1202,
        "awayId": 2385,
        "awayTeam": "Mercyhurst",
        "awayClassification": "fcs",
        "awayConference": "NEC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.007530510425567627,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.6429486449769999,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862784,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 4729,
        "venue": "Yulman Stadium",
        "homeId": 2655,
        "homeTeam": "Tulane",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 24,
        "homeLineScores": [
            7,
            7,
            0,
            10
        ],
        "homePostgameWinProbability": 0.4611043930053711,
        "homePregameElo": 1520,
        "homePostgameElo": 1517,
        "awayId": 2572,
        "awayTeam": "Southern Miss",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            14,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.5388956069946289,
        "awayPregameElo": 1224,
        "awayPostgameElo": 1227,
        "excitementIndex": 6.744854884552767,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871048,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3662,
        "venue": "AmFirst Stadium",
        "homeId": 55,
        "homeTeam": "Jacksonville State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 23,
        "homeLineScores": [
            3,
            7,
            10,
            3
        ],
        "homePostgameWinProbability": 0.7791450619697571,
        "homePregameElo": 1427,
        "homePostgameElo": 1435,
        "awayId": 2393,
        "awayTeam": "Middle Tennessee",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            7,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.22085493803024292,
        "awayPregameElo": 1298,
        "awayPostgameElo": 1290,
        "excitementIndex": 4.013981990276698,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856696,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3657,
        "venue": "Bryant-Denny Stadium",
        "homeId": 333,
        "homeTeam": "Alabama",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 49,
        "homeLineScores": [
            14,
            21,
            0,
            14
        ],
        "homePostgameWinProbability": 0.9893242120742798,
        "homePregameElo": 1863,
        "homePostgameElo": 1929,
        "awayId": 2579,
        "awayTeam": "South Carolina",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 18,
        "awayLineScores": [
            0,
            10,
            0,
            8
        ],
        "awayPostgameWinProbability": 0.010675787925720215,
        "awayPregameElo": 1721,
        "awayPostgameElo": 1655,
        "excitementIndex": 2.9230204809345275,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856814,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3854,
        "venue": "Nippert Stadium",
        "homeId": 2132,
        "homeTeam": "Cincinnati",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 31,
        "homeLineScores": [
            0,
            10,
            14,
            7
        ],
        "homePostgameWinProbability": 0.938930094242096,
        "homePregameElo": 1512,
        "homePostgameElo": 1525,
        "awayId": 2306,
        "awayTeam": "Kansas State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 26,
        "awayLineScores": [
            3,
            14,
            0,
            9
        ],
        "awayPostgameWinProbability": 0.06106990575790405,
        "awayPregameElo": 1692,
        "awayPostgameElo": 1679,
        "excitementIndex": 6.24996004926384,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869931,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3625,
        "venue": "Centennial Bank Stadium",
        "homeId": 2032,
        "homeTeam": "Arkansas State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 17,
        "homeLineScores": [
            0,
            7,
            7,
            3
        ],
        "homePostgameWinProbability": 0.98304682970047,
        "homePregameElo": 1319,
        "homePostgameElo": 1320,
        "awayId": 338,
        "awayTeam": "Kennesaw State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.01695317029953003,
        "awayPregameElo": 1285,
        "awayPostgameElo": 1284,
        "excitementIndex": 5.388692542832646,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860894,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3905,
        "venue": "Maverik Stadium",
        "homeId": 328,
        "homeTeam": "Utah State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 21,
        "homeLineScores": [
            7,
            0,
            14,
            0
        ],
        "homePostgameWinProbability": 0.9860266447067261,
        "homePregameElo": 1348,
        "homePostgameElo": 1374,
        "awayId": 2653,
        "awayTeam": "Troy",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 10,
        "awayLineScores": [
            7,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.013973355293273926,
        "awayPregameElo": 1421,
        "awayPostgameElo": 1395,
        "excitementIndex": 5.5326810230665355,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864572,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3670,
        "venue": "Carter-Finley Stadium",
        "homeId": 152,
        "homeTeam": "NC State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 41,
        "homeLineScores": [
            14,
            14,
            3,
            10
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1510,
        "homePostgameElo": 1514,
        "awayId": 2026,
        "awayTeam": "App State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 31,
        "awayLineScores": [
            0,
            10,
            7,
            14
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1324,
        "awayPostgameElo": 1320,
        "excitementIndex": 3.85214387880401,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856702,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3958,
        "venue": "Tiger Stadium (LA)",
        "homeId": 99,
        "homeTeam": "LSU",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 35,
        "homeLineScores": [
            7,
            7,
            21,
            0
        ],
        "homePostgameWinProbability": 0.9909849762916565,
        "homePregameElo": 1786,
        "homePostgameElo": 1868,
        "awayId": 245,
        "awayTeam": "Texas A&M",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 6,
        "awayLineScores": [
            0,
            3,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.009015023708343506,
        "awayPregameElo": 1824,
        "awayPostgameElo": 1742,
        "excitementIndex": 2.2734410877272273,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858469,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 477,
        "venue": "Los Angeles Memorial Coliseum",
        "homeId": 30,
        "homeTeam": "USC",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 27,
        "homeLineScores": [
            0,
            10,
            10,
            7
        ],
        "homePostgameWinProbability": 0.25431522727012634,
        "homePregameElo": 1817,
        "homePostgameElo": 1784,
        "awayId": 2483,
        "awayTeam": "Oregon",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 41,
        "awayLineScores": [
            3,
            10,
            14,
            14
        ],
        "awayPostgameWinProbability": 0.7456847727298737,
        "awayPregameElo": 1811,
        "awayPostgameElo": 1844,
        "excitementIndex": 6.699116589123444,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862783,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3825,
        "venue": "DATCU Stadium",
        "homeId": 249,
        "homeTeam": "North Texas",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 63,
        "homeLineScores": [
            14,
            21,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9887198209762573,
        "homePregameElo": 1662,
        "homePostgameElo": 1662,
        "awayId": 2277,
        "awayTeam": "Houston Christian",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.011280179023742676,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.903250242393854,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856804,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3820,
        "venue": "Gesa Field",
        "homeId": 265,
        "homeTeam": "Washington State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 24,
        "homeLineScores": [
            14,
            3,
            0,
            7
        ],
        "homePostgameWinProbability": 0.0026794152799993753,
        "homePregameElo": 1533,
        "homePostgameElo": 1521,
        "awayId": 12,
        "awayTeam": "Arizona",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 34,
        "awayLineScores": [
            7,
            7,
            7,
            13
        ],
        "awayPostgameWinProbability": 0.9973205847200006,
        "awayPregameElo": 1634,
        "awayPostgameElo": 1646,
        "excitementIndex": 5.895117948296565,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856703,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-26T23:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3693,
        "venue": "Davis Wade Stadium",
        "homeId": 344,
        "homeTeam": "Mississippi State",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 31,
        "homeLineScores": [
            14,
            0,
            3,
            14
        ],
        "homePostgameWinProbability": 0.3596450388431549,
        "homePregameElo": 1663,
        "homePostgameElo": 1674,
        "awayId": 142,
        "awayTeam": "Missouri",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 24,
        "awayLineScores": [
            0,
            10,
            14,
            0
        ],
        "awayPostgameWinProbability": 0.6403549611568451,
        "awayPregameElo": 1690,
        "awayPostgameElo": 1679,
        "excitementIndex": 6.647011263502548,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862782,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3817,
        "venue": "Malone Stadium",
        "homeId": 2433,
        "homeTeam": "UL Monroe",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 17,
        "homeLineScores": [
            7,
            10,
            0,
            0
        ],
        "homePostgameWinProbability": 0.08487337082624435,
        "homePregameElo": 1079,
        "homePostgameElo": 1022,
        "awayId": 2226,
        "awayTeam": "Florida Atlantic",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 45,
        "awayLineScores": [
            7,
            28,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.9151266291737556,
        "awayPregameElo": 1243,
        "awayPostgameElo": 1300,
        "excitementIndex": 4.822148686279762,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856697,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3887,
        "venue": "Razorback Stadium",
        "homeId": 8,
        "homeTeam": "Arkansas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 34,
        "homeLineScores": [
            10,
            6,
            7,
            11
        ],
        "homePostgameWinProbability": 0.9860058426856995,
        "homePregameElo": 1466,
        "homePostgameElo": 1516,
        "awayId": 202,
        "awayTeam": "Tulsa",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 6,
        "awayLineScores": [
            0,
            0,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.013994157314300537,
        "awayPregameElo": 1271,
        "awayPostgameElo": 1221,
        "excitementIndex": 2.1778321544728887,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866429,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3757,
        "venue": "Hornet Stadium",
        "homeId": 16,
        "homeTeam": "Sacramento State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 6,
        "homeLineScores": [
            0,
            6,
            0,
            0
        ],
        "homePostgameWinProbability": 0.007599536329507828,
        "homePregameElo": 1297,
        "homePostgameElo": 1185,
        "awayId": 113,
        "awayTeam": "Massachusetts",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 35,
        "awayLineScores": [
            7,
            14,
            14,
            0
        ],
        "awayPostgameWinProbability": 0.9924004636704922,
        "awayPregameElo": 1076,
        "awayPostgameElo": 1188,
        "excitementIndex": 3.6890494155371187,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860895,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3946,
        "venue": "Sun Bowl",
        "homeId": 2638,
        "homeTeam": "UTEP",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 7,
        "homeLineScores": [
            0,
            0,
            7,
            0
        ],
        "homePostgameWinProbability": 0.03515193238854408,
        "homePregameElo": 1130,
        "homePostgameElo": 1078,
        "awayId": 204,
        "awayTeam": "Oregon State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 33,
        "awayLineScores": [
            17,
            3,
            7,
            6
        ],
        "awayPostgameWinProbability": 0.9648480676114559,
        "awayPregameElo": 1285,
        "awayPostgameElo": 1337,
        "excitementIndex": 4.3919418362268345,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858241,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3735,
        "venue": "Gerald J. Ford Stadium",
        "homeId": 2567,
        "homeTeam": "SMU",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 34,
        "homeLineScores": [
            0,
            14,
            7,
            13
        ],
        "homePostgameWinProbability": 0.9805787801742554,
        "homePregameElo": 1706,
        "homePostgameElo": 1695,
        "awayId": 2623,
        "awayTeam": "Missouri State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 24,
        "awayLineScores": [
            10,
            0,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.01942121982574463,
        "awayPregameElo": 1281,
        "awayPostgameElo": 1292,
        "excitementIndex": 5.032704053568597,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860891,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3660,
        "venue": "Valley Children's Stadium",
        "homeId": 278,
        "homeTeam": "Fresno State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 38,
        "homeLineScores": [
            0,
            14,
            10,
            14
        ],
        "homePostgameWinProbability": 0.8269332051277161,
        "homePregameElo": 1611,
        "homePostgameElo": 1604,
        "awayId": 242,
        "awayTeam": "Rice",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 24,
        "awayLineScores": [
            7,
            10,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.17306679487228394,
        "awayPregameElo": 1162,
        "awayPostgameElo": 1169,
        "excitementIndex": 5.138066437526457,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858240,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3940,
        "venue": "Stanford Stadium",
        "homeId": 24,
        "homeTeam": "Stanford",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 34,
        "homeLineScores": [
            7,
            3,
            17,
            7
        ],
        "homePostgameWinProbability": 0.9169948697090149,
        "homePregameElo": 1311,
        "homePostgameElo": 1333,
        "awayId": 59,
        "awayTeam": "Georgia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 27,
        "awayLineScores": [
            10,
            10,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.08300513029098511,
        "awayPregameElo": 1515,
        "awayPostgameElo": 1493,
        "excitementIndex": 6.637513719856492,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864509,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3816,
        "venue": "Mackay Stadium",
        "homeId": 2440,
        "homeTeam": "Nevada",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 33,
        "homeLineScores": [
            10,
            0,
            7,
            10,
            6
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1441,
        "homePostgameElo": 1435,
        "awayId": 2005,
        "awayTeam": "Air Force",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 36,
        "awayLineScores": [
            3,
            7,
            3,
            14,
            9
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1423,
        "awayPostgameElo": 1429,
        "excitementIndex": 9.923571121258782,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858470,
        "season": 2026,
        "week": 4,
        "seasonType": "regular",
        "startDate": "2026-09-27T03:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3765,
        "venue": "Husky Stadium",
        "homeId": 264,
        "homeTeam": "Washington",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 24,
        "homeLineScores": [
            0,
            10,
            0,
            14
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1757,
        "homePostgameElo": 1735,
        "awayId": 135,
        "awayTeam": "Minnesota",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 27,
        "awayLineScores": [
            14,
            7,
            3,
            3
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1484,
        "awayPostgameElo": 1506,
        "excitementIndex": 4.3491841477312905,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871049,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-02T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3601,
        "venue": "Aggie Memorial Stadium",
        "homeId": 166,
        "homeTeam": "New Mexico State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 34,
        "homeLineScores": [
            6,
            14,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9956599473953247,
        "homePregameElo": 1231,
        "homePostgameElo": 1282,
        "awayId": 98,
        "awayTeam": "Western Kentucky",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 13,
        "awayLineScores": [
            3,
            3,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.004340052604675293,
        "awayPregameElo": 1242,
        "awayPostgameElo": 1191,
        "excitementIndex": 3.645225100103533,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862786,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-02T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3674,
        "venue": "Chapman Stadium",
        "homeId": 202,
        "homeTeam": "Tulsa",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 44,
        "homeLineScores": [
            0,
            17,
            7,
            14,
            6
        ],
        "homePostgameWinProbability": 0.5476754307746887,
        "homePregameElo": 1221,
        "homePostgameElo": 1238,
        "awayId": 249,
        "awayTeam": "North Texas",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 45,
        "awayLineScores": [
            3,
            7,
            21,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.4523245692253113,
        "awayPregameElo": 1646,
        "awayPostgameElo": 1629,
        "excitementIndex": 9.178704480523782,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871050,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-02T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3695,
        "venue": "Delaware Stadium",
        "homeId": 48,
        "homeTeam": "Delaware",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 14,
        "homeLineScores": [
            0,
            0,
            0,
            14
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1328,
        "homePostgameElo": 1328,
        "awayId": 2335,
        "awayTeam": "Liberty",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 30,
        "awayLineScores": [
            6,
            14,
            3,
            7
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1725,
        "awayPostgameElo": 1725,
        "excitementIndex": 2.815466784134099,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858245,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-02T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3799,
        "venue": "Lane Stadium",
        "homeId": 259,
        "homeTeam": "Virginia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 33,
        "homeLineScores": [
            14,
            10,
            0,
            9
        ],
        "homePostgameWinProbability": 0.4889671206474304,
        "homePregameElo": 1494,
        "homePostgameElo": 1501,
        "awayId": 221,
        "awayTeam": "Pittsburgh",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 35,
        "awayLineScores": [
            7,
            14,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.5110328793525696,
        "awayPregameElo": 1675,
        "awayPostgameElo": 1668,
        "excitementIndex": 8.589521676333588,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858476,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 11823,
        "venue": "Ryan Field",
        "homeId": 77,
        "homeTeam": "Northwestern",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 34,
        "homeLineScores": [
            10,
            14,
            7,
            3
        ],
        "homePostgameWinProbability": 0.9702258110046387,
        "homePregameElo": 1640,
        "homePostgameElo": 1720,
        "awayId": 213,
        "awayTeam": "Penn State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            7,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.029774188995361328,
        "awayPregameElo": 1901,
        "awayPostgameElo": 1821,
        "excitementIndex": 2.8401246527817596,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862787,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T15:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4418,
        "venue": "Jerry Richardson Stadium",
        "homeId": 2429,
        "homeTeam": "Charlotte",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 8,
        "homeLineScores": [
            0,
            0,
            8,
            0
        ],
        "homePostgameWinProbability": 0.035076938569545746,
        "homePregameElo": 1123,
        "homePostgameElo": 1022,
        "awayId": 235,
        "awayTeam": "Memphis",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 59,
        "awayLineScores": [
            14,
            10,
            21,
            14
        ],
        "awayPostgameWinProbability": 0.9649230614304543,
        "awayPregameElo": 1526,
        "awayPostgameElo": 1627,
        "excitementIndex": 2.532662790749484,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858246,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3735,
        "venue": "Gerald J. Ford Stadium",
        "homeId": 2567,
        "homeTeam": "SMU",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 25,
        "homeLineScores": [
            6,
            7,
            6,
            6
        ],
        "homePostgameWinProbability": 0.7583794593811035,
        "homePregameElo": 1695,
        "homePostgameElo": 1689,
        "awayId": 103,
        "awayTeam": "Boston College",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 16,
        "awayLineScores": [
            10,
            0,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.24162054061889648,
        "awayPregameElo": 1375,
        "awayPostgameElo": 1381,
        "excitementIndex": 5.075198211482828,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858251,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3630,
        "venue": "Allegacy Federal Credit Union Stadium",
        "homeId": 154,
        "homeTeam": "Wake Forest",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 57,
        "homeLineScores": [
            15,
            14,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9946141839027405,
        "homePregameElo": 1530,
        "homePostgameElo": 1669,
        "awayId": 24,
        "awayTeam": "Stanford",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0053858160972595215,
        "awayPregameElo": 1333,
        "awayPostgameElo": 1194,
        "excitementIndex": 2.643082689114888,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856819,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4728,
        "venue": "TDECU Stadium",
        "homeId": 248,
        "homeTeam": "Houston",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 27,
        "homeLineScores": [
            0,
            0,
            14,
            13
        ],
        "homePostgameWinProbability": 0.9425193071365356,
        "homePregameElo": 1535,
        "homePostgameElo": 1550,
        "awayId": 2116,
        "awayTeam": "UCF",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 17,
        "awayLineScores": [
            7,
            3,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.057480692863464355,
        "awayPregameElo": 1503,
        "awayPostgameElo": 1488,
        "excitementIndex": 4.823941199047085,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858252,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3892,
        "venue": "Pratt & Whitney Stadium",
        "homeId": 41,
        "homeTeam": "UConn",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": 41,
        "homeLineScores": [
            7,
            7,
            6,
            14,
            7
        ],
        "homePostgameWinProbability": 0.03171622008085251,
        "homePregameElo": 1470,
        "homePostgameElo": 1460,
        "awayId": 183,
        "awayTeam": "Syracuse",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 42,
        "awayLineScores": [
            6,
            21,
            7,
            0,
            8
        ],
        "awayPostgameWinProbability": 0.9682837799191475,
        "awayPregameElo": 1290,
        "awayPostgameElo": 1300,
        "excitementIndex": 8.43005733896295,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856707,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3693,
        "venue": "Davis Wade Stadium",
        "homeId": 344,
        "homeTeam": "Mississippi State",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 23,
        "homeLineScores": [
            7,
            10,
            6,
            0
        ],
        "homePostgameWinProbability": 0.005353123880922794,
        "homePregameElo": 1674,
        "homePostgameElo": 1612,
        "awayId": 333,
        "awayTeam": "Alabama",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 56,
        "awayLineScores": [
            14,
            14,
            14,
            14
        ],
        "awayPostgameWinProbability": 0.9946468761190772,
        "awayPregameElo": 1929,
        "awayPostgameElo": 1991,
        "excitementIndex": 4.692304878277608,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858474,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3953,
        "venue": "Huntington Bank Stadium",
        "homeId": 135,
        "homeTeam": "Minnesota",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 20,
        "homeLineScores": [
            7,
            0,
            3,
            10
        ],
        "homePostgameWinProbability": 0.8947822451591492,
        "homePregameElo": 1506,
        "homePostgameElo": 1526,
        "awayId": 130,
        "awayTeam": "Michigan",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            14,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.10521775484085083,
        "awayPregameElo": 1739,
        "awayPostgameElo": 1719,
        "excitementIndex": 5.135040566968979,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858250,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3787,
        "venue": "Kenan Stadium",
        "homeId": 153,
        "homeTeam": "North Carolina",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 26,
        "homeLineScores": [
            7,
            7,
            6,
            6
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1396,
        "homePostgameElo": 1426,
        "awayId": 87,
        "awayTeam": "Notre Dame",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": 37,
        "awayLineScores": [
            14,
            7,
            6,
            10
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 2084,
        "awayPostgameElo": 2054,
        "excitementIndex": 4.5359298654309725,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862791,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3713,
        "venue": "Falcon Stadium",
        "homeId": 2005,
        "homeTeam": "Air Force",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 14,
        "homeLineScores": [
            0,
            14,
            0,
            0
        ],
        "homePostgameWinProbability": 0.4444858133792877,
        "homePregameElo": 1429,
        "homePostgameElo": 1437,
        "awayId": 2426,
        "awayTeam": "Navy",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 9,
        "awayLineScores": [
            0,
            3,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.5555141866207123,
        "awayPregameElo": 1506,
        "awayPostgameElo": 1498,
        "excitementIndex": 4.162410320149281,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856822,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3772,
        "venue": "Jack Trice Stadium",
        "homeId": 66,
        "homeTeam": "Iowa State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 45,
        "homeLineScores": [
            7,
            14,
            7,
            17
        ],
        "homePostgameWinProbability": 0.6174993515014648,
        "homePregameElo": 1672,
        "homePostgameElo": 1669,
        "awayId": 277,
        "awayTeam": "West Virginia",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 42,
        "awayLineScores": [
            7,
            7,
            14,
            14
        ],
        "awayPostgameWinProbability": 0.38250064849853516,
        "awayPregameElo": 1352,
        "awayPostgameElo": 1355,
        "excitementIndex": 7.433361650036701,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856807,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3833,
        "venue": "Memorial Stadium",
        "homeId": 2305,
        "homeTeam": "Kansas",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 55,
        "homeLineScores": [
            3,
            17,
            14,
            21
        ],
        "homePostgameWinProbability": 0.9911808371543884,
        "homePregameElo": 1481,
        "homePostgameElo": 1625,
        "awayId": 2393,
        "awayTeam": "Middle Tennessee",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.008819162845611572,
        "awayPregameElo": 1290,
        "awayPostgameElo": 1146,
        "excitementIndex": 2.218614161166433,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858479,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 347,
        "venue": "Camp Randall Stadium",
        "homeId": 275,
        "homeTeam": "Wisconsin",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 31,
        "homeLineScores": [
            14,
            3,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9267917275428772,
        "homePregameElo": 1612,
        "homePostgameElo": 1673,
        "awayId": 127,
        "awayTeam": "Michigan State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0732082724571228,
        "awayPregameElo": 1510,
        "awayPostgameElo": 1449,
        "excitementIndex": 2.3447012755899217,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856705,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T16:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3917,
        "venue": "Sanford Stadium",
        "homeId": 61,
        "homeTeam": "Georgia",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 38,
        "homeLineScores": [
            7,
            14,
            7,
            10
        ],
        "homePostgameWinProbability": 0.9678956866264343,
        "homePregameElo": 2023,
        "homePostgameElo": 2052,
        "awayId": 238,
        "awayTeam": "Vanderbilt",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.032104313373565674,
        "awayPregameElo": 1731,
        "awayPostgameElo": 1702,
        "excitementIndex": 3.3109500340673255,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866432,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3965,
        "venue": "UB Stadium",
        "homeId": 2084,
        "homeTeam": "Buffalo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 17,
        "homeLineScores": [
            7,
            7,
            0,
            3
        ],
        "homePostgameWinProbability": 0.3350275456905365,
        "homePregameElo": 1288,
        "homePostgameElo": 1294,
        "awayId": 2711,
        "awayTeam": "Western Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 20,
        "awayLineScores": [
            7,
            3,
            0,
            10
        ],
        "awayPostgameWinProbability": 0.6649724543094635,
        "awayPregameElo": 1463,
        "awayPostgameElo": 1457,
        "excitementIndex": 5.642200631025459,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866431,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3919,
        "venue": "Scheumann Stadium",
        "homeId": 2050,
        "homeTeam": "Ball State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 24,
        "homeLineScores": [
            7,
            3,
            7,
            7
        ],
        "homePostgameWinProbability": 0.09331406652927399,
        "homePregameElo": 1049,
        "homePostgameElo": 1065,
        "awayId": 2649,
        "awayTeam": "Toledo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 39,
        "awayLineScores": [
            6,
            9,
            7,
            17
        ],
        "awayPostgameWinProbability": 0.906685933470726,
        "awayPregameElo": 1614,
        "awayPostgameElo": 1598,
        "excitementIndex": 6.143312682675779,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856710,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3853,
        "venue": "Neyland Stadium",
        "homeId": 2633,
        "homeTeam": "Tennessee",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 24,
        "homeLineScores": [
            0,
            3,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9807823300361633,
        "homePregameElo": 1776,
        "homePostgameElo": 1786,
        "awayId": 2,
        "awayTeam": "Auburn",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.01921766996383667,
        "awayPregameElo": 1679,
        "awayPostgameElo": 1669,
        "excitementIndex": 5.662936554553704,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866477,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3996,
        "venue": "Yager Stadium",
        "homeId": 193,
        "homeTeam": "Miami (OH)",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 20,
        "homeLineScores": [
            0,
            6,
            3,
            11
        ],
        "homePostgameWinProbability": 0.6265079379081726,
        "homePregameElo": 1267,
        "homePostgameElo": 1253,
        "awayId": 189,
        "awayTeam": "Bowling Green",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 24,
        "awayLineScores": [
            0,
            10,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.3734920620918274,
        "awayPregameElo": 1156,
        "awayPostgameElo": 1170,
        "excitementIndex": 7.091780467548417,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862793,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 7221,
        "venue": "Protective Stadium",
        "homeId": 5,
        "homeTeam": "UAB",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 33,
        "homeLineScores": [
            10,
            3,
            3,
            17
        ],
        "homePostgameWinProbability": 0.9913856387138367,
        "homePregameElo": 1400,
        "homePostgameElo": 1400,
        "awayId": 2535,
        "awayTeam": "Samford",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": 14,
        "awayLineScores": [
            7,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.00861436128616333,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 5.240117480374941,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866433,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3985,
        "venue": "Warren McGuirk Alumni Stadium",
        "homeId": 113,
        "homeTeam": "Massachusetts",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 14,
        "homeLineScores": [
            0,
            7,
            0,
            7
        ],
        "homePostgameWinProbability": 0.11339150369167328,
        "homePregameElo": 1188,
        "homePostgameElo": 1124,
        "awayId": 2199,
        "awayTeam": "Eastern Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            7,
            14,
            10
        ],
        "awayPostgameWinProbability": 0.8866084963083267,
        "awayPregameElo": 1188,
        "awayPostgameElo": 1252,
        "excitementIndex": 3.5605968582570156,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858247,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 6501,
        "venue": "Allegiant Stadium",
        "homeId": 2439,
        "homeTeam": "UNLV",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 39,
        "homeLineScores": [
            7,
            17,
            0,
            15
        ],
        "homePostgameWinProbability": 0.9526850581169128,
        "homePregameElo": 1491,
        "homePostgameElo": 1494,
        "awayId": 25,
        "awayTeam": "California",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 31,
        "awayLineScores": [
            7,
            0,
            11,
            13
        ],
        "awayPostgameWinProbability": 0.04731494188308716,
        "awayPregameElo": 1338,
        "awayPostgameElo": 1335,
        "excitementIndex": 5.9039498929902905,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866434,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3696,
        "venue": "Dix Stadium",
        "homeId": 2309,
        "homeTeam": "Kent State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 10,
        "homeLineScores": [
            0,
            3,
            7,
            0
        ],
        "homePostgameWinProbability": 0.32623523473739624,
        "homePregameElo": 1039,
        "homePostgameElo": 1050,
        "awayId": 195,
        "awayTeam": "Ohio",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 13,
        "awayLineScores": [
            3,
            7,
            3,
            0
        ],
        "awayPostgameWinProbability": 0.6737647652626038,
        "awayPregameElo": 1318,
        "awayPostgameElo": 1307,
        "excitementIndex": 7.291537627201257,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858248,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3670,
        "venue": "Carter-Finley Stadium",
        "homeId": 152,
        "homeTeam": "NC State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 31,
        "homeLineScores": [
            3,
            10,
            15,
            3
        ],
        "homePostgameWinProbability": 0.8300904631614685,
        "homePregameElo": 1514,
        "homePostgameElo": 1517,
        "awayId": 97,
        "awayTeam": "Louisville",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 28,
        "awayLineScores": [
            0,
            7,
            14,
            7
        ],
        "awayPostgameWinProbability": 0.1699095368385315,
        "awayPregameElo": 1674,
        "awayPostgameElo": 1671,
        "excitementIndex": 5.862126229860792,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869956,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4246,
        "venue": "Center Parc Stadium",
        "homeId": 2247,
        "homeTeam": "Georgia State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 42,
        "homeLineScores": [
            14,
            14,
            14,
            0
        ],
        "homePostgameWinProbability": 0.9976320266723633,
        "homePregameElo": 1320,
        "homePostgameElo": 1402,
        "awayId": 295,
        "awayTeam": "Old Dominion",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.0023679733276367188,
        "awayPregameElo": 1279,
        "awayPostgameElo": 1197,
        "excitementIndex": 2.7635259418799105,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858253,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3697,
        "venue": "Doak Campbell Stadium",
        "homeId": 52,
        "homeTeam": "Florida State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 38,
        "homeLineScores": [
            0,
            17,
            14,
            7
        ],
        "homePostgameWinProbability": 0.9962074756622314,
        "homePregameElo": 1553,
        "homePostgameElo": 1656,
        "awayId": 258,
        "awayTeam": "Virginia",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0037925243377685547,
        "awayPregameElo": 1698,
        "awayPostgameElo": 1595,
        "excitementIndex": 3.7669042045643755,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866430,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3786,
        "venue": "Kelly/Shorts Stadium",
        "homeId": 2117,
        "homeTeam": "Central Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 41,
        "homeLineScores": [
            0,
            21,
            14,
            6
        ],
        "homePostgameWinProbability": 0.9662176966667175,
        "homePregameElo": 1224,
        "homePostgameElo": 1248,
        "awayId": 2006,
        "awayTeam": "Akron",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 17,
        "awayLineScores": [
            0,
            7,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.03378230333328247,
        "awayPregameElo": 886,
        "awayPostgameElo": 862,
        "excitementIndex": 3.976102476112796,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858473,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3793,
        "venue": "Kinnick Stadium",
        "homeId": 2294,
        "homeTeam": "Iowa",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 14,
        "homeLineScores": [
            6,
            0,
            0,
            8
        ],
        "homePostgameWinProbability": 0.0027711866423487663,
        "homePregameElo": 1841,
        "homePostgameElo": 1821,
        "awayId": 194,
        "awayTeam": "Ohio State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 31,
        "awayLineScores": [
            10,
            7,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.9972288133576512,
        "awayPregameElo": 2044,
        "awayPostgameElo": 2064,
        "excitementIndex": 3.9270304956729296,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856708,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3838,
        "venue": "Memorial Stadium",
        "homeId": 142,
        "homeTeam": "Missouri",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 45,
        "homeLineScores": [
            3,
            17,
            10,
            15
        ],
        "homePostgameWinProbability": 0.883412778377533,
        "homePregameElo": 1679,
        "homePostgameElo": 1761,
        "awayId": 57,
        "awayTeam": "Florida",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 17,
        "awayLineScores": [
            3,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.11658722162246704,
        "awayPregameElo": 1751,
        "awayPostgameElo": 1669,
        "excitementIndex": 4.331333996636084,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864515,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3714,
        "venue": "Fargodome",
        "homeId": 2449,
        "homeTeam": "North Dakota State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 28,
        "homeLineScores": [
            7,
            10,
            3,
            8
        ],
        "homePostgameWinProbability": 0.9897133708000183,
        "homePregameElo": 1594,
        "homePostgameElo": 1636,
        "awayId": 2751,
        "awayTeam": "Wyoming",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 0,
        "awayLineScores": [
            0,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.01028662919998169,
        "awayPregameElo": 1322,
        "awayPostgameElo": 1280,
        "excitementIndex": 1.957773990495417,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869962,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T19:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3651,
        "venue": "Bridgeforth Stadium",
        "homeId": 256,
        "homeTeam": "James Madison",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 45,
        "homeLineScores": [
            10,
            28,
            0,
            7
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1793,
        "homePostgameElo": 1821,
        "awayId": 276,
        "awayTeam": "Marshall",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 17,
        "awayLineScores": [
            7,
            7,
            3,
            0
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1391,
        "awayPostgameElo": 1363,
        "excitementIndex": 4.165137838321348,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858475,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3834,
        "venue": "Memorial Stadium (Lincoln, NE)",
        "homeId": 158,
        "homeTeam": "Nebraska",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 48,
        "homeLineScores": [
            7,
            21,
            0,
            20
        ],
        "homePostgameWinProbability": 0.9956637024879456,
        "homePregameElo": 1732,
        "homePostgameElo": 1751,
        "awayId": 120,
        "awayTeam": "Maryland",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 23,
        "awayLineScores": [
            16,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.004336297512054443,
        "awayPregameElo": 1316,
        "awayPostgameElo": 1297,
        "excitementIndex": 6.045121883257123,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864514,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3971,
        "venue": "University Stadium (NM)",
        "homeId": 167,
        "homeTeam": "New Mexico",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 61,
        "homeLineScores": [
            14,
            7,
            16,
            24
        ],
        "homePostgameWinProbability": 0.9931564331054688,
        "homePregameElo": 1589,
        "homePostgameElo": 1683,
        "awayId": 2638,
        "awayTeam": "UTEP",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.00684356689453125,
        "awayPregameElo": 1078,
        "awayPostgameElo": 984,
        "excitementIndex": 2.873179026852267,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858472,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3832,
        "venue": "Memorial Stadium (Champaign, IL)",
        "homeId": 356,
        "homeTeam": "Illinois",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 17,
        "homeLineScores": [
            0,
            7,
            0,
            10
        ],
        "homePostgameWinProbability": 0.04809911176562309,
        "homePregameElo": 1577,
        "homePostgameElo": 1539,
        "awayId": 2509,
        "awayTeam": "Purdue",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 24,
        "awayLineScores": [
            3,
            10,
            3,
            8
        ],
        "awayPostgameWinProbability": 0.9519008882343769,
        "awayPregameElo": 1288,
        "awayPostgameElo": 1326,
        "excitementIndex": 4.787842886848418,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856709,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3994,
        "venue": "Williams-Brice Stadium",
        "homeId": 2579,
        "homeTeam": "South Carolina",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 34,
        "homeLineScores": [
            14,
            6,
            0,
            7,
            7
        ],
        "homePostgameWinProbability": 0.1789211928844452,
        "homePregameElo": 1655,
        "homePostgameElo": 1649,
        "awayId": 96,
        "awayTeam": "Kentucky",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 35,
        "awayLineScores": [
            0,
            10,
            14,
            3,
            8
        ],
        "awayPostgameWinProbability": 0.8210788071155548,
        "awayPregameElo": 1553,
        "awayPostgameElo": 1559,
        "excitementIndex": 8.515613518542256,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860899,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 5388,
        "venue": "Canvas Stadium",
        "homeId": 36,
        "homeTeam": "Colorado State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 26,
        "homeLineScores": [
            7,
            7,
            6,
            6
        ],
        "homePostgameWinProbability": 0.2153664082288742,
        "homePregameElo": 1314,
        "homePostgameElo": 1233,
        "awayId": 204,
        "awayTeam": "Oregon State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 56,
        "awayLineScores": [
            14,
            21,
            7,
            14
        ],
        "awayPostgameWinProbability": 0.7846335917711258,
        "awayPregameElo": 1337,
        "awayPostgameElo": 1418,
        "excitementIndex": 3.7250906538894744,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862790,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3715,
        "venue": "FAU Stadium",
        "homeId": 2226,
        "homeTeam": "Florida Atlantic",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 66,
        "homeLineScores": [
            28,
            21,
            10,
            7
        ],
        "homePostgameWinProbability": 0.9320746660232544,
        "homePregameElo": 1314,
        "homePostgameElo": 1314,
        "awayId": 2640,
        "awayTeam": "Texas Southern",
        "awayClassification": "fcs",
        "awayConference": "SWAC",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.0679253339767456,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 1.893677319054822,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862788,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3895,
        "venue": "Rice Stadium",
        "homeId": 242,
        "homeTeam": "Rice",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 14,
        "homeLineScores": [
            7,
            0,
            0,
            7
        ],
        "homePostgameWinProbability": 0.20610922574996948,
        "homePregameElo": 1169,
        "homePostgameElo": 1184,
        "awayId": 2636,
        "awayTeam": "UTSA",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 16,
        "awayLineScores": [
            6,
            10,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.7938907742500305,
        "awayPregameElo": 1519,
        "awayPostgameElo": 1504,
        "excitementIndex": 6.087824749841565,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856818,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3616,
        "venue": "Amon G. Carter Stadium",
        "homeId": 2628,
        "homeTeam": "TCU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 10,
        "homeLineScores": [
            0,
            7,
            0,
            3
        ],
        "homePostgameWinProbability": 0.33925971388816833,
        "homePregameElo": 1607,
        "homePostgameElo": 1600,
        "awayId": 252,
        "awayTeam": "BYU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 17,
        "awayLineScores": [
            0,
            7,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.6607402861118317,
        "awayPregameElo": 1692,
        "awayPostgameElo": 1699,
        "excitementIndex": 4.736900224396812,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871089,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6526,
        "venue": "Hancock Whitney Stadium",
        "homeId": 6,
        "homeTeam": "South Alabama",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 52,
        "homeLineScores": [
            21,
            10,
            14,
            7
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1346,
        "homePostgameElo": 1354,
        "awayId": 2433,
        "awayTeam": "UL Monroe",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 35,
        "awayLineScores": [
            7,
            7,
            14,
            7
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1022,
        "awayPostgameElo": 1014,
        "excitementIndex": 2.5634407183986836,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869942,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3654,
        "venue": "Brooks Stadium (SC)",
        "homeId": 324,
        "homeTeam": "Coastal Carolina",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 24,
        "homeLineScores": [
            0,
            10,
            7,
            7
        ],
        "homePostgameWinProbability": 0.030554279685020447,
        "homePregameElo": 1270,
        "homePostgameElo": 1262,
        "awayId": 290,
        "awayTeam": "Georgia Southern",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 31,
        "awayLineScores": [
            10,
            7,
            0,
            14
        ],
        "awayPostgameWinProbability": 0.9694457203149796,
        "awayPregameElo": 1341,
        "awayPostgameElo": 1349,
        "excitementIndex": 5.024180046867894,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856711,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3795,
        "venue": "Kyle Field",
        "homeId": 245,
        "homeTeam": "Texas A&M",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 34,
        "homeLineScores": [
            14,
            10,
            7,
            3
        ],
        "homePostgameWinProbability": 0.9772444367408752,
        "homePregameElo": 1742,
        "homePostgameElo": 1786,
        "awayId": 8,
        "awayTeam": "Arkansas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 7,
        "awayLineScores": [
            7,
            0,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.022755563259124756,
        "awayPregameElo": 1516,
        "awayPostgameElo": 1472,
        "excitementIndex": 2.798006488918313,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858478,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 477,
        "venue": "Los Angeles Memorial Coliseum",
        "homeId": 30,
        "homeTeam": "USC",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 25,
        "homeLineScores": [
            3,
            7,
            12,
            3
        ],
        "homePostgameWinProbability": 0.8316252827644348,
        "homePregameElo": 1784,
        "homePostgameElo": 1785,
        "awayId": 264,
        "awayTeam": "Washington",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 21,
        "awayLineScores": [
            7,
            7,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.16837471723556519,
        "awayPregameElo": 1735,
        "awayPostgameElo": 1734,
        "excitementIndex": 6.958558692468312,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860898,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3653,
        "venue": "Albertsons Stadium",
        "homeId": 68,
        "homeTeam": "Boise State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 37,
        "homeLineScores": [
            14,
            14,
            3,
            6
        ],
        "homePostgameWinProbability": 0.9931004047393799,
        "homePregameElo": 1665,
        "homePostgameElo": 1681,
        "awayId": 328,
        "awayTeam": "Utah State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 18,
        "awayLineScores": [
            0,
            10,
            0,
            8
        ],
        "awayPostgameWinProbability": 0.006899595260620117,
        "awayPregameElo": 1374,
        "awayPostgameElo": 1358,
        "excitementIndex": 2.474974242737391,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869842,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3776,
        "venue": "Joe Aillet Stadium",
        "homeId": 2348,
        "homeTeam": "Louisiana Tech",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 31,
        "homeLineScores": [
            7,
            7,
            14,
            3
        ],
        "homePostgameWinProbability": 0.6970677971839905,
        "homePregameElo": 1377,
        "homePostgameElo": 1379,
        "awayId": 349,
        "awayTeam": "Army",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 29,
        "awayLineScores": [
            7,
            0,
            8,
            14
        ],
        "awayPostgameWinProbability": 0.3029322028160095,
        "awayPregameElo": 1524,
        "awayPostgameElo": 1522,
        "excitementIndex": 6.068752144446249,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856821,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3726,
        "venue": "Folsom Field",
        "homeId": 38,
        "homeTeam": "Colorado",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 7,
        "homeLineScores": [
            7,
            0,
            0,
            0
        ],
        "homePostgameWinProbability": 0.3495481610298157,
        "homePregameElo": 1327,
        "homePostgameElo": 1325,
        "awayId": 2641,
        "awayTeam": "Texas Tech",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 29,
        "awayLineScores": [
            3,
            0,
            9,
            17
        ],
        "awayPostgameWinProbability": 0.6504518389701843,
        "awayPregameElo": 1860,
        "awayPostgameElo": 1862,
        "excitementIndex": 5.74389753418718,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862792,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3886,
        "venue": "Raymond James Stadium",
        "homeId": 58,
        "homeTeam": "South Florida",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 13,
        "homeLineScores": [
            3,
            0,
            7,
            3
        ],
        "homePostgameWinProbability": 0.2204078882932663,
        "homePregameElo": 1652,
        "homePostgameElo": 1623,
        "awayId": 218,
        "awayTeam": "Temple",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 17,
        "awayLineScores": [
            0,
            10,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.7795921117067337,
        "awayPregameElo": 1336,
        "awayPostgameElo": 1365,
        "excitementIndex": 4.978677040544546,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858249,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3836,
        "venue": "Memorial Stadium (Clemson, SC)",
        "homeId": 228,
        "homeTeam": "Clemson",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 13,
        "homeLineScores": [
            3,
            3,
            0,
            7
        ],
        "homePostgameWinProbability": 0.03666641563177109,
        "homePregameElo": 1572,
        "homePostgameElo": 1541,
        "awayId": 2390,
        "awayTeam": "Miami",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 41,
        "awayLineScores": [
            10,
            7,
            7,
            17
        ],
        "awayPostgameWinProbability": 0.9633335843682289,
        "awayPregameElo": 1962,
        "awayPostgameElo": 1993,
        "excitementIndex": 3.6376306966824457,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856706,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-03T23:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3958,
        "venue": "Tiger Stadium (LA)",
        "homeId": 99,
        "homeTeam": "LSU",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 63,
        "homeLineScores": [
            14,
            21,
            14,
            14
        ],
        "homePostgameWinProbability": 0.9917916059494019,
        "homePregameElo": 1736,
        "homePostgameElo": 1736,
        "awayId": 2377,
        "awayTeam": "McNeese",
        "awayClassification": "fcs",
        "awayConference": "Southland",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            0,
            14,
            0
        ],
        "awayPostgameWinProbability": 0.008208394050598145,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": 2.287826999888987,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869932,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-04T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3666,
        "venue": "Cajun Field",
        "homeId": 309,
        "homeTeam": "Louisiana",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 23,
        "homeLineScores": [
            7,
            0,
            3,
            13
        ],
        "homePostgameWinProbability": 0.8674270510673523,
        "homePregameElo": 1443,
        "homePostgameElo": 1442,
        "awayId": 2032,
        "awayTeam": "Arkansas State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 20,
        "awayLineScores": [
            0,
            10,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.1325729489326477,
        "awayPregameElo": 1320,
        "awayPostgameElo": 1321,
        "excitementIndex": 5.6318319316177865,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858477,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-04T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6577,
        "venue": "SHI Stadium",
        "homeId": 164,
        "homeTeam": "Rutgers",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 15,
        "homeLineScores": [
            0,
            0,
            7,
            8
        ],
        "homePostgameWinProbability": 0.023024221882224083,
        "homePregameElo": 1391,
        "homePostgameElo": 1383,
        "awayId": 84,
        "awayTeam": "Indiana",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 47,
        "awayLineScores": [
            10,
            13,
            14,
            10
        ],
        "awayPostgameWinProbability": 0.9769757781177759,
        "awayPregameElo": 2106,
        "awayPostgameElo": 2114,
        "excitementIndex": 2.397520527927256,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860921,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-04T01:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3820,
        "venue": "Gesa Field",
        "homeId": 265,
        "homeTeam": "Washington State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 6,
        "homeLineScores": [
            0,
            6,
            0,
            0
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1521,
        "homePostgameElo": 1480,
        "awayId": 278,
        "awayTeam": "Fresno State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 26,
        "awayLineScores": [
            3,
            3,
            7,
            13
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1604,
        "awayPostgameElo": 1645,
        "excitementIndex": 4.894603494960914,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856817,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-04T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3947,
        "venue": "Mountain America Stadium",
        "homeId": 9,
        "homeTeam": "Arizona State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 19,
        "homeLineScores": [
            3,
            10,
            3,
            3
        ],
        "homePostgameWinProbability": 0.015242117457091808,
        "homePregameElo": 1535,
        "homePostgameElo": 1429,
        "awayId": 239,
        "awayTeam": "Baylor",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 55,
        "awayLineScores": [
            14,
            10,
            21,
            10
        ],
        "awayPostgameWinProbability": 0.9847578825429082,
        "awayPregameElo": 1537,
        "awayPostgameElo": 1643,
        "excitementIndex": 4.173738824794729,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860900,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-04T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7311,
        "venue": "Snapdragon Stadium",
        "homeId": 21,
        "homeTeam": "San Diego State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 31,
        "homeLineScores": [
            3,
            0,
            21,
            7
        ],
        "homePostgameWinProbability": 0.5365890860557556,
        "homePregameElo": 1415,
        "homePostgameElo": 1417,
        "awayId": 326,
        "awayTeam": "Texas State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 29,
        "awayLineScores": [
            10,
            7,
            0,
            12
        ],
        "awayPostgameWinProbability": 0.4634109139442444,
        "awayPregameElo": 1491,
        "awayPostgameElo": 1489,
        "excitementIndex": 9.091327985007027,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856820,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-04T03:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3619,
        "venue": "Arizona Stadium",
        "homeId": 12,
        "homeTeam": "Arizona",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 34,
        "homeLineScores": [
            7,
            3,
            14,
            10
        ],
        "homePostgameWinProbability": 0.9906310439109802,
        "homePregameElo": 1646,
        "homePostgameElo": 1702,
        "awayId": 2132,
        "awayTeam": "Cincinnati",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.009368956089019775,
        "awayPregameElo": 1525,
        "awayPostgameElo": 1469,
        "excitementIndex": 2.6648744359923286,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864513,
        "season": 2026,
        "week": 5,
        "seasonType": "regular",
        "startDate": "2026-10-04T03:59:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7220,
        "venue": "Clarence T.C. Ching Athletics Complex",
        "homeId": 62,
        "homeTeam": "Hawai'i",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 16,
        "homeLineScores": [
            0,
            0,
            13,
            3
        ],
        "homePostgameWinProbability": 0.029331829398870468,
        "homePregameElo": 1378,
        "homePostgameElo": 1373,
        "awayId": 23,
        "awayTeam": "San José State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 20,
        "awayLineScores": [
            0,
            14,
            3,
            3
        ],
        "awayPostgameWinProbability": 0.9706681706011295,
        "awayPregameElo": 1393,
        "awayPostgameElo": 1398,
        "excitementIndex": 5.354287467230804,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871090,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-07T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3975,
        "venue": "Veterans Memorial Stadium (AL)",
        "homeId": 2653,
        "homeTeam": "Troy",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 55,
        "homeLineScores": [
            17,
            14,
            10,
            14
        ],
        "homePostgameWinProbability": 0.9570257067680359,
        "homePregameElo": 1395,
        "homePostgameElo": 1428,
        "awayId": 2572,
        "awayTeam": "Southern Miss",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 34,
        "awayLineScores": [
            0,
            7,
            20,
            7
        ],
        "awayPostgameWinProbability": 0.04297429323196411,
        "awayPregameElo": 1227,
        "awayPostgameElo": 1194,
        "excitementIndex": 2.51310206327835,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871051,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-07T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4899,
        "venue": "Fifth Third Stadium",
        "homeId": 338,
        "homeTeam": "Kennesaw State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 26,
        "homeLineScores": [
            3,
            13,
            7,
            3
        ],
        "homePostgameWinProbability": 0.5450258851051331,
        "homePregameElo": 1284,
        "homePostgameElo": 1290,
        "awayId": 55,
        "awayTeam": "Jacksonville State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 27,
        "awayLineScores": [
            0,
            14,
            7,
            6
        ],
        "awayPostgameWinProbability": 0.45497411489486694,
        "awayPregameElo": 1435,
        "awayPostgameElo": 1429,
        "excitementIndex": 7.598558723416495,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871066,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-07T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 2031,
        "venue": "Pitbull Stadium",
        "homeId": 2229,
        "homeTeam": "Florida International",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 22,
        "homeLineScores": [
            7,
            3,
            6,
            6
        ],
        "homePostgameWinProbability": 1,
        "homePregameElo": 1392,
        "homePostgameElo": 1425,
        "awayId": 166,
        "awayTeam": "New Mexico State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0,
        "awayPregameElo": 1282,
        "awayPostgameElo": 1249,
        "excitementIndex": 3.1518785665921194,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871052,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-08T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3796,
        "venue": "Houchens Industries-L.T. Smith Stadium",
        "homeId": 98,
        "homeTeam": "Western Kentucky",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 34,
        "homeLineScores": [
            7,
            14,
            3,
            10
        ],
        "homePostgameWinProbability": 0.992168128490448,
        "homePregameElo": 1191,
        "homePostgameElo": 1252,
        "awayId": 2623,
        "awayTeam": "Missouri State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 13,
        "awayLineScores": [
            3,
            3,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.007831871509552002,
        "awayPregameElo": 1292,
        "awayPostgameElo": 1231,
        "excitementIndex": 3.524116727007871,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870766,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-08T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3992,
        "venue": "Williams Stadium (VA)",
        "homeId": 2335,
        "homeTeam": "Liberty",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": 35,
        "homeLineScores": [
            7,
            7,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9936631917953491,
        "homePregameElo": 1725,
        "homePostgameElo": 1746,
        "awayId": 2534,
        "awayTeam": "Sam Houston",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": 3,
        "awayLineScores": [
            0,
            3,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.006336808204650879,
        "awayPregameElo": 1142,
        "awayPostgameElo": 1121,
        "excitementIndex": 1.949340313126247,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862794,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-08T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3604,
        "venue": "Alamodome",
        "homeId": 2636,
        "homeTeam": "UTSA",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 31,
        "homeLineScores": [
            7,
            3,
            10,
            11
        ],
        "homePostgameWinProbability": 0.8826709389686584,
        "homePregameElo": 1504,
        "homePostgameElo": 1521,
        "awayId": 58,
        "awayTeam": "South Florida",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 24,
        "awayLineScores": [
            14,
            3,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.11732906103134155,
        "awayPregameElo": 1623,
        "awayPostgameElo": 1606,
        "excitementIndex": 6.476942467989171,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869933,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-08T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3625,
        "venue": "Centennial Bank Stadium",
        "homeId": 2032,
        "homeTeam": "Arkansas State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 49,
        "homeLineScores": [
            7,
            21,
            7,
            14
        ],
        "homePostgameWinProbability": 0.3574901521205902,
        "homePregameElo": 1321,
        "homePostgameElo": 1310,
        "awayId": 6,
        "awayTeam": "South Alabama",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 56,
        "awayLineScores": [
            14,
            20,
            15,
            7
        ],
        "awayPostgameWinProbability": 0.6425098478794098,
        "awayPregameElo": 1354,
        "awayPostgameElo": 1365,
        "excitementIndex": 5.956079136123486,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858254,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-09T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3873,
        "venue": "L&N Federal Credit Union Stadium",
        "homeId": 97,
        "homeTeam": "Louisville",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 44,
        "homeLineScores": [
            0,
            14,
            14,
            16
        ],
        "homePostgameWinProbability": 0.9954826235771179,
        "homePregameElo": 1671,
        "homePostgameElo": 1729,
        "awayId": 52,
        "awayTeam": "Florida State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 20,
        "awayLineScores": [
            14,
            0,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.00451737642288208,
        "awayPregameElo": 1656,
        "awayPostgameElo": 1598,
        "excitementIndex": 3.5998890418089173,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860922,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3905,
        "venue": "Maverik Stadium",
        "homeId": 328,
        "homeTeam": "Utah State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 17,
        "homeLineScores": [
            0,
            3,
            7,
            7
        ],
        "homePostgameWinProbability": 0.690333366394043,
        "homePregameElo": 1358,
        "homePostgameElo": 1362,
        "awayId": 265,
        "awayTeam": "Washington State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 16,
        "awayLineScores": [
            6,
            10,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.30966663360595703,
        "awayPregameElo": 1480,
        "awayPostgameElo": 1476,
        "excitementIndex": 5.943634877360968,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858487,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3765,
        "venue": "Husky Stadium",
        "homeId": 264,
        "homeTeam": "Washington",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 24,
        "homeLineScores": [
            0,
            3,
            15,
            6
        ],
        "homePostgameWinProbability": 0.01600835844874382,
        "homePregameElo": 1734,
        "homePostgameElo": 1702,
        "awayId": 2294,
        "awayTeam": "Iowa",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 41,
        "awayLineScores": [
            13,
            14,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.9839916415512562,
        "awayPregameElo": 1821,
        "awayPostgameElo": 1853,
        "excitementIndex": 3.135915859347961,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864519,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3935,
        "venue": "CEFCU Stadium",
        "homeId": 23,
        "homeTeam": "San José State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 13,
        "homeLineScores": [
            0,
            7,
            6,
            0,
            0
        ],
        "homePostgameWinProbability": 0.17873911559581757,
        "homePregameElo": 1398,
        "homePostgameElo": 1386,
        "awayId": 2751,
        "awayTeam": "Wyoming",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 16,
        "awayLineScores": [
            3,
            3,
            0,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.8212608844041824,
        "awayPregameElo": 1280,
        "awayPostgameElo": 1292,
        "excitementIndex": 8.558500622567513,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856826,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T02:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3801,
        "venue": "LaVell Edwards Stadium",
        "homeId": 252,
        "homeTeam": "BYU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 24,
        "homeLineScores": [
            7,
            7,
            7,
            3
        ],
        "homePostgameWinProbability": 0.9784883856773376,
        "homePregameElo": 1699,
        "homePostgameElo": 1725,
        "awayId": 66,
        "awayTeam": "Iowa State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            3,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.021511614322662354,
        "awayPregameElo": 1669,
        "awayPostgameElo": 1643,
        "excitementIndex": 2.87103923255117,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856716,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3838,
        "venue": "Memorial Stadium",
        "homeId": 142,
        "homeTeam": "Missouri",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 27,
        "homeLineScores": [
            0,
            10,
            10,
            7
        ],
        "homePostgameWinProbability": 0.8709767460823059,
        "homePregameElo": 1761,
        "homePostgameElo": 1814,
        "awayId": 245,
        "awayTeam": "Texas A&M",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 6,
        "awayLineScores": [
            3,
            0,
            0,
            3
        ],
        "awayPostgameWinProbability": 0.1290232539176941,
        "awayPregameElo": 1786,
        "awayPostgameElo": 1733,
        "excitementIndex": 4.9279586517176694,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858260,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3670,
        "venue": "Carter-Finley Stadium",
        "homeId": 152,
        "homeTeam": "NC State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 14,
        "homeLineScores": [
            7,
            7,
            0,
            0
        ],
        "homePostgameWinProbability": 0.022184818983078003,
        "homePregameElo": 1517,
        "homePostgameElo": 1471,
        "awayId": 154,
        "awayTeam": "Wake Forest",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            3,
            21,
            7
        ],
        "awayPostgameWinProbability": 0.977815181016922,
        "awayPregameElo": 1669,
        "awayPostgameElo": 1715,
        "excitementIndex": 4.221938339346501,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858481,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3834,
        "venue": "Memorial Stadium (Lincoln, NE)",
        "homeId": 158,
        "homeTeam": "Nebraska",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 17,
        "homeLineScores": [
            10,
            0,
            0,
            7
        ],
        "homePostgameWinProbability": 0.24200484156608582,
        "homePregameElo": 1751,
        "homePostgameElo": 1767,
        "awayId": 84,
        "awayTeam": "Indiana",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 20,
        "awayLineScores": [
            3,
            0,
            3,
            14
        ],
        "awayPostgameWinProbability": 0.7579951584339142,
        "awayPregameElo": 2114,
        "awayPostgameElo": 2098,
        "excitementIndex": 5.519647891588554,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862795,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3841,
        "venue": "Michie Stadium",
        "homeId": 349,
        "homeTeam": "Army",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 20,
        "homeLineScores": [
            7,
            0,
            0,
            13
        ],
        "homePostgameWinProbability": 0.6205256581306458,
        "homePregameElo": 1522,
        "homePostgameElo": 1523,
        "awayId": 2655,
        "awayTeam": "Tulane",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 17,
        "awayLineScores": [
            0,
            3,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.37947434186935425,
        "awayPregameElo": 1517,
        "awayPostgameElo": 1516,
        "excitementIndex": 4.7867311274029785,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856823,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3842,
        "venue": "Milan Puskar Stadium",
        "homeId": 277,
        "homeTeam": "West Virginia",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 31,
        "homeLineScores": [
            3,
            14,
            7,
            7
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 1355,
        "homePostgameElo": 1338,
        "awayId": 12,
        "awayTeam": "Arizona",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 52,
        "awayLineScores": [
            14,
            10,
            14,
            14
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1702,
        "awayPostgameElo": 1719,
        "excitementIndex": 6.445911997721114,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866436,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3700,
        "venue": "Doyt L. Perry Stadium",
        "homeId": 189,
        "homeTeam": "Bowling Green",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 38,
        "homeLineScores": [
            0,
            17,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9845569729804993,
        "homePregameElo": 1170,
        "homePostgameElo": 1245,
        "awayId": 16,
        "awayTeam": "Sacramento State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            0,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.015443027019500732,
        "awayPregameElo": 1185,
        "awayPostgameElo": 1110,
        "excitementIndex": 2.7669272377379412,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858256,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3752,
        "venue": "Acrisure Stadium",
        "homeId": 221,
        "homeTeam": "Pittsburgh",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 17,
        "homeLineScores": [
            7,
            3,
            0,
            7
        ],
        "homePostgameWinProbability": 0.3315916955471039,
        "homePregameElo": 1668,
        "homePostgameElo": 1645,
        "awayId": 153,
        "awayTeam": "North Carolina",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 21,
        "awayLineScores": [
            0,
            7,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.6684083044528961,
        "awayPregameElo": 1426,
        "awayPostgameElo": 1449,
        "excitementIndex": 6.365562383065453,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856824,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3646,
        "venue": "Boone Pickens Stadium",
        "homeId": 197,
        "homeTeam": "Oklahoma State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 42,
        "homeLineScores": [
            7,
            14,
            3,
            18
        ],
        "homePostgameWinProbability": 0.8780238628387451,
        "homePregameElo": 1330,
        "homePostgameElo": 1373,
        "awayId": 2116,
        "awayTeam": "UCF",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 28,
        "awayLineScores": [
            14,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.12197613716125488,
        "awayPregameElo": 1488,
        "awayPostgameElo": 1445,
        "excitementIndex": 5.754555238924946,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858482,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 11823,
        "venue": "Ryan Field",
        "homeId": 77,
        "homeTeam": "Northwestern",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 45,
        "homeLineScores": [
            14,
            17,
            14,
            0
        ],
        "homePostgameWinProbability": 0.9955438375473022,
        "homePregameElo": 1720,
        "homePostgameElo": 1731,
        "awayId": 2050,
        "awayTeam": "Ball State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            14,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.004456162452697754,
        "awayPregameElo": 1065,
        "awayPostgameElo": 1054,
        "excitementIndex": 2.886970834301903,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856714,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T16:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3634,
        "venue": "Ben Hill Griffin Stadium",
        "homeId": 57,
        "homeTeam": "Florida",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 19,
        "homeLineScores": [
            7,
            3,
            3,
            6
        ],
        "homePostgameWinProbability": 0.05005598068237305,
        "homePregameElo": 1669,
        "homePostgameElo": 1619,
        "awayId": 2579,
        "awayTeam": "South Carolina",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 38,
        "awayLineScores": [
            7,
            10,
            14,
            7
        ],
        "awayPostgameWinProbability": 0.949944019317627,
        "awayPregameElo": 1649,
        "awayPostgameElo": 1699,
        "excitementIndex": 4.963688247327227,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869843,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3792,
        "venue": "Kidd Brewer Stadium",
        "homeId": 2026,
        "homeTeam": "App State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 3,
        "homeLineScores": [
            0,
            0,
            3,
            0
        ],
        "homePostgameWinProbability": 0.5341777205467224,
        "homePregameElo": 1320,
        "homePostgameElo": 1297,
        "awayId": 295,
        "awayTeam": "Old Dominion",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 10,
        "awayLineScores": [
            0,
            0,
            2,
            8
        ],
        "awayPostgameWinProbability": 0.4658222794532776,
        "awayPregameElo": 1197,
        "awayPostgameElo": 1220,
        "excitementIndex": 5.698763731626017,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862797,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3699,
        "venue": "Dowdy-Ficklen Stadium",
        "homeId": 151,
        "homeTeam": "East Carolina",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 28,
        "homeLineScores": [
            7,
            0,
            7,
            14
        ],
        "homePostgameWinProbability": 0.8384724855422974,
        "homePregameElo": 1456,
        "homePostgameElo": 1466,
        "awayId": 242,
        "awayTeam": "Rice",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 12,
        "awayLineScores": [
            0,
            3,
            6,
            3
        ],
        "awayPostgameWinProbability": 0.16152751445770264,
        "awayPregameElo": 1184,
        "awayPostgameElo": 1174,
        "excitementIndex": 4.430653081519991,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866440,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3985,
        "venue": "Warren McGuirk Alumni Stadium",
        "homeId": 113,
        "homeTeam": "Massachusetts",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 19,
        "homeLineScores": [
            7,
            3,
            0,
            9
        ],
        "homePostgameWinProbability": 0.14881259202957153,
        "homePregameElo": 1124,
        "homePostgameElo": 1129,
        "awayId": 193,
        "awayTeam": "Miami (OH)",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 20,
        "awayLineScores": [
            14,
            0,
            3,
            3
        ],
        "awayPostgameWinProbability": 0.8511874079704285,
        "awayPregameElo": 1253,
        "awayPostgameElo": 1248,
        "excitementIndex": 5.976828416531704,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858259,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3831,
        "venue": "California Memorial Stadium",
        "homeId": 25,
        "homeTeam": "California",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 25,
        "homeLineScores": [
            0,
            10,
            3,
            12
        ],
        "homePostgameWinProbability": 0.5495479702949524,
        "homePregameElo": 1335,
        "homePostgameElo": 1347,
        "awayId": 259,
        "awayTeam": "Virginia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 20,
        "awayLineScores": [
            0,
            14,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.4504520297050476,
        "awayPregameElo": 1501,
        "awayPostgameElo": 1489,
        "excitementIndex": 8.42556675363963,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866439,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3980,
        "venue": "Waldo Stadium",
        "homeId": 2711,
        "homeTeam": "Western Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 38,
        "homeLineScores": [
            7,
            14,
            3,
            14
        ],
        "homePostgameWinProbability": 0.9920874238014221,
        "homePregameElo": 1457,
        "homePostgameElo": 1493,
        "awayId": 2309,
        "awayTeam": "Kent State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.00791257619857788,
        "awayPregameElo": 1050,
        "awayPostgameElo": 1014,
        "excitementIndex": 2.537063603542151,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858484,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3626,
        "venue": "Autzen Stadium",
        "homeId": 2483,
        "homeTeam": "Oregon",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 15,
        "homeLineScores": [
            6,
            0,
            0,
            9
        ],
        "homePostgameWinProbability": 0.12066039443016052,
        "homePregameElo": 1844,
        "homePostgameElo": 1831,
        "awayId": 26,
        "awayTeam": "UCLA",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 17,
        "awayLineScores": [
            3,
            7,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.8793396055698395,
        "awayPregameElo": 1660,
        "awayPostgameElo": 1673,
        "excitementIndex": 6.097509757657062,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866438,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3876,
        "venue": "Peden Stadium",
        "homeId": 195,
        "homeTeam": "Ohio",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 31,
        "homeLineScores": [
            14,
            17,
            0,
            0
        ],
        "homePostgameWinProbability": 0.9627941250801086,
        "homePregameElo": 1307,
        "homePostgameElo": 1339,
        "awayId": 2117,
        "awayTeam": "Central Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            0,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.03720587491989136,
        "awayPregameElo": 1248,
        "awayPostgameElo": 1216,
        "excitementIndex": 1.9912887689139445,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862799,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3852,
        "venue": "Navy-Marine Corps Memorial Stadium",
        "homeId": 2426,
        "homeTeam": "Navy",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 34,
        "homeLineScores": [
            7,
            7,
            6,
            14
        ],
        "homePostgameWinProbability": 0.9989381432533264,
        "homePregameElo": 1498,
        "homePostgameElo": 1495,
        "awayId": 202,
        "awayTeam": "Tulsa",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 26,
        "awayLineScores": [
            14,
            6,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.001061856746673584,
        "awayPregameElo": 1238,
        "awayPostgameElo": 1241,
        "excitementIndex": 5.0124505705180855,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856825,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3636,
        "venue": "Bill Snyder Family Stadium",
        "homeId": 2306,
        "homeTeam": "Kansas State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 16,
        "homeLineScores": [
            3,
            0,
            6,
            7
        ],
        "homePostgameWinProbability": 0.014933845959603786,
        "homePregameElo": 1679,
        "homePostgameElo": 1617,
        "awayId": 248,
        "awayTeam": "Houston",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 35,
        "awayLineScores": [
            7,
            14,
            14,
            0
        ],
        "awayPostgameWinProbability": 0.9850661540403962,
        "awayPregameElo": 1550,
        "awayPostgameElo": 1612,
        "excitementIndex": 3.567862426655693,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862796,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3825,
        "venue": "DATCU Stadium",
        "homeId": 249,
        "homeTeam": "North Texas",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 50,
        "homeLineScores": [
            10,
            30,
            7,
            3
        ],
        "homePostgameWinProbability": 0.9892137050628662,
        "homePregameElo": 1629,
        "homePostgameElo": 1669,
        "awayId": 2429,
        "awayTeam": "Charlotte",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 10,
        "awayLineScores": [
            3,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.010786294937133789,
        "awayPregameElo": 1022,
        "awayPostgameElo": 982,
        "excitementIndex": 2.020748152729714,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856717,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": true,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 499,
        "venue": "Cotton Bowl",
        "homeId": 201,
        "homeTeam": "Oklahoma",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 27,
        "homeLineScores": [
            0,
            7,
            3,
            17
        ],
        "homePostgameWinProbability": 0.6481005549430847,
        "homePregameElo": 1731,
        "homePostgameElo": 1747,
        "awayId": 251,
        "awayTeam": "Texas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 24,
        "awayLineScores": [
            7,
            10,
            0,
            7
        ],
        "awayPostgameWinProbability": 0.3518994450569153,
        "awayPregameElo": 1930,
        "awayPostgameElo": 1914,
        "excitementIndex": 6.784623338362566,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858480,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3936,
        "venue": "Spartan Stadium",
        "homeId": 127,
        "homeTeam": "Michigan State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 37,
        "homeLineScores": [
            0,
            7,
            10,
            14,
            6
        ],
        "homePostgameWinProbability": 0.9987384676933289,
        "homePregameElo": 1449,
        "homePostgameElo": 1452,
        "awayId": 356,
        "awayTeam": "Illinois",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 38,
        "awayLineScores": [
            10,
            10,
            3,
            8,
            7
        ],
        "awayPostgameWinProbability": 0.0012615323066711426,
        "awayPregameElo": 1539,
        "awayPostgameElo": 1536,
        "excitementIndex": 5.778580011279023,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856718,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3973,
        "venue": "FirstBank Stadium",
        "homeId": 238,
        "homeTeam": "Vanderbilt",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 17,
        "homeLineScores": [
            3,
            0,
            7,
            7
        ],
        "homePostgameWinProbability": 0.0029896472115069628,
        "homePregameElo": 1702,
        "homePostgameElo": 1610,
        "awayId": 145,
        "awayTeam": "Ole Miss",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 52,
        "awayLineScores": [
            14,
            28,
            0,
            10
        ],
        "awayPostgameWinProbability": 0.997010352788493,
        "awayPregameElo": 1776,
        "awayPostgameElo": 1868,
        "excitementIndex": 3.681822594301053,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866435,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3768,
        "venue": "InfoCision Stadium",
        "homeId": 2006,
        "homeTeam": "Akron",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 23,
        "homeLineScores": [
            7,
            7,
            3,
            6
        ],
        "homePostgameWinProbability": 0.7734358906745911,
        "homePregameElo": 862,
        "homePostgameElo": 879,
        "awayId": 2199,
        "awayTeam": "Eastern Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 25,
        "awayLineScores": [
            3,
            10,
            3,
            9
        ],
        "awayPostgameWinProbability": 0.22656410932540894,
        "awayPregameElo": 1252,
        "awayPostgameElo": 1235,
        "excitementIndex": 6.721419928868478,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858255,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 721,
        "venue": "Bobby Dodd Stadium",
        "homeId": 59,
        "homeTeam": "Georgia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 28,
        "homeLineScores": [
            7,
            7,
            7,
            7
        ],
        "homePostgameWinProbability": 0.43627268075942993,
        "homePregameElo": 1493,
        "homePostgameElo": 1496,
        "awayId": 150,
        "awayTeam": "Duke",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 25,
        "awayLineScores": [
            0,
            10,
            8,
            7
        ],
        "awayPostgameWinProbability": 0.5637273192405701,
        "awayPregameElo": 1656,
        "awayPostgameElo": 1653,
        "excitementIndex": 6.172059738682084,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866437,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3739,
        "venue": "Glass Bowl",
        "homeId": 2649,
        "homeTeam": "Toledo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": 8,
        "homeLineScores": [
            0,
            0,
            0,
            8
        ],
        "homePostgameWinProbability": 0.2077482044696808,
        "homePregameElo": 1598,
        "homePostgameElo": 1529,
        "awayId": 2084,
        "awayTeam": "Buffalo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": 23,
        "awayLineScores": [
            6,
            7,
            3,
            7
        ],
        "awayPostgameWinProbability": 0.7922517955303192,
        "awayPregameElo": 1294,
        "awayPostgameElo": 1363,
        "excitementIndex": 4.372017235949381,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858257,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3855,
        "venue": "Notre Dame Stadium",
        "homeId": 87,
        "homeTeam": "Notre Dame",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": 58,
        "homeLineScores": [
            14,
            23,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9926139116287231,
        "homePregameElo": 2054,
        "homePostgameElo": 2097,
        "awayId": 24,
        "awayTeam": "Stanford",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            0,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.0073860883712768555,
        "awayPregameElo": 1194,
        "awayPostgameElo": 1151,
        "excitementIndex": 1.7875929071207786,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401861964,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T19:45:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3806,
        "venue": "Lincoln Financial Field",
        "homeId": 218,
        "homeTeam": "Temple",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 20,
        "homeLineScores": [
            14,
            3,
            3,
            0
        ],
        "homePostgameWinProbability": 0.14584887027740479,
        "homePregameElo": 1365,
        "homePostgameElo": 1342,
        "awayId": 41,
        "awayTeam": "UConn",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": 34,
        "awayLineScores": [
            14,
            10,
            0,
            10
        ],
        "awayPostgameWinProbability": 0.8541511297225952,
        "awayPregameElo": 1460,
        "awayPostgameElo": 1483,
        "excitementIndex": 5.403988599457139,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858483,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3861,
        "venue": "Ohio Stadium",
        "homeId": 194,
        "homeTeam": "Ohio State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 45,
        "homeLineScores": [
            14,
            17,
            7,
            7
        ],
        "homePostgameWinProbability": 0.9938061833381653,
        "homePregameElo": 2064,
        "homePostgameElo": 2060,
        "awayId": 120,
        "awayTeam": "Maryland",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 16,
        "awayLineScores": [
            3,
            7,
            6,
            0
        ],
        "awayPostgameWinProbability": 0.006193816661834717,
        "awayPregameElo": 1297,
        "awayPostgameElo": 1301,
        "excitementIndex": 2.7884631613589907,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856713,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T20:15:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3887,
        "venue": "Razorback Stadium",
        "homeId": 8,
        "homeTeam": "Arkansas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 17,
        "homeLineScores": [
            0,
            0,
            14,
            3
        ],
        "homePostgameWinProbability": 0.1248495876789093,
        "homePregameElo": 1472,
        "homePostgameElo": 1482,
        "awayId": 2633,
        "awayTeam": "Tennessee",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 24,
        "awayLineScores": [
            0,
            7,
            3,
            14
        ],
        "awayPostgameWinProbability": 0.8751504123210907,
        "awayPregameElo": 1786,
        "awayPostgameElo": 1776,
        "excitementIndex": 7.461777480689512,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860902,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3893,
        "venue": "Reser Stadium",
        "homeId": 204,
        "homeTeam": "Oregon State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 66,
        "homeLineScores": [
            14,
            24,
            21,
            7
        ],
        "homePostgameWinProbability": 0.9876359701156616,
        "homePregameElo": 1418,
        "homePostgameElo": 1581,
        "awayId": 21,
        "awayTeam": "San Diego State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 14,
        "awayLineScores": [
            0,
            7,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.012364029884338379,
        "awayPregameElo": 1417,
        "awayPostgameElo": 1254,
        "excitementIndex": 1.7526299750321135,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862798,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3805,
        "venue": "Simmons Bank Liberty Stadium",
        "homeId": 235,
        "homeTeam": "Memphis",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": 38,
        "homeLineScores": [
            7,
            3,
            14,
            14
        ],
        "homePostgameWinProbability": 0.989381730556488,
        "homePregameElo": 1627,
        "homePostgameElo": 1665,
        "awayId": 5,
        "awayTeam": "UAB",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": 13,
        "awayLineScores": [
            7,
            6,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.010618269443511963,
        "awayPregameElo": 1400,
        "awayPostgameElo": 1362,
        "excitementIndex": 4.020261918232617,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864517,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3946,
        "venue": "Sun Bowl",
        "homeId": 2638,
        "homeTeam": "UTEP",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 13,
        "homeLineScores": [
            0,
            7,
            0,
            6
        ],
        "homePostgameWinProbability": 0,
        "homePregameElo": 984,
        "homePostgameElo": 986,
        "awayId": 2440,
        "awayTeam": "Nevada",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 30,
        "awayLineScores": [
            7,
            6,
            10,
            7
        ],
        "awayPostgameWinProbability": 1,
        "awayPregameElo": 1435,
        "awayPostgameElo": 1433,
        "excitementIndex": 4.340491443704483,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864518,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6501,
        "venue": "Allegiant Stadium",
        "homeId": 2439,
        "homeTeam": "UNLV",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 13,
        "homeLineScores": [
            7,
            0,
            3,
            3
        ],
        "homePostgameWinProbability": 0.7040004730224609,
        "homePregameElo": 1494,
        "homePostgameElo": 1509,
        "awayId": 2449,
        "awayTeam": "North Dakota State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 7,
        "awayLineScores": [
            0,
            7,
            0,
            0
        ],
        "awayPostgameWinProbability": 0.29599952697753906,
        "awayPregameElo": 1636,
        "awayPostgameElo": 1621,
        "excitementIndex": 4.437279384128355,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869943,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3775,
        "venue": "Joan C. Edwards Stadium",
        "homeId": 276,
        "homeTeam": "Marshall",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 21,
        "homeLineScores": [
            0,
            0,
            7,
            14
        ],
        "homePostgameWinProbability": 0.3272958993911743,
        "homePregameElo": 1363,
        "homePostgameElo": 1344,
        "awayId": 324,
        "awayTeam": "Coastal Carolina",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 27,
        "awayLineScores": [
            3,
            10,
            14,
            0
        ],
        "awayPostgameWinProbability": 0.6727041006088257,
        "awayPregameElo": 1262,
        "awayPostgameElo": 1281,
        "excitementIndex": 4.435735314439996,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856715,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3683,
        "venue": "Kroger Field",
        "homeId": 96,
        "homeTeam": "Kentucky",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 35,
        "homeLineScores": [
            7,
            14,
            0,
            6,
            8
        ],
        "homePostgameWinProbability": 0.6850408911705017,
        "homePregameElo": 1559,
        "homePostgameElo": 1568,
        "awayId": 99,
        "awayTeam": "LSU",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 34,
        "awayLineScores": [
            10,
            7,
            3,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.3149591088294983,
        "awayPregameElo": 1868,
        "awayPostgameElo": 1859,
        "excitementIndex": 8.621913746910705,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858485,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3632,
        "venue": "Beaver Stadium",
        "homeId": 213,
        "homeTeam": "Penn State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 23,
        "homeLineScores": [
            7,
            10,
            3,
            3
        ],
        "homePostgameWinProbability": 0.14959882199764252,
        "homePregameElo": 1821,
        "homePostgameElo": 1802,
        "awayId": 30,
        "awayTeam": "USC",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 31,
        "awayLineScores": [
            7,
            10,
            7,
            7
        ],
        "awayPostgameWinProbability": 0.8504011780023575,
        "awayPregameElo": 1785,
        "awayPostgameElo": 1804,
        "excitementIndex": 6.147584436259081,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856712,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3657,
        "venue": "Bryant-Denny Stadium",
        "homeId": 333,
        "homeTeam": "Alabama",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": 17,
        "homeLineScores": [
            0,
            14,
            3,
            0
        ],
        "homePostgameWinProbability": 0.3378307521343231,
        "homePregameElo": 1991,
        "homePostgameElo": 1990,
        "awayId": 61,
        "awayTeam": "Georgia",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": 20,
        "awayLineScores": [
            3,
            7,
            7,
            3
        ],
        "awayPostgameWinProbability": 0.6621692478656769,
        "awayPregameElo": 2052,
        "awayPostgameElo": 2053,
        "excitementIndex": 6.287136759489017,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858258,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3923,
        "venue": "Scott Stadium",
        "homeId": 258,
        "homeTeam": "Virginia",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": 28,
        "homeLineScores": [
            7,
            0,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9630276560783386,
        "homePregameElo": 1595,
        "homePostgameElo": 1592,
        "awayId": 183,
        "awayTeam": "Syracuse",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": 25,
        "awayLineScores": [
            7,
            10,
            0,
            8
        ],
        "awayPostgameWinProbability": 0.03697234392166138,
        "awayPregameElo": 1300,
        "awayPostgameElo": 1303,
        "excitementIndex": 5.325817113286339,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869949,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3608,
        "venue": "Allen E. Paulson Stadium",
        "homeId": 290,
        "homeTeam": "Georgia Southern",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 24,
        "homeLineScores": [
            7,
            3,
            0,
            14
        ],
        "homePostgameWinProbability": 0.597503662109375,
        "homePregameElo": 1349,
        "homePostgameElo": 1370,
        "awayId": 256,
        "awayTeam": "James Madison",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 27,
        "awayLineScores": [
            3,
            3,
            14,
            7
        ],
        "awayPostgameWinProbability": 0.402496337890625,
        "awayPregameElo": 1821,
        "awayPostgameElo": 1800,
        "excitementIndex": 6.446752468089923,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864516,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3764,
        "venue": "Huskie Stadium",
        "homeId": 2459,
        "homeTeam": "Northern Illinois",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": 7,
        "homeLineScores": [
            0,
            7,
            0,
            0
        ],
        "homePostgameWinProbability": 0.07954786717891693,
        "homePregameElo": 1194,
        "homePostgameElo": 1167,
        "awayId": 2005,
        "awayTeam": "Air Force",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 28,
        "awayLineScores": [
            7,
            7,
            14,
            0
        ],
        "awayPostgameWinProbability": 0.9204521328210831,
        "awayPregameElo": 1437,
        "awayPostgameElo": 1464,
        "excitementIndex": 2.9741157297847916,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869965,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-10T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3776,
        "venue": "Joe Aillet Stadium",
        "homeId": 2348,
        "homeTeam": "Louisiana Tech",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": 32,
        "homeLineScores": [
            0,
            13,
            0,
            19
        ],
        "homePostgameWinProbability": 0.9799741506576538,
        "homePregameElo": 1379,
        "homePostgameElo": 1382,
        "awayId": 309,
        "awayTeam": "Louisiana",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": 31,
        "awayLineScores": [
            0,
            10,
            14,
            7
        ],
        "awayPostgameWinProbability": 0.02002584934234619,
        "awayPregameElo": 1442,
        "awayPostgameElo": 1439,
        "excitementIndex": 6.863604193615755,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856827,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-11T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 587,
        "venue": "Rice-Eccles Stadium",
        "homeId": 254,
        "homeTeam": "Utah",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 41,
        "homeLineScores": [
            14,
            7,
            6,
            14
        ],
        "homePostgameWinProbability": 0.9344750642776489,
        "homePregameElo": 1918,
        "homePostgameElo": 1929,
        "awayId": 2305,
        "awayTeam": "Kansas",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": 24,
        "awayLineScores": [
            0,
            17,
            7,
            0
        ],
        "awayPostgameWinProbability": 0.06552493572235107,
        "awayPregameElo": 1625,
        "awayPostgameElo": 1614,
        "excitementIndex": 3.942336161669341,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858486,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-11T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3907,
        "venue": "Ross-Ade Stadium",
        "homeId": 2509,
        "homeTeam": "Purdue",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": 41,
        "homeLineScores": [
            10,
            10,
            7,
            14
        ],
        "homePostgameWinProbability": 0.9963497519493103,
        "homePregameElo": 1326,
        "homePostgameElo": 1425,
        "awayId": 135,
        "awayTeam": "Minnesota",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": 13,
        "awayLineScores": [
            0,
            3,
            10,
            0
        ],
        "awayPostgameWinProbability": 0.0036502480506896973,
        "awayPregameElo": 1526,
        "awayPostgameElo": 1427,
        "excitementIndex": 2.269918712099371,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856808,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-11T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3947,
        "venue": "Mountain America Stadium",
        "homeId": 9,
        "homeTeam": "Arizona State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": 30,
        "homeLineScores": [
            7,
            10,
            7,
            6
        ],
        "homePostgameWinProbability": 0.9607327580451965,
        "homePregameElo": 1429,
        "homePostgameElo": 1464,
        "awayId": 62,
        "awayTeam": "Hawai'i",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": 12,
        "awayLineScores": [
            3,
            3,
            0,
            6
        ],
        "awayPostgameWinProbability": 0.03926724195480347,
        "awayPregameElo": 1373,
        "awayPostgameElo": 1338,
        "excitementIndex": 3.1827709449403048,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860901,
        "season": 2026,
        "week": 6,
        "seasonType": "regular",
        "startDate": "2026-10-11T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": true,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3660,
        "venue": "Valley Children's Stadium",
        "homeId": 278,
        "homeTeam": "Fresno State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": 31,
        "homeLineScores": [
            13,
            7,
            0,
            11
        ],
        "homePostgameWinProbability": 0.19863373041152954,
        "homePregameElo": 1645,
        "homePostgameElo": 1635,
        "awayId": 68,
        "awayTeam": "Boise State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": 38,
        "awayLineScores": [
            15,
            10,
            3,
            10
        ],
        "awayPostgameWinProbability": 0.8013662695884705,
        "awayPregameElo": 1681,
        "awayPostgameElo": 1691,
        "excitementIndex": 5.212494743489183,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871067,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-13T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3725,
        "venue": "Johnny \"Red\" Floyd Stadium",
        "homeId": 2393,
        "homeTeam": "Middle Tennessee",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1146,
        "homePostgameElo": null,
        "awayId": 48,
        "awayTeam": "Delaware",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1328,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871053,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-14T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3662,
        "venue": "AmFirst Stadium",
        "homeId": 55,
        "homeTeam": "Jacksonville State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1429,
        "homePostgameElo": null,
        "awayId": 2229,
        "awayTeam": "Florida International",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1425,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871054,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-14T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3878,
        "venue": "Plaster Sports Complex",
        "homeId": 2623,
        "homeTeam": "Missouri State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1231,
        "homePostgameElo": null,
        "awayId": 338,
        "awayTeam": "Kennesaw State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1290,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871068,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-15T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3647,
        "venue": "Elliott T. Bowers Stadium",
        "homeId": 2534,
        "homeTeam": "Sam Houston",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1121,
        "homePostgameElo": null,
        "awayId": 98,
        "awayTeam": "Western Kentucky",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1252,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869950,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-15T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3918,
        "venue": "S.B. Ballard Stadium",
        "homeId": 295,
        "homeTeam": "Old Dominion",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1220,
        "homePostgameElo": null,
        "awayId": 290,
        "awayTeam": "Georgia Southern",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1370,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862800,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-15T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7221,
        "venue": "Protective Stadium",
        "homeId": 5,
        "homeTeam": "UAB",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1362,
        "homePostgameElo": null,
        "awayId": 151,
        "awayTeam": "East Carolina",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1466,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860923,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-16T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3644,
        "venue": "Bobcat Stadium (TX)",
        "homeId": 326,
        "homeTeam": "Texas State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1489,
        "homePostgameElo": null,
        "awayId": 36,
        "awayTeam": "Colorado State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1233,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862801,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-16T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4729,
        "venue": "Yulman Stadium",
        "homeId": 2655,
        "homeTeam": "Tulane",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1516,
        "homePostgameElo": null,
        "awayId": 235,
        "awayTeam": "Memphis",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1665,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858493,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3907,
        "venue": "Ross-Ade Stadium",
        "homeId": 2509,
        "homeTeam": "Purdue",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1425,
        "homePostgameElo": null,
        "awayId": 264,
        "awayTeam": "Washington",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1702,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869844,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3654,
        "venue": "Brooks Stadium (SC)",
        "homeId": 324,
        "homeTeam": "Coastal Carolina",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1281,
        "homePostgameElo": null,
        "awayId": 2026,
        "awayTeam": "App State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1297,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858494,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1056,
        "venue": "Rose Bowl",
        "homeId": 26,
        "homeTeam": "UCLA",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1673,
        "homePostgameElo": null,
        "awayId": 275,
        "awayTeam": "Wisconsin",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1673,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858492,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3626,
        "venue": "Autzen Stadium",
        "homeId": 2483,
        "homeTeam": "Oregon",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1831,
        "homePostgameElo": null,
        "awayId": 158,
        "awayTeam": "Nebraska",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1767,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856720,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3958,
        "venue": "Tiger Stadium (LA)",
        "homeId": 99,
        "homeTeam": "LSU",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1859,
        "homePostgameElo": null,
        "awayId": 344,
        "awayTeam": "Mississippi State",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1612,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858491,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3936,
        "venue": "Spartan Stadium",
        "homeId": 127,
        "homeTeam": "Michigan State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1452,
        "homePostgameElo": null,
        "awayId": 77,
        "awayTeam": "Northwestern",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1731,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856724,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3910,
        "venue": "DKR-Texas Memorial Stadium",
        "homeId": 251,
        "homeTeam": "Texas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1914,
        "homePostgameElo": null,
        "awayId": 57,
        "awayTeam": "Florida",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1619,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866441,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3700,
        "venue": "Doyt L. Perry Stadium",
        "homeId": 189,
        "homeTeam": "Bowling Green",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1245,
        "homePostgameElo": null,
        "awayId": 2050,
        "awayTeam": "Ball State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1054,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858261,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3836,
        "venue": "Memorial Stadium (Clemson, SC)",
        "homeId": 228,
        "homeTeam": "Clemson",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1515,
        "homePostgameElo": 1515,
        "awayId": 2127,
        "awayTeam": "Charleston Southern",
        "awayClassification": "fcs",
        "awayConference": "OVC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858267,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3615,
        "venue": "Alumni Stadium (Chestnut Hill, MA)",
        "homeId": 103,
        "homeTeam": "Boston College",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1381,
        "homePostgameElo": null,
        "awayId": 221,
        "awayTeam": "Pittsburgh",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1645,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858268,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3735,
        "venue": "Gerald J. Ford Stadium",
        "homeId": 2567,
        "homeTeam": "SMU",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1689,
        "homePostgameElo": null,
        "awayId": 258,
        "awayTeam": "Virginia",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1592,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858488,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3830,
        "venue": "Memorial Stadium (Bloomington, IN)",
        "homeId": 84,
        "homeTeam": "Indiana",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2098,
        "homePostgameElo": null,
        "awayId": 194,
        "awayTeam": "Ohio State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2060,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862802,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3841,
        "venue": "Michie Stadium",
        "homeId": 349,
        "homeTeam": "Army",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1523,
        "homePostgameElo": null,
        "awayId": 2226,
        "awayTeam": "Florida Atlantic",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1300,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856830,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3636,
        "venue": "Bill Snyder Family Stadium",
        "homeId": 2306,
        "homeTeam": "Kansas State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1617,
        "homePostgameElo": null,
        "awayId": 2305,
        "awayTeam": "Kansas",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1614,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856829,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3842,
        "venue": "Milan Puskar Stadium",
        "homeId": 277,
        "homeTeam": "West Virginia",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1338,
        "homePostgameElo": null,
        "awayId": 2132,
        "awayTeam": "Cincinnati",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1469,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869957,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3651,
        "venue": "Bridgeforth Stadium",
        "homeId": 256,
        "homeTeam": "James Madison",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1800,
        "homePostgameElo": null,
        "awayId": 2247,
        "awayTeam": "Georgia State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1402,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858489,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T16:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3665,
        "venue": "SECU Stadium",
        "homeId": 120,
        "homeTeam": "Maryland",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1301,
        "homePostgameElo": null,
        "awayId": 164,
        "awayTeam": "Rutgers",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1383,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856725,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3795,
        "venue": "Kyle Field",
        "homeId": 245,
        "homeTeam": "Texas A&M",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1739,
        "homePostgameElo": 1739,
        "awayId": 2643,
        "awayTeam": "The Citadel",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866442,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3965,
        "venue": "UB Stadium",
        "homeId": 2084,
        "homeTeam": "Buffalo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1363,
        "homePostgameElo": null,
        "awayId": 113,
        "awayTeam": "Massachusetts",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1129,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862803,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3806,
        "venue": "Lincoln Financial Field",
        "homeId": 218,
        "homeTeam": "Temple",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1342,
        "homePostgameElo": null,
        "awayId": 2429,
        "awayTeam": "Charlotte",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 982,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866443,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T17:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3786,
        "venue": "Kelly/Shorts Stadium",
        "homeId": 2117,
        "homeTeam": "Central Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1216,
        "homePostgameElo": null,
        "awayId": 2711,
        "awayTeam": "Western Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1493,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858264,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3799,
        "venue": "Lane Stadium",
        "homeId": 259,
        "homeTeam": "Virginia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1489,
        "homePostgameElo": null,
        "awayId": 59,
        "awayTeam": "Georgia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1496,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864524,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3713,
        "venue": "Falcon Stadium",
        "homeId": 2005,
        "homeTeam": "Air Force",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1464,
        "homePostgameElo": null,
        "awayId": 2439,
        "awayTeam": "UNLV",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1509,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856719,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3917,
        "venue": "Sanford Stadium",
        "homeId": 61,
        "homeTeam": "Georgia",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2053,
        "homePostgameElo": null,
        "awayId": 2,
        "awayTeam": "Auburn",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1669,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866478,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3996,
        "venue": "Yager Stadium",
        "homeId": 193,
        "homeTeam": "Miami (OH)",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1248,
        "homePostgameElo": null,
        "awayId": 2006,
        "awayTeam": "Akron",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 879,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856723,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3853,
        "venue": "Neyland Stadium",
        "homeId": 2633,
        "homeTeam": "Tennessee",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1776,
        "homePostgameElo": null,
        "awayId": 333,
        "awayTeam": "Alabama",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1990,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856828,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3784,
        "venue": "Jones AT&T Stadium",
        "homeId": 2641,
        "homeTeam": "Texas Tech",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1862,
        "homePostgameElo": null,
        "awayId": 9,
        "awayTeam": "Arizona State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1464,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858490,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3558,
        "venue": "Michigan Stadium",
        "homeId": 130,
        "homeTeam": "Michigan",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1719,
        "homePostgameElo": null,
        "awayId": 213,
        "awayTeam": "Penn State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1802,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856721,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3974,
        "venue": "Vaught-Hemingway Stadium",
        "homeId": 145,
        "homeTeam": "Ole Miss",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1868,
        "homePostgameElo": null,
        "awayId": 142,
        "awayTeam": "Missouri",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1814,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858266,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3982,
        "venue": "Wallace Wade Stadium",
        "homeId": 150,
        "homeTeam": "Duke",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1653,
        "homePostgameElo": null,
        "awayId": 153,
        "awayTeam": "North Carolina",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1449,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866444,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3912,
        "venue": "Rynearson Stadium",
        "homeId": 2199,
        "homeTeam": "Eastern Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1235,
        "homePostgameElo": null,
        "awayId": 2649,
        "awayTeam": "Toledo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1529,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864522,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3984,
        "venue": "War Memorial Stadium",
        "homeId": 2751,
        "homeTeam": "Wyoming",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1292,
        "homePostgameElo": null,
        "awayId": 2459,
        "awayTeam": "Northern Illinois",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1167,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862805,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3895,
        "venue": "Rice Stadium",
        "homeId": 242,
        "homeTeam": "Rice",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1174,
        "homePostgameElo": null,
        "awayId": 202,
        "awayTeam": "Tulsa",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1241,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869966,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3666,
        "venue": "Cajun Field",
        "homeId": 309,
        "homeTeam": "Louisiana",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1439,
        "homePostgameElo": null,
        "awayId": 2653,
        "awayTeam": "Troy",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1428,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860903,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3893,
        "venue": "Reser Stadium",
        "homeId": 204,
        "homeTeam": "Oregon State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1581,
        "homePostgameElo": null,
        "awayId": 265,
        "awayTeam": "Washington State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1476,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858263,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3948,
        "venue": "Hard Rock Stadium",
        "homeId": 2390,
        "homeTeam": "Miami",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1993,
        "homePostgameElo": null,
        "awayId": 52,
        "awayTeam": "Florida State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1598,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869934,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3815,
        "venue": "M. M. Roberts Stadium",
        "homeId": 2572,
        "homeTeam": "Southern Miss",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1194,
        "homePostgameElo": null,
        "awayId": 2032,
        "awayTeam": "Arkansas State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1310,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856832,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4727,
        "venue": "McLane Stadium",
        "homeId": 239,
        "homeTeam": "Baylor",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1643,
        "homePostgameElo": null,
        "awayId": 2628,
        "awayTeam": "TCU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1600,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864520,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3714,
        "venue": "Fargodome",
        "homeId": 2449,
        "homeTeam": "North Dakota State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1621,
        "homePostgameElo": null,
        "awayId": 2440,
        "awayTeam": "Nevada",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1433,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856726,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3973,
        "venue": "FirstBank Stadium",
        "homeId": 238,
        "homeTeam": "Vanderbilt",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1610,
        "homePostgameElo": null,
        "awayId": 8,
        "awayTeam": "Arkansas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1482,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862806,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3886,
        "venue": "Raymond James Stadium",
        "homeId": 58,
        "homeTeam": "South Florida",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1606,
        "homePostgameElo": null,
        "awayId": 2309,
        "awayTeam": "Kent State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1014,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858262,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3940,
        "venue": "Stanford Stadium",
        "homeId": 24,
        "homeTeam": "Stanford",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1111,
        "homePostgameElo": 1111,
        "awayId": 2210,
        "awayTeam": "Elon",
        "awayClassification": "fcs",
        "awayConference": "Coastal Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858265,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1964,
        "venue": "JMA Wireless Dome",
        "homeId": 183,
        "homeTeam": "Syracuse",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1303,
        "homePostgameElo": null,
        "awayId": 97,
        "awayTeam": "Louisville",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1729,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856831,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4728,
        "venue": "TDECU Stadium",
        "homeId": 248,
        "homeTeam": "Houston",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1612,
        "homePostgameElo": null,
        "awayId": 197,
        "awayTeam": "Oklahoma State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1373,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856809,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3801,
        "venue": "LaVell Edwards Stadium",
        "homeId": 252,
        "homeTeam": "BYU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1725,
        "homePostgameElo": null,
        "awayId": 87,
        "awayTeam": "Notre Dame",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2097,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856722,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-17T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3835,
        "venue": "Memorial Stadium (Norman, OK)",
        "homeId": 201,
        "homeTeam": "Oklahoma",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1747,
        "homePostgameElo": null,
        "awayId": 96,
        "awayTeam": "Kentucky",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1568,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862804,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-18T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3604,
        "venue": "Alamodome",
        "homeId": 2636,
        "homeTeam": "UTSA",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1521,
        "homePostgameElo": null,
        "awayId": 2426,
        "awayTeam": "Navy",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1495,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871091,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-18T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3817,
        "venue": "Malone Stadium",
        "homeId": 2433,
        "homeTeam": "UL Monroe",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1014,
        "homePostgameElo": null,
        "awayId": 2348,
        "awayTeam": "Louisiana Tech",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1382,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864523,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-18T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3946,
        "venue": "Sun Bowl",
        "homeId": 2638,
        "homeTeam": "UTEP",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 986,
        "homePostgameElo": null,
        "awayId": 23,
        "awayTeam": "San José State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1386,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866445,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-18T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3757,
        "venue": "Hornet Stadium",
        "homeId": 16,
        "homeTeam": "Sacramento State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1110,
        "homePostgameElo": null,
        "awayId": 195,
        "awayTeam": "Ohio",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1339,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856833,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-18T02:15:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3726,
        "venue": "Folsom Field",
        "homeId": 38,
        "homeTeam": "Colorado",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1325,
        "homePostgameElo": null,
        "awayId": 254,
        "awayTeam": "Utah",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1929,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860904,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-18T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7311,
        "venue": "Snapdragon Stadium",
        "homeId": 21,
        "homeTeam": "San Diego State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1254,
        "homePostgameElo": null,
        "awayId": 278,
        "awayTeam": "Fresno State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1635,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858269,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-18T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3831,
        "venue": "California Memorial Stadium",
        "homeId": 25,
        "homeTeam": "California",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1347,
        "homePostgameElo": null,
        "awayId": 154,
        "awayTeam": "Wake Forest",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1715,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864521,
        "season": 2026,
        "week": 7,
        "seasonType": "regular",
        "startDate": "2026-10-18T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7220,
        "venue": "Clarence T.C. Ching Athletics Complex",
        "homeId": 62,
        "homeTeam": "Hawai'i",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1338,
        "homePostgameElo": null,
        "awayId": 167,
        "awayTeam": "New Mexico",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1683,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871069,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-20T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3695,
        "venue": "Delaware Stadium",
        "homeId": 48,
        "homeTeam": "Delaware",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1328,
        "homePostgameElo": null,
        "awayId": 2623,
        "awayTeam": "Missouri State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1231,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871055,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-20T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 2031,
        "venue": "Pitbull Stadium",
        "homeId": 2229,
        "homeTeam": "Florida International",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1425,
        "homePostgameElo": null,
        "awayId": 2393,
        "awayTeam": "Middle Tennessee",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1146,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871092,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-20T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3775,
        "venue": "Joan C. Edwards Stadium",
        "homeId": 276,
        "homeTeam": "Marshall",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1344,
        "homePostgameElo": null,
        "awayId": 6,
        "awayTeam": "South Alabama",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1365,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871070,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-22T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3647,
        "venue": "Elliott T. Bowers Stadium",
        "homeId": 2534,
        "homeTeam": "Sam Houston",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1121,
        "homePostgameElo": null,
        "awayId": 166,
        "awayTeam": "New Mexico State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1249,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869845,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-22T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3792,
        "venue": "Kidd Brewer Stadium",
        "homeId": 2026,
        "homeTeam": "App State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1297,
        "homePostgameElo": null,
        "awayId": 256,
        "awayTeam": "James Madison",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1800,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871056,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-22T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4899,
        "venue": "Fifth Third Stadium",
        "homeId": 338,
        "homeTeam": "Kennesaw State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1290,
        "homePostgameElo": null,
        "awayId": 2335,
        "awayTeam": "Liberty",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1746,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862807,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-22T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3805,
        "venue": "Simmons Bank Liberty Stadium",
        "homeId": 235,
        "homeTeam": "Memphis",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1665,
        "homePostgameElo": null,
        "awayId": 151,
        "awayTeam": "East Carolina",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1466,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858271,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-23T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3923,
        "venue": "Scott Stadium",
        "homeId": 258,
        "homeTeam": "Virginia",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1592,
        "homePostgameElo": null,
        "awayId": 150,
        "awayTeam": "Duke",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1653,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401861965,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-23T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3892,
        "venue": "Pratt & Whitney Stadium",
        "homeId": 41,
        "homeTeam": "UConn",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1483,
        "homePostgameElo": null,
        "awayId": 113,
        "awayTeam": "Massachusetts",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1129,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862808,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3674,
        "venue": "Chapman Stadium",
        "homeId": 202,
        "homeTeam": "Tulsa",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1241,
        "homePostgameElo": null,
        "awayId": 349,
        "awayTeam": "Army",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1523,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864525,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3984,
        "venue": "War Memorial Stadium",
        "homeId": 2751,
        "homeTeam": "Wyoming",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1292,
        "homePostgameElo": null,
        "awayId": 2005,
        "awayTeam": "Air Force",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1464,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858272,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3940,
        "venue": "Stanford Stadium",
        "homeId": 24,
        "homeTeam": "Stanford",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1151,
        "homePostgameElo": null,
        "awayId": 152,
        "awayTeam": "NC State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1471,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856732,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3910,
        "venue": "DKR-Texas Memorial Stadium",
        "homeId": 251,
        "homeTeam": "Texas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1914,
        "homePostgameElo": null,
        "awayId": 145,
        "awayTeam": "Ole Miss",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1868,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856731,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3994,
        "venue": "Williams-Brice Stadium",
        "homeId": 2579,
        "homeTeam": "South Carolina",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1699,
        "homePostgameElo": null,
        "awayId": 2633,
        "awayTeam": "Tennessee",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1776,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "AFTERNOON: 3:30 - 4:30pm ET start",
        "playoff": null
    },
    {
        "id": 401862811,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4729,
        "venue": "Yulman Stadium",
        "homeId": 2655,
        "homeTeam": "Tulane",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1516,
        "homePostgameElo": null,
        "awayId": 2636,
        "awayTeam": "UTSA",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1521,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856729,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3683,
        "venue": "Kroger Field",
        "homeId": 96,
        "homeTeam": "Kentucky",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1568,
        "homePostgameElo": null,
        "awayId": 238,
        "awayTeam": "Vanderbilt",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1610,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "NIGHT: 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856727,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3657,
        "venue": "Bryant-Denny Stadium",
        "homeId": 333,
        "homeTeam": "Alabama",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1990,
        "homePostgameElo": null,
        "awayId": 245,
        "awayTeam": "Texas A&M",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1733,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856835,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3652,
        "venue": "FBC Mortgage Stadium",
        "homeId": 2116,
        "homeTeam": "UCF",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1445,
        "homePostgameElo": null,
        "awayId": 252,
        "awayTeam": "BYU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1725,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856839,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3947,
        "venue": "Mountain America Stadium",
        "homeId": 9,
        "homeTeam": "Arizona State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1464,
        "homePostgameElo": null,
        "awayId": 2306,
        "awayTeam": "Kansas State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1617,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858276,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3836,
        "venue": "Memorial Stadium (Clemson, SC)",
        "homeId": 228,
        "homeTeam": "Clemson",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1541,
        "homePostgameElo": null,
        "awayId": 259,
        "awayTeam": "Virginia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1489,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866446,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3696,
        "venue": "Dix Stadium",
        "homeId": 2309,
        "homeTeam": "Kent State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1014,
        "homePostgameElo": null,
        "awayId": 2006,
        "awayTeam": "Akron",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 879,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856730,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3693,
        "venue": "Davis Wade Stadium",
        "homeId": 344,
        "homeTeam": "Mississippi State",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1612,
        "homePostgameElo": null,
        "awayId": 201,
        "awayTeam": "Oklahoma",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1747,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401871094,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3975,
        "venue": "Veterans Memorial Stadium (AL)",
        "homeId": 2653,
        "homeTeam": "Troy",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1428,
        "homePostgameElo": null,
        "awayId": 2433,
        "awayTeam": "UL Monroe",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1014,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871093,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3776,
        "venue": "Joe Aillet Stadium",
        "homeId": 2348,
        "homeTeam": "Louisiana Tech",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1382,
        "homePostgameElo": null,
        "awayId": 295,
        "awayTeam": "Old Dominion",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1220,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858497,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3953,
        "venue": "Huntington Bank Stadium",
        "homeId": 135,
        "homeTeam": "Minnesota",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1427,
        "homePostgameElo": null,
        "awayId": 2294,
        "awayTeam": "Iowa",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1853,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866450,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3739,
        "venue": "Glass Bowl",
        "homeId": 2649,
        "homeTeam": "Toledo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1529,
        "homePostgameElo": null,
        "awayId": 2711,
        "awayTeam": "Western Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1493,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866476,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3786,
        "venue": "Kelly/Shorts Stadium",
        "homeId": 2117,
        "homeTeam": "Central Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1216,
        "homePostgameElo": null,
        "awayId": 193,
        "awayTeam": "Miami (OH)",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1248,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869967,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3815,
        "venue": "M. M. Roberts Stadium",
        "homeId": 2572,
        "homeTeam": "Southern Miss",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1194,
        "homePostgameElo": null,
        "awayId": 309,
        "awayTeam": "Louisiana",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1439,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858273,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 721,
        "venue": "Bobby Dodd Stadium",
        "homeId": 59,
        "homeTeam": "Georgia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1496,
        "homePostgameElo": null,
        "awayId": 103,
        "awayTeam": "Boston College",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1381,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858270,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3735,
        "venue": "Gerald J. Ford Stadium",
        "homeId": 2567,
        "homeTeam": "SMU",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1689,
        "homePostgameElo": null,
        "awayId": 25,
        "awayTeam": "California",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1347,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856834,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3833,
        "venue": "Memorial Stadium",
        "homeId": 2305,
        "homeTeam": "Kansas",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1614,
        "homePostgameElo": null,
        "awayId": 239,
        "awayTeam": "Baylor",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1643,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858274,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3948,
        "venue": "Hard Rock Stadium",
        "homeId": 2390,
        "homeTeam": "Miami",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1993,
        "homePostgameElo": null,
        "awayId": 221,
        "awayTeam": "Pittsburgh",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1645,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858495,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3832,
        "venue": "Memorial Stadium (Champaign, IL)",
        "homeId": 356,
        "homeTeam": "Illinois",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1536,
        "homePostgameElo": null,
        "awayId": 2483,
        "awayTeam": "Oregon",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1831,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858496,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3558,
        "venue": "Michigan Stadium",
        "homeId": 130,
        "homeTeam": "Michigan",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1719,
        "homePostgameElo": null,
        "awayId": 84,
        "awayTeam": "Indiana",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2098,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858498,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 11823,
        "venue": "Ryan Field",
        "homeId": 77,
        "homeTeam": "Northwestern",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1731,
        "homePostgameElo": null,
        "awayId": 164,
        "awayTeam": "Rutgers",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1383,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858275,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3787,
        "venue": "Kenan Stadium",
        "homeId": 153,
        "homeTeam": "North Carolina",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1449,
        "homePostgameElo": null,
        "awayId": 183,
        "awayTeam": "Syracuse",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1303,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856838,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3619,
        "venue": "Arizona Stadium",
        "homeId": 12,
        "homeTeam": "Arizona",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1719,
        "homePostgameElo": null,
        "awayId": 66,
        "awayTeam": "Iowa State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1643,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856837,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 587,
        "venue": "Rice-Eccles Stadium",
        "homeId": 254,
        "homeTeam": "Utah",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1929,
        "homePostgameElo": null,
        "awayId": 248,
        "awayTeam": "Houston",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1612,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856840,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3854,
        "venue": "Nippert Stadium",
        "homeId": 2132,
        "homeTeam": "Cincinnati",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1469,
        "homePostgameElo": null,
        "awayId": 2641,
        "awayTeam": "Texas Tech",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1862,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856836,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3646,
        "venue": "Boone Pickens Stadium",
        "homeId": 197,
        "homeTeam": "Oklahoma State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1373,
        "homePostgameElo": null,
        "awayId": 38,
        "awayTeam": "Colorado",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1325,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856841,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3616,
        "venue": "Amon G. Carter Stadium",
        "homeId": 2628,
        "homeTeam": "TCU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1600,
        "homePostgameElo": null,
        "awayId": 277,
        "awayTeam": "West Virginia",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1338,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858499,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1056,
        "venue": "Rose Bowl",
        "homeId": 26,
        "homeTeam": "UCLA",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1673,
        "homePostgameElo": null,
        "awayId": 127,
        "awayTeam": "Michigan State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1452,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858500,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 347,
        "venue": "Camp Randall Stadium",
        "homeId": 275,
        "homeTeam": "Wisconsin",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1673,
        "homePostgameElo": null,
        "awayId": 30,
        "awayTeam": "USC",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1804,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862809,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3715,
        "venue": "FAU Stadium",
        "homeId": 2226,
        "homeTeam": "Florida Atlantic",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1300,
        "homePostgameElo": null,
        "awayId": 242,
        "awayTeam": "Rice",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1174,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864526,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3764,
        "venue": "Huskie Stadium",
        "homeId": 2459,
        "homeTeam": "Northern Illinois",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1167,
        "homePostgameElo": null,
        "awayId": 62,
        "awayTeam": "Hawai'i",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1338,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866448,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3965,
        "venue": "UB Stadium",
        "homeId": 2084,
        "homeTeam": "Buffalo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1363,
        "homePostgameElo": null,
        "awayId": 189,
        "awayTeam": "Bowling Green",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1245,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866447,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3919,
        "venue": "Scheumann Stadium",
        "homeId": 2050,
        "homeTeam": "Ball State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1054,
        "homePostgameElo": null,
        "awayId": 16,
        "awayTeam": "Sacramento State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1110,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866449,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3876,
        "venue": "Peden Stadium",
        "homeId": 195,
        "homeTeam": "Ohio",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1339,
        "homePostgameElo": null,
        "awayId": 2199,
        "awayTeam": "Eastern Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1235,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856728,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3785,
        "venue": "Jordan-Hare Stadium",
        "homeId": 2,
        "homeTeam": "Auburn",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1669,
        "homePostgameElo": null,
        "awayId": 99,
        "awayTeam": "LSU",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1859,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862810,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3852,
        "venue": "Navy-Marine Corps Memorial Stadium",
        "homeId": 2426,
        "homeTeam": "Navy",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1495,
        "homePostgameElo": null,
        "awayId": 249,
        "awayTeam": "North Texas",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1669,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864528,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3816,
        "venue": "Mackay Stadium",
        "homeId": 2440,
        "homeTeam": "Nevada",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1433,
        "homePostgameElo": null,
        "awayId": 23,
        "awayTeam": "San José State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1386,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860907,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3820,
        "venue": "Gesa Field",
        "homeId": 265,
        "homeTeam": "Washington State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1476,
        "homePostgameElo": null,
        "awayId": 68,
        "awayTeam": "Boise State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1691,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860905,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T22:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 5388,
        "venue": "Canvas Stadium",
        "homeId": 36,
        "homeTeam": "Colorado State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1233,
        "homePostgameElo": null,
        "awayId": 21,
        "awayTeam": "San Diego State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1254,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869935,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3625,
        "venue": "Centennial Bank Stadium",
        "homeId": 2032,
        "homeTeam": "Arkansas State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1310,
        "homePostgameElo": null,
        "awayId": 2247,
        "awayTeam": "Georgia State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1402,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860906,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-24T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3644,
        "venue": "Bobcat Stadium (TX)",
        "homeId": 326,
        "homeTeam": "Texas State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1489,
        "homePostgameElo": null,
        "awayId": 328,
        "awayTeam": "Utah State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1362,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864527,
        "season": 2026,
        "week": 8,
        "seasonType": "regular",
        "startDate": "2026-10-25T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3971,
        "venue": "University Stadium (NM)",
        "homeId": 167,
        "homeTeam": "New Mexico",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1683,
        "homePostgameElo": null,
        "awayId": 2449,
        "awayTeam": "North Dakota State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1621,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871071,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-27T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3796,
        "venue": "Houchens Industries-L.T. Smith Stadium",
        "homeId": 98,
        "homeTeam": "Western Kentucky",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1252,
        "homePostgameElo": null,
        "awayId": 48,
        "awayTeam": "Delaware",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1328,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871072,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-28T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3878,
        "venue": "Plaster Sports Complex",
        "homeId": 2623,
        "homeTeam": "Missouri State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1231,
        "homePostgameElo": null,
        "awayId": 2534,
        "awayTeam": "Sam Houston",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1121,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871058,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-28T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3725,
        "venue": "Johnny \"Red\" Floyd Stadium",
        "homeId": 2393,
        "homeTeam": "Middle Tennessee",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1146,
        "homePostgameElo": null,
        "awayId": 338,
        "awayTeam": "Kennesaw State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1290,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871057,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-29T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3601,
        "venue": "Aggie Memorial Stadium",
        "homeId": 166,
        "homeTeam": "New Mexico State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1249,
        "homePostgameElo": null,
        "awayId": 55,
        "awayTeam": "Jacksonville State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1429,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869963,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-29T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3651,
        "venue": "Bridgeforth Stadium",
        "homeId": 256,
        "homeTeam": "James Madison",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1800,
        "homePostgameElo": null,
        "awayId": 2653,
        "awayTeam": "Troy",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1428,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862812,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-29T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3825,
        "venue": "DATCU Stadium",
        "homeId": 249,
        "homeTeam": "North Texas",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1669,
        "homePostgameElo": null,
        "awayId": 2226,
        "awayTeam": "Florida Atlantic",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1300,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862813,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-30T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4418,
        "venue": "Jerry Richardson Stadium",
        "homeId": 2429,
        "homeTeam": "Charlotte",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 982,
        "homePostgameElo": null,
        "awayId": 2655,
        "awayTeam": "Tulane",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1516,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856844,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-30T23:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3652,
        "venue": "FBC Mortgage Stadium",
        "homeId": 2116,
        "homeTeam": "UCF",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1445,
        "homePostgameElo": null,
        "awayId": 239,
        "awayTeam": "Baylor",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1643,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866451,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3757,
        "venue": "Hornet Stadium",
        "homeId": 16,
        "homeTeam": "Sacramento State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1110,
        "homePostgameElo": null,
        "awayId": 2309,
        "awayTeam": "Kent State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1014,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871097,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6526,
        "venue": "Hancock Whitney Stadium",
        "homeId": 6,
        "homeTeam": "South Alabama",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1365,
        "homePostgameElo": null,
        "awayId": 2348,
        "awayTeam": "Louisiana Tech",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1382,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862816,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3886,
        "venue": "Raymond James Stadium",
        "homeId": 58,
        "homeTeam": "South Florida",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1606,
        "homePostgameElo": null,
        "awayId": 5,
        "awayTeam": "UAB",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1362,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858277,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3670,
        "venue": "Carter-Finley Stadium",
        "homeId": 152,
        "homeTeam": "NC State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1471,
        "homePostgameElo": null,
        "awayId": 25,
        "awayTeam": "California",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1347,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858506,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3632,
        "venue": "Beaver Stadium",
        "homeId": 213,
        "homeTeam": "Penn State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1802,
        "homePostgameElo": null,
        "awayId": 2509,
        "awayTeam": "Purdue",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1425,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871096,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3918,
        "venue": "S.B. Ballard Stadium",
        "homeId": 295,
        "homeTeam": "Old Dominion",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1220,
        "homePostgameElo": null,
        "awayId": 276,
        "awayTeam": "Marshall",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1344,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856845,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3616,
        "venue": "Amon G. Carter Stadium",
        "homeId": 2628,
        "homeTeam": "TCU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1600,
        "homePostgameElo": null,
        "awayId": 2305,
        "awayTeam": "Kansas",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1614,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871095,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3817,
        "venue": "Malone Stadium",
        "homeId": 2433,
        "homeTeam": "UL Monroe",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1014,
        "homePostgameElo": null,
        "awayId": 2572,
        "awayTeam": "Southern Miss",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1194,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862815,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3699,
        "venue": "Dowdy-Ficklen Stadium",
        "homeId": 151,
        "homeTeam": "East Carolina",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1466,
        "homePostgameElo": null,
        "awayId": 218,
        "awayTeam": "Temple",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1342,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862814,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3805,
        "venue": "Simmons Bank Liberty Stadium",
        "homeId": 235,
        "homeTeam": "Memphis",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1665,
        "homePostgameElo": null,
        "awayId": 349,
        "awayTeam": "Army",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1523,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858508,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 1056,
        "venue": "Rose Bowl",
        "homeId": 26,
        "homeTeam": "UCLA",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1673,
        "homePostgameElo": null,
        "awayId": 2440,
        "awayTeam": "Nevada",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1433,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858503,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3665,
        "venue": "SECU Stadium",
        "homeId": 120,
        "homeTeam": "Maryland",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1301,
        "homePostgameElo": null,
        "awayId": 356,
        "awayTeam": "Illinois",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1536,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858283,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3873,
        "venue": "L&N Federal Credit Union Stadium",
        "homeId": 97,
        "homeTeam": "Louisville",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1729,
        "homePostgameElo": null,
        "awayId": 24,
        "awayTeam": "Stanford",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1151,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858280,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3697,
        "venue": "Doak Campbell Stadium",
        "homeId": 52,
        "homeTeam": "Florida State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1598,
        "homePostgameElo": null,
        "awayId": 228,
        "awayTeam": "Clemson",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1541,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856847,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3772,
        "venue": "Jack Trice Stadium",
        "homeId": 66,
        "homeTeam": "Iowa State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1643,
        "homePostgameElo": null,
        "awayId": 197,
        "awayTeam": "Oklahoma State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1373,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856842,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3784,
        "venue": "Jones AT&T Stadium",
        "homeId": 2641,
        "homeTeam": "Texas Tech",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1862,
        "homePostgameElo": null,
        "awayId": 12,
        "awayTeam": "Arizona",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1719,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858505,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3626,
        "venue": "Autzen Stadium",
        "homeId": 2483,
        "homeTeam": "Oregon",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1831,
        "homePostgameElo": null,
        "awayId": 77,
        "awayTeam": "Northwestern",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1731,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856733,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3887,
        "venue": "Razorback Stadium",
        "homeId": 8,
        "homeTeam": "Arkansas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1482,
        "homePostgameElo": null,
        "awayId": 142,
        "awayTeam": "Missouri",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1814,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401858278,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1964,
        "venue": "JMA Wireless Dome",
        "homeId": 183,
        "homeTeam": "Syracuse",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1303,
        "homePostgameElo": null,
        "awayId": 2567,
        "awayTeam": "SMU",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1689,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858279,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3982,
        "venue": "Wallace Wade Stadium",
        "homeId": 150,
        "homeTeam": "Duke",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1653,
        "homePostgameElo": null,
        "awayId": 103,
        "awayTeam": "Boston College",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1381,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858281,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3752,
        "venue": "Acrisure Stadium",
        "homeId": 221,
        "homeTeam": "Pittsburgh",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1645,
        "homePostgameElo": null,
        "awayId": 59,
        "awayTeam": "Georgia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1496,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858282,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3787,
        "venue": "Kenan Stadium",
        "homeId": 153,
        "homeTeam": "North Carolina",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1449,
        "homePostgameElo": null,
        "awayId": 2390,
        "awayTeam": "Miami",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1993,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858504,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3834,
        "venue": "Memorial Stadium (Lincoln, NE)",
        "homeId": 158,
        "homeTeam": "Nebraska",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1767,
        "homePostgameElo": null,
        "awayId": 264,
        "awayTeam": "Washington",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1702,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869846,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3608,
        "venue": "Allen E. Paulson Stadium",
        "homeId": 290,
        "homeTeam": "Georgia Southern",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1370,
        "homePostgameElo": null,
        "awayId": 2026,
        "awayTeam": "App State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1297,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858501,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3830,
        "venue": "Memorial Stadium (Bloomington, IN)",
        "homeId": 84,
        "homeTeam": "Indiana",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2098,
        "homePostgameElo": null,
        "awayId": 135,
        "awayTeam": "Minnesota",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1427,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858502,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3793,
        "venue": "Kinnick Stadium",
        "homeId": 2294,
        "homeTeam": "Iowa",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1853,
        "homePostgameElo": null,
        "awayId": 275,
        "awayTeam": "Wisconsin",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1673,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858507,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6577,
        "venue": "SHI Stadium",
        "homeId": 164,
        "homeTeam": "Rutgers",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1383,
        "homePostgameElo": null,
        "awayId": 130,
        "awayTeam": "Michigan",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1719,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858284,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3630,
        "venue": "Allegacy Federal Credit Union Stadium",
        "homeId": 154,
        "homeTeam": "Wake Forest",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1715,
        "homePostgameElo": null,
        "awayId": 258,
        "awayTeam": "Virginia",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1592,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869944,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4246,
        "venue": "Center Parc Stadium",
        "homeId": 2247,
        "homeTeam": "Georgia State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1402,
        "homePostgameElo": null,
        "awayId": 324,
        "awayTeam": "Coastal Carolina",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1281,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856843,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3801,
        "venue": "LaVell Edwards Stadium",
        "homeId": 252,
        "homeTeam": "BYU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1725,
        "homePostgameElo": null,
        "awayId": 9,
        "awayTeam": "Arizona State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1464,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858509,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 477,
        "venue": "Los Angeles Memorial Coliseum",
        "homeId": 30,
        "homeTeam": "USC",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1804,
        "homePostgameElo": null,
        "awayId": 194,
        "awayTeam": "Ohio State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2060,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860924,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3660,
        "venue": "Valley Children's Stadium",
        "homeId": 278,
        "homeTeam": "Fresno State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1635,
        "homePostgameElo": null,
        "awayId": 204,
        "awayTeam": "Oregon State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1581,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856736,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3835,
        "venue": "Memorial Stadium (Norman, OK)",
        "homeId": 201,
        "homeTeam": "Oklahoma",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1747,
        "homePostgameElo": null,
        "awayId": 2579,
        "awayTeam": "South Carolina",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1699,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856735,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3974,
        "venue": "Vaught-Hemingway Stadium",
        "homeId": 145,
        "homeTeam": "Ole Miss",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1868,
        "homePostgameElo": null,
        "awayId": 2,
        "awayTeam": "Auburn",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1669,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401856737,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3910,
        "venue": "DKR-Texas Memorial Stadium",
        "homeId": 251,
        "homeTeam": "Texas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1914,
        "homePostgameElo": null,
        "awayId": 344,
        "awayTeam": "Mississippi State",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1612,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "NIGHT: 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856846,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3726,
        "venue": "Folsom Field",
        "homeId": 38,
        "homeTeam": "Colorado",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1325,
        "homePostgameElo": null,
        "awayId": 2306,
        "awayTeam": "Kansas State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1617,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856848,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3854,
        "venue": "Nippert Stadium",
        "homeId": 2132,
        "homeTeam": "Cincinnati",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1469,
        "homePostgameElo": null,
        "awayId": 254,
        "awayTeam": "Utah",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1929,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864529,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T04:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3935,
        "venue": "CEFCU Stadium",
        "homeId": 23,
        "homeTeam": "San José State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1386,
        "homePostgameElo": null,
        "awayId": 167,
        "awayTeam": "New Mexico",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1683,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401859185,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": true,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3738,
        "venue": "Gillette Stadium",
        "homeId": 2426,
        "homeTeam": "Navy",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1495,
        "homePostgameElo": null,
        "awayId": 87,
        "awayTeam": "Notre Dame",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2097,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866452,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T16:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3980,
        "venue": "Waldo Stadium",
        "homeId": 2711,
        "homeTeam": "Western Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1493,
        "homePostgameElo": null,
        "awayId": 189,
        "awayTeam": "Bowling Green",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1245,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401861966,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3713,
        "venue": "Falcon Stadium",
        "homeId": 2005,
        "homeTeam": "Air Force",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1464,
        "homePostgameElo": null,
        "awayId": 41,
        "awayTeam": "UConn",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1483,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864531,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3714,
        "venue": "Fargodome",
        "homeId": 2449,
        "homeTeam": "North Dakota State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1621,
        "homePostgameElo": null,
        "awayId": 2638,
        "awayTeam": "UTEP",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 986,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871059,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3992,
        "venue": "Williams Stadium (VA)",
        "homeId": 2335,
        "homeTeam": "Liberty",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1746,
        "homePostgameElo": null,
        "awayId": 2229,
        "awayTeam": "Florida International",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1425,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860910,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3905,
        "venue": "Maverik Stadium",
        "homeId": 328,
        "homeTeam": "Utah State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1362,
        "homePostgameElo": null,
        "awayId": 36,
        "awayTeam": "Colorado State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1233,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856734,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T19:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": true,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 5348,
        "venue": "Mercedes-Benz Stadium",
        "homeId": 61,
        "homeTeam": "Georgia",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2053,
        "homePostgameElo": null,
        "awayId": 57,
        "awayTeam": "Florida",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1619,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860909,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-10-31T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7311,
        "venue": "Snapdragon Stadium",
        "homeId": 21,
        "homeTeam": "San Diego State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1254,
        "homePostgameElo": null,
        "awayId": 265,
        "awayTeam": "Washington State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1476,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860908,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-11-01T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3653,
        "venue": "Albertsons Stadium",
        "homeId": 68,
        "homeTeam": "Boise State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1691,
        "homePostgameElo": null,
        "awayId": 326,
        "awayTeam": "Texas State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1489,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864530,
        "season": 2026,
        "week": 9,
        "seasonType": "regular",
        "startDate": "2026-11-01T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6501,
        "venue": "Allegiant Stadium",
        "homeId": 2439,
        "homeTeam": "UNLV",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1509,
        "homePostgameElo": null,
        "awayId": 2459,
        "awayTeam": "Northern Illinois",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1167,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866453,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-04T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3768,
        "venue": "InfoCision Stadium",
        "homeId": 2006,
        "homeTeam": "Akron",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 879,
        "homePostgameElo": null,
        "awayId": 195,
        "awayTeam": "Ohio",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1339,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866454,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-04T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3996,
        "venue": "Yager Stadium",
        "homeId": 193,
        "homeTeam": "Miami (OH)",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1248,
        "homePostgameElo": null,
        "awayId": 2084,
        "awayTeam": "Buffalo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1363,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866455,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-04T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3985,
        "venue": "Warren McGuirk Alumni Stadium",
        "homeId": 113,
        "homeTeam": "Massachusetts",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1129,
        "homePostgameElo": null,
        "awayId": 2050,
        "awayTeam": "Ball State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1054,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866457,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-04T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3757,
        "venue": "Hornet Stadium",
        "homeId": 16,
        "homeTeam": "Sacramento State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1110,
        "homePostgameElo": null,
        "awayId": 2649,
        "awayTeam": "Toledo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1529,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866456,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-04T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": true,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3727,
        "venue": "Ford Field",
        "homeId": 2199,
        "homeTeam": "Eastern Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1235,
        "homePostgameElo": null,
        "awayId": 2117,
        "awayTeam": "Central Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1216,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869964,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-06T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3815,
        "venue": "M. M. Roberts Stadium",
        "homeId": 2572,
        "homeTeam": "Southern Miss",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1194,
        "homePostgameElo": null,
        "awayId": 256,
        "awayTeam": "James Madison",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1800,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862817,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-06T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3715,
        "venue": "FAU Stadium",
        "homeId": 2226,
        "homeTeam": "Florida Atlantic",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1300,
        "homePostgameElo": null,
        "awayId": 2636,
        "awayTeam": "UTSA",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1521,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858288,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3735,
        "venue": "Gerald J. Ford Stadium",
        "homeId": 2567,
        "homeTeam": "SMU",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1689,
        "homePostgameElo": null,
        "awayId": 259,
        "awayTeam": "Virginia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1489,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862818,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3699,
        "venue": "Dowdy-Ficklen Stadium",
        "homeId": 151,
        "homeTeam": "East Carolina",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1466,
        "homePostgameElo": null,
        "awayId": 58,
        "awayTeam": "South Florida",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1606,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858510,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3832,
        "venue": "Memorial Stadium (Champaign, IL)",
        "homeId": 356,
        "homeTeam": "Illinois",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1536,
        "homePostgameElo": null,
        "awayId": 158,
        "awayTeam": "Nebraska",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1767,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864533,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3816,
        "venue": "Mackay Stadium",
        "homeId": 2440,
        "homeTeam": "Nevada",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1433,
        "homePostgameElo": null,
        "awayId": 167,
        "awayTeam": "New Mexico",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1683,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856855,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T03:15:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3619,
        "venue": "Arizona Stadium",
        "homeId": 12,
        "homeTeam": "Arizona",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1719,
        "homePostgameElo": null,
        "awayId": 2628,
        "awayTeam": "TCU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1600,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858290,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3630,
        "venue": "Allegacy Federal Credit Union Stadium",
        "homeId": 154,
        "homeTeam": "Wake Forest",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1728,
        "homePostgameElo": 1728,
        "awayId": 2771,
        "awayTeam": "Merrimack",
        "awayClassification": "fcs",
        "awayConference": "FCS Independents",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864534,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3935,
        "venue": "CEFCU Stadium",
        "homeId": 23,
        "homeTeam": "San José State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1386,
        "homePostgameElo": null,
        "awayId": 2459,
        "awayTeam": "Northern Illinois",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1167,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856742,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3693,
        "venue": "Davis Wade Stadium",
        "homeId": 344,
        "homeTeam": "Mississippi State",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1612,
        "homePostgameElo": null,
        "awayId": 238,
        "awayTeam": "Vanderbilt",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1610,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401871098,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3975,
        "venue": "Veterans Memorial Stadium (AL)",
        "homeId": 2653,
        "homeTeam": "Troy",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1428,
        "homePostgameElo": null,
        "awayId": 2348,
        "awayTeam": "Louisiana Tech",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1382,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856739,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3634,
        "venue": "Ben Hill Griffin Stadium",
        "homeId": 57,
        "homeTeam": "Florida",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1619,
        "homePostgameElo": null,
        "awayId": 201,
        "awayTeam": "Oklahoma",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1747,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856740,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3958,
        "venue": "Tiger Stadium (LA)",
        "homeId": 99,
        "homeTeam": "LSU",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1859,
        "homePostgameElo": null,
        "awayId": 333,
        "awayTeam": "Alabama",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1990,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856741,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3974,
        "venue": "Vaught-Hemingway Stadium",
        "homeId": 145,
        "homeTeam": "Ole Miss",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1868,
        "homePostgameElo": null,
        "awayId": 61,
        "awayTeam": "Georgia",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2053,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856743,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3838,
        "venue": "Memorial Stadium",
        "homeId": 142,
        "homeTeam": "Missouri",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1814,
        "homePostgameElo": null,
        "awayId": 251,
        "awayTeam": "Texas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1914,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401858514,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3861,
        "venue": "Ohio Stadium",
        "homeId": 194,
        "homeTeam": "Ohio State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2060,
        "homePostgameElo": null,
        "awayId": 2483,
        "awayTeam": "Oregon",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1831,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858517,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 347,
        "venue": "Camp Randall Stadium",
        "homeId": 275,
        "homeTeam": "Wisconsin",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1673,
        "homePostgameElo": null,
        "awayId": 164,
        "awayTeam": "Rutgers",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1383,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858516,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3765,
        "venue": "Husky Stadium",
        "homeId": 264,
        "homeTeam": "Washington",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1702,
        "homePostgameElo": null,
        "awayId": 213,
        "awayTeam": "Penn State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1802,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858515,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3907,
        "venue": "Ross-Ade Stadium",
        "homeId": 2509,
        "homeTeam": "Purdue",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1425,
        "homePostgameElo": null,
        "awayId": 120,
        "awayTeam": "Maryland",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1301,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869968,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3666,
        "venue": "Cajun Field",
        "homeId": 309,
        "homeTeam": "Louisiana",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1439,
        "homePostgameElo": null,
        "awayId": 6,
        "awayTeam": "South Alabama",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1365,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869951,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3608,
        "venue": "Allen E. Paulson Stadium",
        "homeId": 290,
        "homeTeam": "Georgia Southern",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1370,
        "homePostgameElo": null,
        "awayId": 276,
        "awayTeam": "Marshall",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1344,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869927,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3792,
        "venue": "Kidd Brewer Stadium",
        "homeId": 2026,
        "homeTeam": "App State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1297,
        "homePostgameElo": null,
        "awayId": 2247,
        "awayTeam": "Georgia State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1402,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862822,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4729,
        "venue": "Yulman Stadium",
        "homeId": 2655,
        "homeTeam": "Tulane",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1516,
        "homePostgameElo": null,
        "awayId": 202,
        "awayTeam": "Tulsa",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1241,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858289,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3615,
        "venue": "Alumni Stadium (Chestnut Hill, MA)",
        "homeId": 103,
        "homeTeam": "Boston College",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1381,
        "homePostgameElo": null,
        "awayId": 52,
        "awayTeam": "Florida State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1598,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856853,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4727,
        "venue": "McLane Stadium",
        "homeId": 239,
        "homeTeam": "Baylor",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1643,
        "homePostgameElo": null,
        "awayId": 66,
        "awayTeam": "Iowa State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1643,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856738,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3785,
        "venue": "Jordan-Hare Stadium",
        "homeId": 2,
        "homeTeam": "Auburn",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1669,
        "homePostgameElo": null,
        "awayId": 8,
        "awayTeam": "Arkansas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1482,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401858512,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3953,
        "venue": "Huntington Bank Stadium",
        "homeId": 135,
        "homeTeam": "Minnesota",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1427,
        "homePostgameElo": null,
        "awayId": 26,
        "awayTeam": "UCLA",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1673,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869945,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3654,
        "venue": "Brooks Stadium (SC)",
        "homeId": 324,
        "homeTeam": "Coastal Carolina",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1281,
        "homePostgameElo": null,
        "awayId": 295,
        "awayTeam": "Old Dominion",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1220,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856852,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3947,
        "venue": "Mountain America Stadium",
        "homeId": 9,
        "homeTeam": "Arizona State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1464,
        "homePostgameElo": null,
        "awayId": 38,
        "awayTeam": "Colorado",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1325,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856850,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3833,
        "venue": "Memorial Stadium",
        "homeId": 2305,
        "homeTeam": "Kansas",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1614,
        "homePostgameElo": null,
        "awayId": 2116,
        "awayTeam": "UCF",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1445,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856745,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3853,
        "venue": "Neyland Stadium",
        "homeId": 2633,
        "homeTeam": "Tennessee",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1776,
        "homePostgameElo": null,
        "awayId": 96,
        "awayTeam": "Kentucky",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1568,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "NIGHT: 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856851,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4728,
        "venue": "TDECU Stadium",
        "homeId": 248,
        "homeTeam": "Houston",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1612,
        "homePostgameElo": null,
        "awayId": 2132,
        "awayTeam": "Cincinnati",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1469,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858511,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3558,
        "venue": "Michigan Stadium",
        "homeId": 130,
        "homeTeam": "Michigan",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1719,
        "homePostgameElo": null,
        "awayId": 127,
        "awayTeam": "Michigan State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1452,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856744,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3994,
        "venue": "Williams-Brice Stadium",
        "homeId": 2579,
        "homeTeam": "South Carolina",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1699,
        "homePostgameElo": null,
        "awayId": 245,
        "awayTeam": "Texas A&M",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1733,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "AFTERNOON: 3:30 - 4:30pm ET start",
        "playoff": null
    },
    {
        "id": 401858513,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 11823,
        "venue": "Ryan Field",
        "homeId": 77,
        "homeTeam": "Northwestern",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1731,
        "homePostgameElo": null,
        "awayId": 2294,
        "awayTeam": "Iowa",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1853,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862821,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3825,
        "venue": "DATCU Stadium",
        "homeId": 249,
        "homeTeam": "North Texas",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1669,
        "homePostgameElo": null,
        "awayId": 242,
        "awayTeam": "Rice",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1174,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864532,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3946,
        "venue": "Sun Bowl",
        "homeId": 2638,
        "homeTeam": "UTEP",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 986,
        "homePostgameElo": null,
        "awayId": 62,
        "awayTeam": "Hawai'i",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1338,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862819,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7221,
        "venue": "Protective Stadium",
        "homeId": 5,
        "homeTeam": "UAB",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1362,
        "homePostgameElo": null,
        "awayId": 2429,
        "awayTeam": "Charlotte",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 982,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858287,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 721,
        "venue": "Bobby Dodd Stadium",
        "homeId": 59,
        "homeTeam": "Georgia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1496,
        "homePostgameElo": null,
        "awayId": 97,
        "awayTeam": "Louisville",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1729,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858286,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3670,
        "venue": "Carter-Finley Stadium",
        "homeId": 152,
        "homeTeam": "NC State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1471,
        "homePostgameElo": null,
        "awayId": 150,
        "awayTeam": "Duke",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1653,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858285,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1964,
        "venue": "JMA Wireless Dome",
        "homeId": 183,
        "homeTeam": "Syracuse",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1303,
        "homePostgameElo": null,
        "awayId": 228,
        "awayTeam": "Clemson",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1541,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856856,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3784,
        "venue": "Jones AT&T Stadium",
        "homeId": 2641,
        "homeTeam": "Texas Tech",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1862,
        "homePostgameElo": null,
        "awayId": 277,
        "awayTeam": "West Virginia",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1338,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856854,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3636,
        "venue": "Bill Snyder Family Stadium",
        "homeId": 2306,
        "homeTeam": "Kansas State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1617,
        "homePostgameElo": null,
        "awayId": 197,
        "awayTeam": "Oklahoma State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1373,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856849,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 587,
        "venue": "Rice-Eccles Stadium",
        "homeId": 254,
        "homeTeam": "Utah",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1929,
        "homePostgameElo": null,
        "awayId": 252,
        "awayTeam": "BYU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1725,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858292,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3892,
        "venue": "Pratt & Whitney Stadium",
        "homeId": 41,
        "homeTeam": "UConn",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1483,
        "homePostgameElo": null,
        "awayId": 153,
        "awayTeam": "North Carolina",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1449,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869936,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3625,
        "venue": "Centennial Bank Stadium",
        "homeId": 2032,
        "homeTeam": "Arkansas State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1310,
        "homePostgameElo": null,
        "awayId": 2433,
        "awayTeam": "UL Monroe",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1014,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871073,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4899,
        "venue": "Fifth Third Stadium",
        "homeId": 338,
        "homeTeam": "Kennesaw State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1290,
        "homePostgameElo": null,
        "awayId": 48,
        "awayTeam": "Delaware",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1328,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871076,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3725,
        "venue": "Johnny \"Red\" Floyd Stadium",
        "homeId": 2393,
        "homeTeam": "Middle Tennessee",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1146,
        "homePostgameElo": null,
        "awayId": 98,
        "awayTeam": "Western Kentucky",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1252,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862820,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3852,
        "venue": "Navy-Marine Corps Memorial Stadium",
        "homeId": 2426,
        "homeTeam": "Navy",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1495,
        "homePostgameElo": null,
        "awayId": 218,
        "awayTeam": "Temple",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1342,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871074,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 2031,
        "venue": "Pitbull Stadium",
        "homeId": 2229,
        "homeTeam": "Florida International",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1425,
        "homePostgameElo": null,
        "awayId": 2623,
        "awayTeam": "Missouri State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1231,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870795,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T22:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3601,
        "venue": "Aggie Memorial Stadium",
        "homeId": 166,
        "homeTeam": "New Mexico State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1249,
        "homePostgameElo": null,
        "awayId": 2335,
        "awayTeam": "Liberty",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1746,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860911,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-07T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 5388,
        "venue": "Canvas Stadium",
        "homeId": 36,
        "homeTeam": "Colorado State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1233,
        "homePostgameElo": null,
        "awayId": 68,
        "awayTeam": "Boise State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1691,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871075,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-08T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3662,
        "venue": "AmFirst Stadium",
        "homeId": 55,
        "homeTeam": "Jacksonville State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1429,
        "homePostgameElo": null,
        "awayId": 2534,
        "awayTeam": "Sam Houston",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1121,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858291,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-08T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3855,
        "venue": "Notre Dame Stadium",
        "homeId": 87,
        "homeTeam": "Notre Dame",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2097,
        "homePostgameElo": null,
        "awayId": 2390,
        "awayTeam": "Miami",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1993,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862823,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-08T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3841,
        "venue": "Michie Stadium",
        "homeId": 349,
        "homeTeam": "Army",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1523,
        "homePostgameElo": null,
        "awayId": 2005,
        "awayTeam": "Air Force",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1464,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860913,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-08T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3905,
        "venue": "Maverik Stadium",
        "homeId": 328,
        "homeTeam": "Utah State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1362,
        "homePostgameElo": null,
        "awayId": 278,
        "awayTeam": "Fresno State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1635,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864535,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-08T03:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6501,
        "venue": "Allegiant Stadium",
        "homeId": 2439,
        "homeTeam": "UNLV",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1509,
        "homePostgameElo": null,
        "awayId": 2751,
        "awayTeam": "Wyoming",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1292,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860912,
        "season": 2026,
        "week": 10,
        "seasonType": "regular",
        "startDate": "2026-11-08T03:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3893,
        "venue": "Reser Stadium",
        "homeId": 204,
        "homeTeam": "Oregon State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1581,
        "homePostgameElo": null,
        "awayId": 326,
        "awayTeam": "Texas State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1489,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866460,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-11T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3996,
        "venue": "Yager Stadium",
        "homeId": 193,
        "homeTeam": "Miami (OH)",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1248,
        "homePostgameElo": null,
        "awayId": 195,
        "awayTeam": "Ohio",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1339,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866458,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-11T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3768,
        "venue": "InfoCision Stadium",
        "homeId": 2006,
        "homeTeam": "Akron",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 879,
        "homePostgameElo": null,
        "awayId": 2711,
        "awayTeam": "Western Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1493,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866459,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-11T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3700,
        "venue": "Doyt L. Perry Stadium",
        "homeId": 189,
        "homeTeam": "Bowling Green",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1245,
        "homePostgameElo": null,
        "awayId": 2309,
        "awayTeam": "Kent State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1014,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866461,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-11T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3919,
        "venue": "Scheumann Stadium",
        "homeId": 2050,
        "homeTeam": "Ball State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1054,
        "homePostgameElo": null,
        "awayId": 2084,
        "awayTeam": "Buffalo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1363,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866463,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-11T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3739,
        "venue": "Glass Bowl",
        "homeId": 2649,
        "homeTeam": "Toledo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1529,
        "homePostgameElo": null,
        "awayId": 113,
        "awayTeam": "Massachusetts",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1129,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866462,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-11T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3786,
        "venue": "Kelly/Shorts Stadium",
        "homeId": 2117,
        "homeTeam": "Central Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1216,
        "homePostgameElo": null,
        "awayId": 16,
        "awayTeam": "Sacramento State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1110,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862824,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-13T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3886,
        "venue": "Raymond James Stadium",
        "homeId": 58,
        "homeTeam": "South Florida",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1606,
        "homePostgameElo": null,
        "awayId": 235,
        "awayTeam": "Memphis",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1665,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869969,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-13T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3817,
        "venue": "Malone Stadium",
        "homeId": 2433,
        "homeTeam": "UL Monroe",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1014,
        "homePostgameElo": null,
        "awayId": 309,
        "awayTeam": "Louisiana",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1439,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858293,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3752,
        "venue": "Acrisure Stadium",
        "homeId": 221,
        "homeTeam": "Pittsburgh",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1645,
        "homePostgameElo": null,
        "awayId": 52,
        "awayTeam": "Florida State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1598,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858526,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1056,
        "venue": "Rose Bowl",
        "homeId": 26,
        "homeTeam": "UCLA",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1673,
        "homePostgameElo": null,
        "awayId": 356,
        "awayTeam": "Illinois",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1536,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856860,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T03:15:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3726,
        "venue": "Folsom Field",
        "homeId": 38,
        "homeTeam": "Colorado",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1325,
        "homePostgameElo": null,
        "awayId": 248,
        "awayTeam": "Houston",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1612,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856883,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3917,
        "venue": "Sanford Stadium",
        "homeId": 61,
        "homeTeam": "Georgia",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2053,
        "homePostgameElo": null,
        "awayId": 142,
        "awayTeam": "Missouri",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1814,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856889,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3973,
        "venue": "FirstBank Stadium",
        "homeId": 238,
        "homeTeam": "Vanderbilt",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1610,
        "homePostgameElo": null,
        "awayId": 333,
        "awayTeam": "Alabama",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1990,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401858518,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3830,
        "venue": "Memorial Stadium (Bloomington, IN)",
        "homeId": 84,
        "homeTeam": "Indiana",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2098,
        "homePostgameElo": null,
        "awayId": 30,
        "awayTeam": "USC",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1804,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858519,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3793,
        "venue": "Kinnick Stadium",
        "homeId": 2294,
        "homeTeam": "Iowa",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1853,
        "homePostgameElo": null,
        "awayId": 2509,
        "awayTeam": "Purdue",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1425,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856887,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3835,
        "venue": "Memorial Stadium (Norman, OK)",
        "homeId": 201,
        "homeTeam": "Oklahoma",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1747,
        "homePostgameElo": null,
        "awayId": 145,
        "awayTeam": "Ole Miss",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1868,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "AFTERNOON: 3:30 - 4:30pm ET start",
        "playoff": null
    },
    {
        "id": 401856882,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3887,
        "venue": "Razorback Stadium",
        "homeId": 8,
        "homeTeam": "Arkansas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1482,
        "homePostgameElo": null,
        "awayId": 2579,
        "awayTeam": "South Carolina",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1699,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401869952,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4246,
        "venue": "Center Parc Stadium",
        "homeId": 2247,
        "homeTeam": "Georgia State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1402,
        "homePostgameElo": null,
        "awayId": 290,
        "awayTeam": "Georgia Southern",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1370,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858301,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3735,
        "venue": "Gerald J. Ford Stadium",
        "homeId": 2567,
        "homeTeam": "SMU",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1689,
        "homePostgameElo": null,
        "awayId": 154,
        "awayTeam": "Wake Forest",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1715,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858299,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3799,
        "venue": "Lane Stadium",
        "homeId": 259,
        "homeTeam": "Virginia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1489,
        "homePostgameElo": null,
        "awayId": 24,
        "awayTeam": "Stanford",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1151,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858298,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3787,
        "venue": "Kenan Stadium",
        "homeId": 153,
        "homeTeam": "North Carolina",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1449,
        "homePostgameElo": null,
        "awayId": 97,
        "awayTeam": "Louisville",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1729,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858297,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3836,
        "venue": "Memorial Stadium (Clemson, SC)",
        "homeId": 228,
        "homeTeam": "Clemson",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1541,
        "homePostgameElo": null,
        "awayId": 59,
        "awayTeam": "Georgia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1496,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858296,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3948,
        "venue": "Hard Rock Stadium",
        "homeId": 2390,
        "homeTeam": "Miami",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1993,
        "homePostgameElo": null,
        "awayId": 150,
        "awayTeam": "Duke",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1653,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858295,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3923,
        "venue": "Scott Stadium",
        "homeId": 258,
        "homeTeam": "Virginia",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1592,
        "homePostgameElo": null,
        "awayId": 25,
        "awayTeam": "California",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1347,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856859,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3772,
        "venue": "Jack Trice Stadium",
        "homeId": 66,
        "homeTeam": "Iowa State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1643,
        "homePostgameElo": null,
        "awayId": 2132,
        "awayTeam": "Cincinnati",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1469,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856861,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3842,
        "venue": "Milan Puskar Stadium",
        "homeId": 277,
        "homeTeam": "West Virginia",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1338,
        "homePostgameElo": null,
        "awayId": 2305,
        "awayTeam": "Kansas",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1614,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856863,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3646,
        "venue": "Boone Pickens Stadium",
        "homeId": 197,
        "homeTeam": "Oklahoma State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1373,
        "homePostgameElo": null,
        "awayId": 2641,
        "awayTeam": "Texas Tech",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1862,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856886,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3693,
        "venue": "Davis Wade Stadium",
        "homeId": 344,
        "homeTeam": "Mississippi State",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1612,
        "homePostgameElo": null,
        "awayId": 2,
        "awayTeam": "Auburn",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1669,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401856858,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3801,
        "venue": "LaVell Edwards Stadium",
        "homeId": 252,
        "homeTeam": "BYU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1725,
        "homePostgameElo": null,
        "awayId": 239,
        "awayTeam": "Baylor",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1643,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856864,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3619,
        "venue": "Arizona Stadium",
        "homeId": 12,
        "homeTeam": "Arizona",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1719,
        "homePostgameElo": null,
        "awayId": 254,
        "awayTeam": "Utah",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1929,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856857,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3652,
        "venue": "FBC Mortgage Stadium",
        "homeId": 2116,
        "homeTeam": "UCF",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1445,
        "homePostgameElo": null,
        "awayId": 9,
        "awayTeam": "Arizona State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1464,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858300,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3670,
        "venue": "Carter-Finley Stadium",
        "homeId": 152,
        "homeTeam": "NC State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1471,
        "homePostgameElo": null,
        "awayId": 183,
        "awayTeam": "Syracuse",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1303,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856884,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3683,
        "venue": "Kroger Field",
        "homeId": 96,
        "homeTeam": "Kentucky",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1568,
        "homePostgameElo": null,
        "awayId": 57,
        "awayTeam": "Florida",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1619,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "NIGHT: 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401864536,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3764,
        "venue": "Huskie Stadium",
        "homeId": 2459,
        "homeTeam": "Northern Illinois",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1167,
        "homePostgameElo": null,
        "awayId": 2440,
        "awayTeam": "Nevada",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1433,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864540,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3946,
        "venue": "Sun Bowl",
        "homeId": 2638,
        "homeTeam": "UTEP",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 986,
        "homePostgameElo": null,
        "awayId": 2751,
        "awayTeam": "Wyoming",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1292,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869928,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3775,
        "venue": "Joan C. Edwards Stadium",
        "homeId": 276,
        "homeTeam": "Marshall",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1344,
        "homePostgameElo": null,
        "awayId": 2026,
        "awayTeam": "App State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1297,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858522,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3861,
        "venue": "Ohio Stadium",
        "homeId": 194,
        "homeTeam": "Ohio State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2060,
        "homePostgameElo": null,
        "awayId": 77,
        "awayTeam": "Northwestern",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1731,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862826,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3674,
        "venue": "Chapman Stadium",
        "homeId": 202,
        "homeTeam": "Tulsa",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1241,
        "homePostgameElo": null,
        "awayId": 2226,
        "awayTeam": "Florida Atlantic",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1300,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858525,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6577,
        "venue": "SHI Stadium",
        "homeId": 164,
        "homeTeam": "Rutgers",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1383,
        "homePostgameElo": null,
        "awayId": 158,
        "awayTeam": "Nebraska",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1767,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858520,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3665,
        "venue": "SECU Stadium",
        "homeId": 120,
        "homeTeam": "Maryland",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1301,
        "homePostgameElo": null,
        "awayId": 275,
        "awayTeam": "Wisconsin",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1673,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869937,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3654,
        "venue": "Brooks Stadium (SC)",
        "homeId": 324,
        "homeTeam": "Coastal Carolina",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1281,
        "homePostgameElo": null,
        "awayId": 2032,
        "awayTeam": "Arkansas State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1310,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858523,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3626,
        "venue": "Autzen Stadium",
        "homeId": 2483,
        "homeTeam": "Oregon",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1831,
        "homePostgameElo": null,
        "awayId": 130,
        "awayTeam": "Michigan",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1719,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856885,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3958,
        "venue": "Tiger Stadium (LA)",
        "homeId": 99,
        "homeTeam": "LSU",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1859,
        "homePostgameElo": null,
        "awayId": 251,
        "awayTeam": "Texas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1914,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401862825,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4418,
        "venue": "Jerry Richardson Stadium",
        "homeId": 2429,
        "homeTeam": "Charlotte",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 982,
        "homePostgameElo": null,
        "awayId": 151,
        "awayTeam": "East Carolina",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1466,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862829,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3806,
        "venue": "Lincoln Financial Field",
        "homeId": 218,
        "homeTeam": "Temple",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1342,
        "homePostgameElo": null,
        "awayId": 5,
        "awayTeam": "UAB",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1362,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871100,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6526,
        "venue": "Hancock Whitney Stadium",
        "homeId": 6,
        "homeTeam": "South Alabama",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1365,
        "homePostgameElo": null,
        "awayId": 2653,
        "awayTeam": "Troy",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1428,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862828,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3895,
        "venue": "Rice Stadium",
        "homeId": 242,
        "homeTeam": "Rice",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1174,
        "homePostgameElo": null,
        "awayId": 2655,
        "awayTeam": "Tulane",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1516,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871099,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3776,
        "venue": "Joe Aillet Stadium",
        "homeId": 2348,
        "homeTeam": "Louisiana Tech",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1382,
        "homePostgameElo": null,
        "awayId": 2572,
        "awayTeam": "Southern Miss",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1194,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858521,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3936,
        "venue": "Spartan Stadium",
        "homeId": 127,
        "homeTeam": "Michigan State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1452,
        "homePostgameElo": null,
        "awayId": 264,
        "awayTeam": "Washington",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1702,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862827,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3604,
        "venue": "Alamodome",
        "homeId": 2636,
        "homeTeam": "UTSA",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1521,
        "homePostgameElo": null,
        "awayId": 249,
        "awayTeam": "North Texas",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1669,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856862,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3616,
        "venue": "Amon G. Carter Stadium",
        "homeId": 2628,
        "homeTeam": "TCU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1600,
        "homePostgameElo": null,
        "awayId": 2306,
        "awayTeam": "Kansas State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1617,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858524,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3632,
        "venue": "Beaver Stadium",
        "homeId": 213,
        "homeTeam": "Penn State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1802,
        "homePostgameElo": null,
        "awayId": 135,
        "awayTeam": "Minnesota",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1427,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856888,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3795,
        "venue": "Kyle Field",
        "homeId": 245,
        "homeTeam": "Texas A&M",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1733,
        "homePostgameElo": null,
        "awayId": 2633,
        "awayTeam": "Tennessee",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1776,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401861967,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3892,
        "venue": "Pratt & Whitney Stadium",
        "homeId": 41,
        "homeTeam": "UConn",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1483,
        "homePostgameElo": null,
        "awayId": 256,
        "awayTeam": "James Madison",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1800,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870769,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3647,
        "venue": "Elliott T. Bowers Stadium",
        "homeId": 2534,
        "homeTeam": "Sam Houston",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1121,
        "homePostgameElo": null,
        "awayId": 338,
        "awayTeam": "Kennesaw State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1290,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871060,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3695,
        "venue": "Delaware Stadium",
        "homeId": 48,
        "homeTeam": "Delaware",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1328,
        "homePostgameElo": null,
        "awayId": 2229,
        "awayTeam": "Florida International",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1425,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870796,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3878,
        "venue": "Plaster Sports Complex",
        "homeId": 2623,
        "homeTeam": "Missouri State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1231,
        "homePostgameElo": null,
        "awayId": 166,
        "awayTeam": "New Mexico State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1249,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871061,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3992,
        "venue": "Williams Stadium (VA)",
        "homeId": 2335,
        "homeTeam": "Liberty",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1746,
        "homePostgameElo": null,
        "awayId": 2393,
        "awayTeam": "Middle Tennessee",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1146,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870752,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3796,
        "venue": "Houchens Industries-L.T. Smith Stadium",
        "homeId": 98,
        "homeTeam": "Western Kentucky",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1252,
        "homePostgameElo": null,
        "awayId": 55,
        "awayTeam": "Jacksonville State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1429,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858294,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3855,
        "venue": "Notre Dame Stadium",
        "homeId": 87,
        "homeTeam": "Notre Dame",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2097,
        "homePostgameElo": null,
        "awayId": 103,
        "awayTeam": "Boston College",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1381,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860916,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3644,
        "venue": "Bobcat Stadium (TX)",
        "homeId": 326,
        "homeTeam": "Texas State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1489,
        "homePostgameElo": null,
        "awayId": 278,
        "awayTeam": "Fresno State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1635,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860914,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-14T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3653,
        "venue": "Albertsons Stadium",
        "homeId": 68,
        "homeTeam": "Boise State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1691,
        "homePostgameElo": null,
        "awayId": 204,
        "awayTeam": "Oregon State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1581,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864538,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-15T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3713,
        "venue": "Falcon Stadium",
        "homeId": 2005,
        "homeTeam": "Air Force",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1464,
        "homePostgameElo": null,
        "awayId": 23,
        "awayTeam": "San José State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1386,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864539,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-15T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3971,
        "venue": "University Stadium (NM)",
        "homeId": 167,
        "homeTeam": "New Mexico",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1683,
        "homePostgameElo": null,
        "awayId": 2439,
        "awayTeam": "UNLV",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1509,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860915,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-15T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7311,
        "venue": "Snapdragon Stadium",
        "homeId": 21,
        "homeTeam": "San Diego State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1254,
        "homePostgameElo": null,
        "awayId": 328,
        "awayTeam": "Utah State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1362,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860917,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-15T03:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3820,
        "venue": "Gesa Field",
        "homeId": 265,
        "homeTeam": "Washington State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1476,
        "homePostgameElo": null,
        "awayId": 36,
        "awayTeam": "Colorado State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1233,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864537,
        "season": 2026,
        "week": 11,
        "seasonType": "regular",
        "startDate": "2026-11-15T04:59:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7220,
        "venue": "Clarence T.C. Ching Athletics Complex",
        "homeId": 62,
        "homeTeam": "Hawai'i",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1338,
        "homePostgameElo": null,
        "awayId": 2449,
        "awayTeam": "North Dakota State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1621,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866466,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-18T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3696,
        "venue": "Dix Stadium",
        "homeId": 2309,
        "homeTeam": "Kent State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1014,
        "homePostgameElo": null,
        "awayId": 193,
        "awayTeam": "Miami (OH)",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1248,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866465,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-18T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3980,
        "venue": "Waldo Stadium",
        "homeId": 2711,
        "homeTeam": "Western Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1493,
        "homePostgameElo": null,
        "awayId": 2199,
        "awayTeam": "Eastern Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1235,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866464,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-18T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3876,
        "venue": "Peden Stadium",
        "homeId": 195,
        "homeTeam": "Ohio",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1339,
        "homePostgameElo": null,
        "awayId": 2050,
        "awayTeam": "Ball State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1054,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866469,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-18T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3965,
        "venue": "UB Stadium",
        "homeId": 2084,
        "homeTeam": "Buffalo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1363,
        "homePostgameElo": null,
        "awayId": 2117,
        "awayTeam": "Central Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1216,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866467,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-18T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3985,
        "venue": "Warren McGuirk Alumni Stadium",
        "homeId": 113,
        "homeTeam": "Massachusetts",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1129,
        "homePostgameElo": null,
        "awayId": 2006,
        "awayTeam": "Akron",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 879,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862830,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-20T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3806,
        "venue": "Lincoln Financial Field",
        "homeId": 218,
        "homeTeam": "Temple",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1342,
        "homePostgameElo": null,
        "awayId": 242,
        "awayTeam": "Rice",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1174,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856869,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-20T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3652,
        "venue": "FBC Mortgage Stadium",
        "homeId": 2116,
        "homeTeam": "UCF",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1445,
        "homePostgameElo": null,
        "awayId": 66,
        "awayTeam": "Iowa State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1643,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858303,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3982,
        "venue": "Wallace Wade Stadium",
        "homeId": 150,
        "homeTeam": "Duke",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1653,
        "homePostgameElo": null,
        "awayId": 228,
        "awayTeam": "Clemson",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1541,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866468,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3739,
        "venue": "Glass Bowl",
        "homeId": 2649,
        "homeTeam": "Toledo",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1529,
        "homePostgameElo": null,
        "awayId": 189,
        "awayTeam": "Bowling Green",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1245,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864545,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3713,
        "venue": "Falcon Stadium",
        "homeId": 2005,
        "homeTeam": "Air Force",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1464,
        "homePostgameElo": null,
        "awayId": 2638,
        "awayTeam": "UTEP",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 986,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858529,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3936,
        "venue": "Spartan Stadium",
        "homeId": 127,
        "homeTeam": "Michigan State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1452,
        "homePostgameElo": null,
        "awayId": 2483,
        "awayTeam": "Oregon",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1831,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856753,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3994,
        "venue": "Williams-Brice Stadium",
        "homeId": 2579,
        "homeTeam": "South Carolina",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1699,
        "homePostgameElo": null,
        "awayId": 61,
        "awayTeam": "Georgia",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2053,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856872,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3616,
        "venue": "Amon G. Carter Stadium",
        "homeId": 2628,
        "homeTeam": "TCU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1600,
        "homePostgameElo": null,
        "awayId": 254,
        "awayTeam": "Utah",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1929,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858305,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3923,
        "venue": "Scott Stadium",
        "homeId": 258,
        "homeTeam": "Virginia",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1592,
        "homePostgameElo": null,
        "awayId": 153,
        "awayTeam": "North Carolina",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1449,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858306,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3873,
        "venue": "L&N Federal Credit Union Stadium",
        "homeId": 97,
        "homeTeam": "Louisville",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1729,
        "homePostgameElo": null,
        "awayId": 221,
        "awayTeam": "Pittsburgh",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1645,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858308,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3831,
        "venue": "California Memorial Stadium",
        "homeId": 25,
        "homeTeam": "California",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1347,
        "homePostgameElo": null,
        "awayId": 24,
        "awayTeam": "Stanford",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1151,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871101,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3815,
        "venue": "M. M. Roberts Stadium",
        "homeId": 2572,
        "homeTeam": "Southern Miss",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1194,
        "homePostgameElo": null,
        "awayId": 6,
        "awayTeam": "South Alabama",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1365,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856870,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3947,
        "venue": "Mountain America Stadium",
        "homeId": 9,
        "homeTeam": "Arizona State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1464,
        "homePostgameElo": null,
        "awayId": 197,
        "awayTeam": "Oklahoma State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1373,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869938,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3776,
        "venue": "Joe Aillet Stadium",
        "homeId": 2348,
        "homeTeam": "Louisiana Tech",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1382,
        "homePostgameElo": null,
        "awayId": 2032,
        "awayTeam": "Arkansas State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1310,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858527,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3832,
        "venue": "Memorial Stadium (Champaign, IL)",
        "homeId": 356,
        "homeTeam": "Illinois",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1536,
        "homePostgameElo": null,
        "awayId": 2294,
        "awayTeam": "Iowa",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1853,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856865,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3636,
        "venue": "Bill Snyder Family Stadium",
        "homeId": 2306,
        "homeTeam": "Kansas State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1617,
        "homePostgameElo": null,
        "awayId": 12,
        "awayTeam": "Arizona",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1719,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856866,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3833,
        "venue": "Memorial Stadium",
        "homeId": 2305,
        "homeTeam": "Kansas",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1614,
        "homePostgameElo": null,
        "awayId": 252,
        "awayTeam": "BYU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1725,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856867,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3854,
        "venue": "Nippert Stadium",
        "homeId": 2132,
        "homeTeam": "Cincinnati",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1469,
        "homePostgameElo": null,
        "awayId": 38,
        "awayTeam": "Colorado",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1325,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856868,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3842,
        "venue": "Milan Puskar Stadium",
        "homeId": 277,
        "homeTeam": "West Virginia",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1338,
        "homePostgameElo": null,
        "awayId": 248,
        "awayTeam": "Houston",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1612,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856871,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4727,
        "venue": "McLane Stadium",
        "homeId": 239,
        "homeTeam": "Baylor",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1643,
        "homePostgameElo": null,
        "awayId": 2641,
        "awayTeam": "Texas Tech",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1862,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862832,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3674,
        "venue": "Chapman Stadium",
        "homeId": 202,
        "homeTeam": "Tulsa",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1241,
        "homePostgameElo": null,
        "awayId": 2429,
        "awayTeam": "Charlotte",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 982,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858310,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 721,
        "venue": "Bobby Dodd Stadium",
        "homeId": 59,
        "homeTeam": "Georgia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1496,
        "homePostgameElo": null,
        "awayId": 154,
        "awayTeam": "Wake Forest",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1715,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858304,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3697,
        "venue": "Doak Campbell Stadium",
        "homeId": 52,
        "homeTeam": "Florida State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1598,
        "homePostgameElo": null,
        "awayId": 152,
        "awayTeam": "NC State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1471,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856751,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3838,
        "venue": "Memorial Stadium",
        "homeId": 142,
        "homeTeam": "Missouri",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1814,
        "homePostgameElo": null,
        "awayId": 96,
        "awayTeam": "Kentucky",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1568,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "NIGHT: 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401864541,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3816,
        "venue": "Mackay Stadium",
        "homeId": 2440,
        "homeTeam": "Nevada",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1433,
        "homePostgameElo": null,
        "awayId": 62,
        "awayTeam": "Hawai'i",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1338,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858528,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3558,
        "venue": "Michigan Stadium",
        "homeId": 130,
        "homeTeam": "Michigan",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1719,
        "homePostgameElo": null,
        "awayId": 26,
        "awayTeam": "UCLA",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1673,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856755,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3910,
        "venue": "DKR-Texas Memorial Stadium",
        "homeId": 251,
        "homeTeam": "Texas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1914,
        "homePostgameElo": null,
        "awayId": 8,
        "awayTeam": "Arkansas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1482,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "AFTERNOON: 3:30 - 4:30pm ET start",
        "playoff": null
    },
    {
        "id": 401856748,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3634,
        "venue": "Ben Hill Griffin Stadium",
        "homeId": 57,
        "homeTeam": "Florida",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1619,
        "homePostgameElo": null,
        "awayId": 238,
        "awayTeam": "Vanderbilt",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1610,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401862833,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3715,
        "venue": "FAU Stadium",
        "homeId": 2226,
        "homeTeam": "Florida Atlantic",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1300,
        "homePostgameElo": null,
        "awayId": 58,
        "awayTeam": "South Florida",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1606,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856754,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3853,
        "venue": "Neyland Stadium",
        "homeId": 2633,
        "homeTeam": "Tennessee",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1776,
        "homePostgameElo": null,
        "awayId": 99,
        "awayTeam": "LSU",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1859,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401856752,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3835,
        "venue": "Memorial Stadium (Norman, OK)",
        "homeId": 201,
        "homeTeam": "Oklahoma",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1747,
        "homePostgameElo": null,
        "awayId": 245,
        "awayTeam": "Texas A&M",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1733,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401858530,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3953,
        "venue": "Huntington Bank Stadium",
        "homeId": 135,
        "homeTeam": "Minnesota",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1427,
        "homePostgameElo": null,
        "awayId": 77,
        "awayTeam": "Northwestern",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1731,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858535,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3765,
        "venue": "Husky Stadium",
        "homeId": 264,
        "homeTeam": "Washington",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1702,
        "homePostgameElo": null,
        "awayId": 84,
        "awayTeam": "Indiana",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2098,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862835,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4729,
        "venue": "Yulman Stadium",
        "homeId": 2655,
        "homeTeam": "Tulane",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1516,
        "homePostgameElo": null,
        "awayId": 249,
        "awayTeam": "North Texas",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1669,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858533,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3907,
        "venue": "Ross-Ade Stadium",
        "homeId": 2509,
        "homeTeam": "Purdue",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1425,
        "homePostgameElo": null,
        "awayId": 275,
        "awayTeam": "Wisconsin",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1673,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858302,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3948,
        "venue": "Hard Rock Stadium",
        "homeId": 2390,
        "homeTeam": "Miami",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1993,
        "homePostgameElo": null,
        "awayId": 259,
        "awayTeam": "Virginia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1489,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858534,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 477,
        "venue": "Los Angeles Memorial Coliseum",
        "homeId": 30,
        "homeTeam": "USC",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1804,
        "homePostgameElo": null,
        "awayId": 120,
        "awayTeam": "Maryland",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1301,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869958,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3775,
        "venue": "Joan C. Edwards Stadium",
        "homeId": 276,
        "homeTeam": "Marshall",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1344,
        "homePostgameElo": null,
        "awayId": 2247,
        "awayTeam": "Georgia State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1402,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869946,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3666,
        "venue": "Cajun Field",
        "homeId": 309,
        "homeTeam": "Louisiana",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1439,
        "homePostgameElo": null,
        "awayId": 324,
        "awayTeam": "Coastal Carolina",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1281,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869953,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3975,
        "venue": "Veterans Memorial Stadium (AL)",
        "homeId": 2653,
        "homeTeam": "Troy",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1428,
        "homePostgameElo": null,
        "awayId": 290,
        "awayTeam": "Georgia Southern",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1370,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869929,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3792,
        "venue": "Kidd Brewer Stadium",
        "homeId": 2026,
        "homeTeam": "App State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1297,
        "homePostgameElo": null,
        "awayId": 2433,
        "awayTeam": "UL Monroe",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1014,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862836,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 7221,
        "venue": "Protective Stadium",
        "homeId": 5,
        "homeTeam": "UAB",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1362,
        "homePostgameElo": null,
        "awayId": 2636,
        "awayTeam": "UTSA",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1521,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858532,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3632,
        "venue": "Beaver Stadium",
        "homeId": 213,
        "homeTeam": "Penn State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1802,
        "homePostgameElo": null,
        "awayId": 164,
        "awayTeam": "Rutgers",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1383,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858531,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3834,
        "venue": "Memorial Stadium (Lincoln, NE)",
        "homeId": 158,
        "homeTeam": "Nebraska",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1767,
        "homePostgameElo": null,
        "awayId": 194,
        "awayTeam": "Ohio State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2060,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858309,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3615,
        "venue": "Alumni Stadium (Chestnut Hill, MA)",
        "homeId": 103,
        "homeTeam": "Boston College",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1381,
        "homePostgameElo": null,
        "awayId": 183,
        "awayTeam": "Syracuse",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1303,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862834,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3852,
        "venue": "Navy-Marine Corps Memorial Stadium",
        "homeId": 2426,
        "homeTeam": "Navy",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1495,
        "homePostgameElo": null,
        "awayId": 235,
        "awayTeam": "Memphis",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1665,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856749,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3974,
        "venue": "Vaught-Hemingway Stadium",
        "homeId": 145,
        "homeTeam": "Ole Miss",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1878,
        "homePostgameElo": 1878,
        "awayId": 2747,
        "awayTeam": "Wofford",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862831,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3841,
        "venue": "Michie Stadium",
        "homeId": 349,
        "homeTeam": "Army",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1523,
        "homePostgameElo": null,
        "awayId": 151,
        "awayTeam": "East Carolina",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1466,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856750,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3693,
        "venue": "Davis Wade Stadium",
        "homeId": 344,
        "homeTeam": "Mississippi State",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1593,
        "homePostgameElo": 1593,
        "awayId": 2635,
        "awayTeam": "Tennessee Tech",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871080,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3992,
        "venue": "Williams Stadium (VA)",
        "homeId": 2335,
        "homeTeam": "Liberty",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1746,
        "homePostgameElo": null,
        "awayId": 98,
        "awayTeam": "Western Kentucky",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1252,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856746,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3657,
        "venue": "Bryant-Denny Stadium",
        "homeId": 333,
        "homeTeam": "Alabama",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1987,
        "homePostgameElo": 1987,
        "awayId": 236,
        "awayTeam": "Chattanooga",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871081,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3647,
        "venue": "Elliott T. Bowers Stadium",
        "homeId": 2534,
        "homeTeam": "Sam Houston",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1121,
        "homePostgameElo": null,
        "awayId": 2393,
        "awayTeam": "Middle Tennessee",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1146,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871079,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3662,
        "venue": "AmFirst Stadium",
        "homeId": 55,
        "homeTeam": "Jacksonville State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1429,
        "homePostgameElo": null,
        "awayId": 2623,
        "awayTeam": "Missouri State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1231,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871077,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3601,
        "venue": "Aggie Memorial Stadium",
        "homeId": 166,
        "homeTeam": "New Mexico State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1249,
        "homePostgameElo": null,
        "awayId": 48,
        "awayTeam": "Delaware",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1328,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871078,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4899,
        "venue": "Fifth Third Stadium",
        "homeId": 338,
        "homeTeam": "Kennesaw State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1290,
        "homePostgameElo": null,
        "awayId": 2229,
        "awayTeam": "Florida International",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1425,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856747,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3785,
        "venue": "Jordan-Hare Stadium",
        "homeId": 2,
        "homeTeam": "Auburn",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1668,
        "homePostgameElo": 1668,
        "awayId": 2535,
        "awayTeam": "Samford",
        "awayClassification": "fcs",
        "awayConference": "Southern",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": null,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401861968,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3892,
        "venue": "Pratt & Whitney Stadium",
        "homeId": 41,
        "homeTeam": "UConn",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1483,
        "homePostgameElo": null,
        "awayId": 295,
        "awayTeam": "Old Dominion",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1220,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864543,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T21:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3714,
        "venue": "Fargodome",
        "homeId": 2449,
        "homeTeam": "North Dakota State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1621,
        "homePostgameElo": null,
        "awayId": 2459,
        "awayTeam": "Northern Illinois",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1167,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860920,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-21T23:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3644,
        "venue": "Bobcat Stadium (TX)",
        "homeId": 326,
        "homeTeam": "Texas State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1489,
        "homePostgameElo": null,
        "awayId": 265,
        "awayTeam": "Washington State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1476,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864544,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-22T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3935,
        "venue": "CEFCU Stadium",
        "homeId": 23,
        "homeTeam": "San José State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1386,
        "homePostgameElo": null,
        "awayId": 2439,
        "awayTeam": "UNLV",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1509,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860918,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-22T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3660,
        "venue": "Valley Children's Stadium",
        "homeId": 278,
        "homeTeam": "Fresno State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1635,
        "homePostgameElo": null,
        "awayId": 36,
        "awayTeam": "Colorado State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1233,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858307,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-22T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3855,
        "venue": "Notre Dame Stadium",
        "homeId": 87,
        "homeTeam": "Notre Dame",
        "homeClassification": "fbs",
        "homeConference": "FBS Independents",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2097,
        "homePostgameElo": null,
        "awayId": 2567,
        "awayTeam": "SMU",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1689,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864542,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-22T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3984,
        "venue": "War Memorial Stadium",
        "homeId": 2751,
        "homeTeam": "Wyoming",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1292,
        "homePostgameElo": null,
        "awayId": 167,
        "awayTeam": "New Mexico",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1683,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860925,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-22T02:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3653,
        "venue": "Albertsons Stadium",
        "homeId": 68,
        "homeTeam": "Boise State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1691,
        "homePostgameElo": null,
        "awayId": 21,
        "awayTeam": "San Diego State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1254,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401860919,
        "season": 2026,
        "week": 12,
        "seasonType": "regular",
        "startDate": "2026-11-22T03:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3893,
        "venue": "Reser Stadium",
        "homeId": 204,
        "homeTeam": "Oregon State",
        "homeClassification": "fbs",
        "homeConference": "Pac-12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1581,
        "homePostgameElo": null,
        "awayId": 328,
        "awayTeam": "Utah State",
        "awayClassification": "fbs",
        "awayConference": "Pac-12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1362,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866471,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-24T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3980,
        "venue": "Waldo Stadium",
        "homeId": 2711,
        "homeTeam": "Western Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1493,
        "homePostgameElo": null,
        "awayId": 193,
        "awayTeam": "Miami (OH)",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1248,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866470,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-25T00:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3912,
        "venue": "Rynearson Stadium",
        "homeId": 2199,
        "homeTeam": "Eastern Michigan",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1235,
        "homePostgameElo": null,
        "awayId": 2309,
        "awayTeam": "Kent State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1014,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856879,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T01:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3784,
        "venue": "Jones AT&T Stadium",
        "homeId": 2641,
        "homeTeam": "Texas Tech",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1862,
        "homePostgameElo": null,
        "awayId": 2628,
        "awayTeam": "TCU",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1600,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862837,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3699,
        "venue": "Dowdy-Ficklen Stadium",
        "homeId": 151,
        "homeTeam": "East Carolina",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1466,
        "homePostgameElo": null,
        "awayId": 2226,
        "awayTeam": "Florida Atlantic",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1300,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862839,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3886,
        "venue": "Raymond James Stadium",
        "homeId": 58,
        "homeTeam": "South Florida",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1606,
        "homePostgameElo": null,
        "awayId": 2655,
        "awayTeam": "Tulane",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1516,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "Will be played Nov. 27 or Nov. 28",
        "playoff": null
    },
    {
        "id": 401862838,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3805,
        "venue": "Simmons Bank Liberty Stadium",
        "homeId": 235,
        "homeTeam": "Memphis",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1665,
        "homePostgameElo": null,
        "awayId": 218,
        "awayTeam": "Temple",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1342,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856762,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3974,
        "venue": "Vaught-Hemingway Stadium",
        "homeId": 145,
        "homeTeam": "Ole Miss",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1868,
        "homePostgameElo": null,
        "awayId": 344,
        "awayTeam": "Mississippi State",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1612,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858536,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3793,
        "venue": "Kinnick Stadium",
        "homeId": 2294,
        "homeTeam": "Iowa",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1853,
        "homePostgameElo": null,
        "awayId": 158,
        "awayTeam": "Nebraska",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1767,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866472,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3768,
        "venue": "InfoCision Stadium",
        "homeId": 2006,
        "homeTeam": "Akron",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 879,
        "homePostgameElo": null,
        "awayId": 2084,
        "awayTeam": "Buffalo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1363,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866473,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3876,
        "venue": "Peden Stadium",
        "homeId": 195,
        "homeTeam": "Ohio",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1339,
        "homePostgameElo": null,
        "awayId": 2649,
        "awayTeam": "Toledo",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1529,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869930,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6526,
        "venue": "Hancock Whitney Stadium",
        "homeId": 6,
        "homeTeam": "South Alabama",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1365,
        "homePostgameElo": null,
        "awayId": 2026,
        "awayTeam": "App State",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1297,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864549,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3935,
        "venue": "CEFCU Stadium",
        "homeId": 23,
        "homeTeam": "San José State",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1386,
        "homePostgameElo": null,
        "awayId": 2449,
        "awayTeam": "North Dakota State",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1621,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856759,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-27T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3697,
        "venue": "Doak Campbell Stadium",
        "homeId": 52,
        "homeTeam": "Florida State",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1598,
        "homePostgameElo": null,
        "awayId": 57,
        "awayTeam": "Florida",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1619,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858544,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 347,
        "venue": "Camp Randall Stadium",
        "homeId": 275,
        "homeTeam": "Wisconsin",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1673,
        "homePostgameElo": null,
        "awayId": 135,
        "awayTeam": "Minnesota",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1427,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856756,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T00:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3795,
        "venue": "Kyle Field",
        "homeId": 245,
        "homeTeam": "Texas A&M",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1733,
        "homePostgameElo": null,
        "awayId": 251,
        "awayTeam": "Texas",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1914,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856880,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 587,
        "venue": "Rice-Eccles Stadium",
        "homeId": 254,
        "homeTeam": "Utah",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1929,
        "homePostgameElo": null,
        "awayId": 277,
        "awayTeam": "West Virginia",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1338,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856758,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3887,
        "venue": "Razorback Stadium",
        "homeId": 8,
        "homeTeam": "Arkansas",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1482,
        "homePostgameElo": null,
        "awayId": 99,
        "awayTeam": "LSU",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1859,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401856878,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3772,
        "venue": "Jack Trice Stadium",
        "homeId": 66,
        "homeTeam": "Iowa State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1643,
        "homePostgameElo": null,
        "awayId": 2306,
        "awayTeam": "Kansas State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1617,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856764,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3836,
        "venue": "Memorial Stadium (Clemson, SC)",
        "homeId": 228,
        "homeTeam": "Clemson",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1541,
        "homePostgameElo": null,
        "awayId": 2579,
        "awayTeam": "South Carolina",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1699,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858315,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3831,
        "venue": "California Memorial Stadium",
        "homeId": 25,
        "homeTeam": "California",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1347,
        "homePostgameElo": null,
        "awayId": 221,
        "awayTeam": "Pittsburgh",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1645,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856765,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3973,
        "venue": "FirstBank Stadium",
        "homeId": 238,
        "homeTeam": "Vanderbilt",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1610,
        "homePostgameElo": null,
        "awayId": 2633,
        "awayTeam": "Tennessee",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1776,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "NIGHT: 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401862841,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3895,
        "venue": "Rice Stadium",
        "homeId": 242,
        "homeTeam": "Rice",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1174,
        "homePostgameElo": null,
        "awayId": 349,
        "awayTeam": "Army",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1523,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869954,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3608,
        "venue": "Allen E. Paulson Stadium",
        "homeId": 290,
        "homeTeam": "Georgia Southern",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1370,
        "homePostgameElo": null,
        "awayId": 2348,
        "awayTeam": "Louisiana Tech",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1382,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871102,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3817,
        "venue": "Malone Stadium",
        "homeId": 2433,
        "homeTeam": "UL Monroe",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1014,
        "homePostgameElo": null,
        "awayId": 276,
        "awayTeam": "Marshall",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1344,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858537,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 11823,
        "venue": "Ryan Field",
        "homeId": 77,
        "homeTeam": "Northwestern",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1731,
        "homePostgameElo": null,
        "awayId": 356,
        "awayTeam": "Illinois",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1536,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862843,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3825,
        "venue": "DATCU Stadium",
        "homeId": 249,
        "homeTeam": "North Texas",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1669,
        "homePostgameElo": null,
        "awayId": 5,
        "awayTeam": "UAB",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1362,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856760,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3917,
        "venue": "Sanford Stadium",
        "homeId": 61,
        "homeTeam": "Georgia",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2053,
        "homePostgameElo": null,
        "awayId": 59,
        "awayTeam": "Georgia Tech",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1496,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401858542,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6577,
        "venue": "SHI Stadium",
        "homeId": 164,
        "homeTeam": "Rutgers",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1383,
        "homePostgameElo": null,
        "awayId": 127,
        "awayTeam": "Michigan State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1452,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858538,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3830,
        "venue": "Memorial Stadium (Bloomington, IN)",
        "homeId": 84,
        "homeTeam": "Indiana",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2098,
        "homePostgameElo": null,
        "awayId": 2509,
        "awayTeam": "Purdue",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1425,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858317,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3799,
        "venue": "Lane Stadium",
        "homeId": 259,
        "homeTeam": "Virginia Tech",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1489,
        "homePostgameElo": null,
        "awayId": 258,
        "awayTeam": "Virginia",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1592,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858316,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3940,
        "venue": "Stanford Stadium",
        "homeId": 24,
        "homeTeam": "Stanford",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1151,
        "homePostgameElo": null,
        "awayId": 2567,
        "awayTeam": "SMU",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1689,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856875,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3726,
        "venue": "Folsom Field",
        "homeId": 38,
        "homeTeam": "Colorado",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1325,
        "homePostgameElo": null,
        "awayId": 2116,
        "awayTeam": "UCF",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1445,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858541,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3626,
        "venue": "Autzen Stadium",
        "homeId": 2483,
        "homeTeam": "Oregon",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1831,
        "homePostgameElo": null,
        "awayId": 264,
        "awayTeam": "Washington",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1702,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856763,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3838,
        "venue": "Memorial Stadium",
        "homeId": 142,
        "homeTeam": "Missouri",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1814,
        "homePostgameElo": null,
        "awayId": 201,
        "awayTeam": "Oklahoma",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1747,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "AFTERNOON: 3:30 - 4:30pm ET start",
        "playoff": null
    },
    {
        "id": 401856761,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3683,
        "venue": "Kroger Field",
        "homeId": 96,
        "homeTeam": "Kentucky",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1568,
        "homePostgameElo": null,
        "awayId": 97,
        "awayTeam": "Louisville",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1729,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "EARLY: Noon - 1pm ET start",
        "playoff": null
    },
    {
        "id": 401856874,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4728,
        "venue": "TDECU Stadium",
        "homeId": 248,
        "homeTeam": "Houston",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1612,
        "homePostgameElo": null,
        "awayId": 239,
        "awayTeam": "Baylor",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1643,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858311,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3948,
        "venue": "Hard Rock Stadium",
        "homeId": 2390,
        "homeTeam": "Miami",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1993,
        "homePostgameElo": null,
        "awayId": 103,
        "awayTeam": "Boston College",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1381,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858312,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3630,
        "venue": "Allegacy Federal Credit Union Stadium",
        "homeId": 154,
        "homeTeam": "Wake Forest",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1715,
        "homePostgameElo": null,
        "awayId": 150,
        "awayTeam": "Duke",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1653,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858313,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3787,
        "venue": "Kenan Stadium",
        "homeId": 153,
        "homeTeam": "North Carolina",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1449,
        "homePostgameElo": null,
        "awayId": 152,
        "awayTeam": "NC State",
        "awayClassification": "fbs",
        "awayConference": "ACC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1471,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858543,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 1056,
        "venue": "Rose Bowl",
        "homeId": 26,
        "homeTeam": "UCLA",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1673,
        "homePostgameElo": null,
        "awayId": 30,
        "awayTeam": "USC",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1804,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869947,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3651,
        "venue": "Bridgeforth Stadium",
        "homeId": 256,
        "homeTeam": "James Madison",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1800,
        "homePostgameElo": null,
        "awayId": 324,
        "awayTeam": "Coastal Carolina",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1281,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864550,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3764,
        "venue": "Huskie Stadium",
        "homeId": 2459,
        "homeTeam": "Northern Illinois",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1167,
        "homePostgameElo": null,
        "awayId": 2638,
        "awayTeam": "UTEP",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 986,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871103,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3918,
        "venue": "S.B. Ballard Stadium",
        "homeId": 295,
        "homeTeam": "Old Dominion",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1220,
        "homePostgameElo": null,
        "awayId": 2572,
        "awayTeam": "Southern Miss",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1194,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856877,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3646,
        "venue": "Boone Pickens Stadium",
        "homeId": 197,
        "homeTeam": "Oklahoma State",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1373,
        "homePostgameElo": null,
        "awayId": 2305,
        "awayTeam": "Kansas",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1614,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856873,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3619,
        "venue": "Arizona Stadium",
        "homeId": 12,
        "homeTeam": "Arizona",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1719,
        "homePostgameElo": null,
        "awayId": 9,
        "awayTeam": "Arizona State",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1464,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856876,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3801,
        "venue": "LaVell Edwards Stadium",
        "homeId": 252,
        "homeTeam": "BYU",
        "homeClassification": "fbs",
        "homeConference": "Big 12",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1725,
        "homePostgameElo": null,
        "awayId": 2132,
        "awayTeam": "Cincinnati",
        "awayClassification": "fbs",
        "awayConference": "Big 12",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1469,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869959,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4246,
        "venue": "Center Parc Stadium",
        "homeId": 2247,
        "homeTeam": "Georgia State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1402,
        "homePostgameElo": null,
        "awayId": 309,
        "awayTeam": "Louisiana",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1439,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401856757,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3657,
        "venue": "Bryant-Denny Stadium",
        "homeId": 333,
        "homeTeam": "Alabama",
        "homeClassification": "fbs",
        "homeConference": "SEC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1990,
        "homePostgameElo": null,
        "awayId": 2,
        "awayTeam": "Auburn",
        "awayClassification": "fbs",
        "awayConference": "SEC",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1669,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "FLEX: 3:30 - 4:30pm OR 6 - 8pm ET start",
        "playoff": null
    },
    {
        "id": 401862842,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 4418,
        "venue": "Jerry Richardson Stadium",
        "homeId": 2429,
        "homeTeam": "Charlotte",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 982,
        "homePostgameElo": null,
        "awayId": 2426,
        "awayTeam": "Navy",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1495,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858314,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 1964,
        "venue": "JMA Wireless Dome",
        "homeId": 183,
        "homeTeam": "Syracuse",
        "homeClassification": "fbs",
        "homeConference": "ACC",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1303,
        "homePostgameElo": null,
        "awayId": 87,
        "awayTeam": "Notre Dame",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 2097,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401861969,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 3984,
        "venue": "War Memorial Stadium",
        "homeId": 2751,
        "homeTeam": "Wyoming",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1292,
        "homePostgameElo": null,
        "awayId": 41,
        "awayTeam": "UConn",
        "awayClassification": "fbs",
        "awayConference": "FBS Independents",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1483,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858539,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3665,
        "venue": "SECU Stadium",
        "homeId": 120,
        "homeTeam": "Maryland",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1301,
        "homePostgameElo": null,
        "awayId": 213,
        "awayTeam": "Penn State",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1802,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862840,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T05:00:00.000Z",
        "startTimeTBD": true,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3604,
        "venue": "Alamodome",
        "homeId": 2636,
        "homeTeam": "UTSA",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1521,
        "homePostgameElo": null,
        "awayId": 202,
        "awayTeam": "Tulsa",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1241,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": "Will be played Nov. 27 or Nov. 28",
        "playoff": null
    },
    {
        "id": 401866474,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3919,
        "venue": "Scheumann Stadium",
        "homeId": 2050,
        "homeTeam": "Ball State",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1054,
        "homePostgameElo": null,
        "awayId": 2117,
        "awayTeam": "Central Michigan",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1216,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401858540,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3861,
        "venue": "Ohio Stadium",
        "homeId": 194,
        "homeTeam": "Ohio State",
        "homeClassification": "fbs",
        "homeConference": "Big Ten",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 2060,
        "homePostgameElo": null,
        "awayId": 130,
        "awayTeam": "Michigan",
        "awayClassification": "fbs",
        "awayConference": "Big Ten",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1719,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401866475,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T17:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3700,
        "venue": "Doyt L. Perry Stadium",
        "homeId": 189,
        "homeTeam": "Bowling Green",
        "homeClassification": "fbs",
        "homeConference": "Mid-American",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1245,
        "homePostgameElo": null,
        "awayId": 113,
        "awayTeam": "Massachusetts",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1129,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401870804,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T18:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3796,
        "venue": "Houchens Industries-L.T. Smith Stadium",
        "homeId": 98,
        "homeTeam": "Western Kentucky",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1252,
        "homePostgameElo": null,
        "awayId": 338,
        "awayTeam": "Kennesaw State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1290,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871083,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3725,
        "venue": "Johnny \"Red\" Floyd Stadium",
        "homeId": 2393,
        "homeTeam": "Middle Tennessee",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1146,
        "homePostgameElo": null,
        "awayId": 166,
        "awayTeam": "New Mexico State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1249,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871082,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 2031,
        "venue": "Pitbull Stadium",
        "homeId": 2229,
        "homeTeam": "Florida International",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1425,
        "homePostgameElo": null,
        "awayId": 2534,
        "awayTeam": "Sam Houston",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1121,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871063,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T19:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3878,
        "venue": "Plaster Sports Complex",
        "homeId": 2623,
        "homeTeam": "Missouri State",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1231,
        "homePostgameElo": null,
        "awayId": 2335,
        "awayTeam": "Liberty",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1746,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401869939,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3625,
        "venue": "Centennial Bank Stadium",
        "homeId": 2032,
        "homeTeam": "Arkansas State",
        "homeClassification": "fbs",
        "homeConference": "Sun Belt",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1310,
        "homePostgameElo": null,
        "awayId": 2653,
        "awayTeam": "Troy",
        "awayClassification": "fbs",
        "awayConference": "Sun Belt",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1428,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401871062,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T20:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3695,
        "venue": "Delaware Stadium",
        "homeId": 48,
        "homeTeam": "Delaware",
        "homeClassification": "fbs",
        "homeConference": "Conference USA",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1328,
        "homePostgameElo": null,
        "awayId": 55,
        "awayTeam": "Jacksonville State",
        "awayClassification": "fbs",
        "awayConference": "Conference USA",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1429,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864546,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-28T21:30:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3971,
        "venue": "University Stadium (NM)",
        "homeId": 167,
        "homeTeam": "New Mexico",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1683,
        "homePostgameElo": null,
        "awayId": 2005,
        "awayTeam": "Air Force",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1464,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864548,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-29T02:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 6501,
        "venue": "Allegiant Stadium",
        "homeId": 2439,
        "homeTeam": "UNLV",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1509,
        "homePostgameElo": null,
        "awayId": 2440,
        "awayTeam": "Nevada",
        "awayClassification": "fbs",
        "awayConference": "Mountain West",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1433,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401864547,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "startDate": "2026-11-29T04:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": false,
        "conferenceGame": false,
        "attendance": null,
        "venueId": 7220,
        "venue": "Clarence T.C. Ching Athletics Complex",
        "homeId": 62,
        "homeTeam": "Hawai'i",
        "homeClassification": "fbs",
        "homeConference": "Mountain West",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1338,
        "homePostgameElo": null,
        "awayId": 16,
        "awayTeam": "Sacramento State",
        "awayClassification": "fbs",
        "awayConference": "Mid-American",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1110,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    },
    {
        "id": 401862844,
        "season": 2026,
        "week": 15,
        "seasonType": "regular",
        "startDate": "2026-12-12T20:00:00.000Z",
        "startTimeTBD": false,
        "completed": false,
        "neutralSite": true,
        "conferenceGame": true,
        "attendance": null,
        "venueId": 3839,
        "venue": "MetLife Stadium",
        "homeId": 349,
        "homeTeam": "Army",
        "homeClassification": "fbs",
        "homeConference": "American Athletic",
        "homePoints": null,
        "homeLineScores": null,
        "homePostgameWinProbability": null,
        "homePregameElo": 1523,
        "homePostgameElo": null,
        "awayId": 2426,
        "awayTeam": "Navy",
        "awayClassification": "fbs",
        "awayConference": "American Athletic",
        "awayPoints": null,
        "awayLineScores": null,
        "awayPostgameWinProbability": null,
        "awayPregameElo": 1495,
        "awayPostgameElo": null,
        "excitementIndex": null,
        "highlights": "",
        "notes": null,
        "playoff": null
    }
,
  {
        "id": 10001,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "completed": false,
        "conferenceGame": false,
        "homeTeam": "Boise State",
        "homePoints": null,
        "awayTeam": "Utah State",
        "awayPoints": null,
        "awayLineScores": null,
        "notes": "pac12flex",
        neutralSite: "true"
    },
    {
        "id": 10003,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "completed": false,
        "conferenceGame": false,
        "homeTeam": "Washington State",
        "homePoints": null,
        "awayTeam": "Oregon State",
        "awayPoints": null,
        "awayLineScores": null,
        "notes": "pac12flex",
        neutralSite: "true"
    },
    {
        "id": 10004,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "completed": false,
        "conferenceGame": false,
        "homeTeam": "San Diego State",
        "homePoints": null,
        "awayTeam": "Fresno State",
        "awayPoints": null,
        "awayLineScores": null,
        "notes": "pac12flex",
        neutralSite: "true"
    },
    {
        "id": 10005,
        "season": 2026,
        "week": 13,
        "seasonType": "regular",
        "completed": false,
        "conferenceGame": false,
        "homeTeam": "Texas State",
        "homePoints": null,
        "awayTeam": "Colorado State",
        "awayPoints": null,
        "awayLineScores": null,
        "notes": "pac12flex",
        neutralSite: "true"
    }
]